export const EntityData = [
  {
    id: 132,
    name: "Jaypee Nigrie Super Thermal Power Plant",
  },
  {
    id: 134,
    name: "RAIPUR ENERGEN LIMITED",
  },
  {
    id: 139,
    name: "LAXMIPATI BALAJI SUPPLY CHAIN MANAGEMENT LIMITED",
  },
  {
    id: 140,
    name: "GMR Warora Energy Limited",
  },
  {
    id: 141,
    name: "DHARIWAL INFRASTRUCTURE LIMITED, CTU",
  },
  {
    id: 144,
    name: "HeidelbergCement India Limited-MP",
  },
  {
    id: 148,
    name: "NAVA BHARAT VENTURES LIMITED (Odisha CPP)",
  },
  {
    id: 149,
    name: "HEG LIMITED Tawa Hydro Electric Power Plant",
  },
  {
    id: 153,
    name: "ArcelorMittal Nippon Steel India Limited",
  },
  {
    id: 154,
    name: "EON KHARADI INFRASTRUCTURE PRIVATE LIMITED, Phase -2",
  },
  {
    id: 155,
    name: "WEST CENTRAL RAILWAY",
  },
  {
    id: 156,
    name: "Tata Steel Limited Ferro Alloys Plant Joda",
  },
  {
    id: 157,
    name: "RAIGARH ENERGY GENERATION LIMITED",
  },
  {
    id: 159,
    name: "HARSH NIRMAN INFRAWORLD LLP",
  },
  {
    id: 160,
    name: "JINDAL STAINLESS LIMITED",
  },
  {
    id: 161,
    name: "KSK MAHANADI POWER COMPANY LIMITED",
  },
  {
    id: 162,
    name: "Jhabua Power Limited",
  },
  {
    id: 163,
    name: "EON KHARADI INFRASTRUCTURE PRIVATE LIMITED, Phase -1",
  },
  {
    id: 164,
    name: "EASTMAN INTERNATIONAL, 15MW",
  },
  {
    id: 167,
    name: "SHREE CEMENT LIMITED TPS",
  },
  {
    id: 169,
    name: "Tata Power Delhi Distribution Limited",
  },
  {
    id: 170,
    name: "BSES Rajdhani Power Limited",
  },
  {
    id: 172,
    name: "Shree Cement Limited SURATGARH",
  },
  {
    id: 173,
    name: "DELHI INTERNATIONAL AIRPORT LIMITED",
  },
  {
    id: 174,
    name: "RAJASTHAN URJA VIKAS NIGAM LIMITED",
  },
  {
    id: 176,
    name: "KASHI VISHWANATH STEELS PRIVATE LIMITED",
  },
  {
    id: 177,
    name: "AARTI STEELS LTD",
  },
  {
    id: 179,
    name: "ITC Limited Dairy Plant",
  },
  {
    id: 182,
    name: "ITC LIMITED DEVANAHALLI",
  },
  {
    id: 183,
    name: "Hindustan Zinc Limited Debari",
  },
  {
    id: 184,
    name: "Singoli Bhatwari HEP",
  },
  {
    id: 185,
    name: "AIA Engineering Limited -Unit 12",
  },
  {
    id: 186,
    name: "TPL-Ahmedabad Discom",
  },
  {
    id: 189,
    name: "Philips carbon black limited",
  },
  {
    id: 191,
    name: "IL&FS TAMIL NADU POWER COMPANY LIMITED",
  },
  {
    id: 192,
    name: "COASTAL ENERGEN PRIVATE LIMITED",
  },
  {
    id: 195,
    name: "Department of Power Government of Nagaland",
  },
  {
    id: 196,
    name: "MPSEZ Utilities Limited",
  },
  {
    id: 198,
    name: "GOODWILL ENERGY ENTERPRISES",
  },
  {
    id: 199,
    name: "CAVENDISH INDUSTRIES LIMITED",
  },
  {
    id: 200,
    name: "BHILANGANA HYDRO POWER LIMITED",
  },
  {
    id: 202,
    name: "UP Grinding Unit (A Unit of Shree Cement Limited)",
  },
  {
    id: 203,
    name: "Shree Grinding Unit (Laksar)",
  },
  {
    id: 204,
    name: "SHREE CEMENT LIMITED CPP",
  },
  {
    id: 205,
    name: "Torrent Power Limited - Dahej",
  },
  {
    id: 206,
    name: "Atul Ltd",
  },
  {
    id: 207,
    name: "KANCHANJUNGA POWER COMPANY PVT. LTD.",
  },
  {
    id: 208,
    name: "BSES Yamuna Power Limited",
  },
  {
    id: 209,
    name: "Shree Cement Limited  (KHUSHKHERA)",
  },
  {
    id: 210,
    name: "AIA Engineering Limited",
  },
  {
    id: 211,
    name: "INDIA GLYCOLS LTD",
  },
  {
    id: 212,
    name: "AGRAWAL SOLAR POWER VENTURES(RAJASTHAN) PRIVATE LIMITED-RRECL REGISTRATION NO. S/1100/2014",
  },
  {
    id: 213,
    name: "GOLD PLUS GLASS INDUSTRY LIMITED",
  },
  {
    id: 214,
    name: "Philips Carbon Black Ltd, Palej",
  },
  {
    id: 215,
    name: "GIGAPLEX ESTATE PRIVATE LIMITED",
  },
  {
    id: 216,
    name: "ESTER INDUSTRIES LIMITED",
  },
  {
    id: 217,
    name: "TATA STEEL LIMITED",
  },
  {
    id: 218,
    name: "New Bihar Cement Plant (A Unit of Shree Cement Limited)",
  },
  {
    id: 219,
    name: "TPL-Surat Discom",
  },
  {
    id: 220,
    name: "THE TATA POWER CO LTD",
  },
  {
    id: 221,
    name: "GUJARAT URJA VIKAS NIGAM LIMITED",
  },
  {
    id: 222,
    name: "ACC LIMITED Bargarh Cement Works",
  },
  {
    id: 223,
    name: "BHUBANESHWAR POWER PRIVATE LIMITED.",
  },
  {
    id: 224,
    name: "AIA Engineering Limited Cons.No. 29885",
  },
  {
    id: 225,
    name: "Bihar Cement Plant (A Unit of Shree Cement Ltd)",
  },
  {
    id: 226,
    name: "IA Hydro Energy Private Limited",
  },
  {
    id: 227,
    name: "TRN ENERGY PRIVATE LIMITED",
  },
  {
    id: 228,
    name: "COROMANDEL SUGARS LIMITED",
  },
  {
    id: 229,
    name: "Birla Textile mills Baddi",
  },
  {
    id: 231,
    name: "HILLS CEMENT COMPANY LIMITED",
  },
  {
    id: 232,
    name: "PATSPIN INDIA LIMITED",
  },
  {
    id: 234,
    name: "CALCOM CEMENT INDIA LIMITED,UMRANGSO",
  },
  {
    id: 235,
    name: "Meghalaya Power Limited",
  },
  {
    id: 236,
    name: "GREEN VALLIEY INDUSTRIES LIMITED",
  },
  {
    id: 237,
    name: "BHARAT ALUMINIUM COMPANY LTD",
  },
  {
    id: 238,
    name: "LANCO AMARKANTAK POWER LIMITED",
  },
  {
    id: 239,
    name: "NITTA GELATIN INDIA LIMITED KAKKANAD",
  },
  {
    id: 240,
    name: "New Delhi Municipal Council",
  },
  {
    id: 241,
    name: "HeidelbergCement India Limited-Karnataka",
  },
  {
    id: 242,
    name: "ADANI SOLAR ENERGY JODHPUR TWO LIMITED",
  },
  {
    id: 243,
    name: "Janki corp Limited",
  },
  {
    id: 244,
    name: "TATA STEEL LONG PRODUCTS LIMITED",
  },
  {
    id: 245,
    name: "KRC INFRASTRUCTURE AND PROJECTS PRIVATE LIMITED",
  },
  {
    id: 246,
    name: "AIA Engineering Ltd Unit No 13",
  },
  {
    id: 247,
    name: "ARVIND LIMITED",
  },
  {
    id: 248,
    name: "DHARIWAL INFRASTRUCTURE LIMITED, STU",
  },
  {
    id: 249,
    name: "BANK NOTE PAPER MILL INDIA PRIVATE LIMITED",
  },
  {
    id: 250,
    name: "Malabar Cements Limited",
  },
  {
    id: 251,
    name: "ATHANI SUGARS LIMITED",
  },
  {
    id: 252,
    name: "Dalmia Cement (Bharat) Limited, Rajgangpur, Odisha",
  },
  {
    id: 253,
    name: "Power Company of Karnataka Ltd",
  },
  {
    id: 254,
    name: "DHRUVDESH METASTEEL PVT LTD",
  },
  {
    id: 256,
    name: "SREE JAYAJOTHI CEMENTS PRIVATE LIMITED",
  },
  {
    id: 257,
    name: "Suven Pharmaceuticals Limited",
  },
  {
    id: 258,
    name: "THE RAMCO CEMENTS LIMITED- THESLDCD04",
  },
  {
    id: 259,
    name: "Tata Steel Limited-KHOPOLI ( Vill.- Niphan)",
  },
  {
    id: 260,
    name: "STT GLOBAL DATA CENTRES INDIA PRIVATE LIMITED",
  },
  {
    id: 261,
    name: "Northern Railway UP",
  },
  {
    id: 262,
    name: "Galwalia Ispat Udyog Private Limited",
  },
  {
    id: 263,
    name: "MEGHALAYA POWER DISTRIBUTION CORPORATION LIMITED",
  },
  {
    id: 264,
    name: "UDUPI POWER CORPORATION LIMITED",
  },
  {
    id: 266,
    name: "CESC LIMITED",
  },
  {
    id: 267,
    name: "THE KERALA MINERALS AND METALS LIMITED",
  },
  {
    id: 269,
    name: "MANIPUR STATE POWER DISTRIBUTION COMPANY LIMITED",
  },
  {
    id: 270,
    name: "K D IRON AND STEEL CO",
  },
  {
    id: 272,
    name: "Electricity Department, GOA_WR",
  },
  {
    id: 273,
    name: "Varrsana Ispat Ltd. Varsana",
  },
  {
    id: 274,
    name: "V S LIGNITE POWER PRIVATE LIMITED",
  },
  {
    id: 275,
    name: "Jindal Steel & Power Limited Barbil Odisha",
  },
  {
    id: 276,
    name: "MES DELHI CANTT",
  },
  {
    id: 277,
    name: "Star cement Limited",
  },
  {
    id: 279,
    name: "S M S SMELTERS LTD",
  },
  {
    id: 280,
    name: "Shreeyam Power And Steel Industries Limited, Mithirohar",
  },
  {
    id: 281,
    name: "AMRIT CEMENT LTD",
  },
  {
    id: 282,
    name: "THE FERTILISERS AND CHEMICALS TRAVANCORE LIMITED",
  },
  {
    id: 283,
    name: "THE ANDHRA SUGARS LIMITED",
  },
  {
    id: 284,
    name: "SARDA METALS & ALLOYS LIMITED",
  },
  {
    id: 285,
    name: "EASTMAN INTERNATIONAL, 7MW",
  },
  {
    id: 286,
    name: "G I POWER CORPORATION LTD.",
  },
  {
    id: 287,
    name: "R.K.M POWERGEN PRIVATE LIMITED",
  },
  {
    id: 288,
    name: "RAMESH STEELS",
  },
  {
    id: 289,
    name: "MY HOME INDUSTRIES PRIVATE LIMITED YELAMANCHILI",
  },
  {
    id: 290,
    name: "B R METALLICS",
  },
  {
    id: 291,
    name: "Purbanchal Cement Limited",
  },
  {
    id: 292,
    name: "THE INDIAN HOTELS COMPANY LTD, DWARKA, NEW DELHI",
  },
  {
    id: 293,
    name: "MYLAN LABORATORIES LIMITED CHODAVARAM",
  },
  {
    id: 294,
    name: "GTN TEXTILES LIMITED",
  },
  {
    id: 295,
    name: "SREE AKKAMAMBA TEXTILES LIMITED",
  },
  {
    id: 296,
    name: "ADANI POWER RAJASTHAN LIMITED",
  },
  {
    id: 297,
    name: "NU VISTA LIMITED",
  },
  {
    id: 298,
    name: "RASHMI SPONGE IRON AND POWER INDUSTRIES PRIVATE LIMITED",
  },
  {
    id: 299,
    name: "SHREE NAKODA ISPAT LIMITED",
  },
  {
    id: 300,
    name: "MAHENDRA SPONGE AND POWER LIMITED",
  },
  {
    id: 301,
    name: "EROS GRAND RESORTS AND HOTELS PRIVATE LIMITED",
  },
  {
    id: 302,
    name: "GIFT Power Company Limited",
  },
  {
    id: 303,
    name: "Vedanta Ltd. - CPP, (9 X 135MW), Jharsuguda",
  },
  {
    id: 305,
    name: "AURORE PHARMACEUTICALS PRIVATE LIMITED",
  },
  {
    id: 306,
    name: "TRIMULA INDUSTRIES LIMITED",
  },
  {
    id: 307,
    name: "MSEDCL DHARNI",
  },
  {
    id: 308,
    name: "Jaypee Rewa Plant",
  },
  {
    id: 309,
    name: "PARADEEP PHOSPHATES LTD",
  },
  {
    id: 310,
    name: "NIRMA LIMITED SAVLI",
  },
  {
    id: 311,
    name: "NIRMA LIMITED-KALATALAV",
  },
  {
    id: 312,
    name: "LOKMANGAL AGRO INDUSTRIES LIMITED",
  },
  {
    id: 313,
    name: "BHILAI JAYPEE CEMENT LIMITED",
  },
  {
    id: 314,
    name: "Vedanta Limited SEZ UNIT, Jharsuguda",
  },
  {
    id: 315,
    name: "IND SYNERGY LIMITED",
  },
  {
    id: 316,
    name: "Rimjhim Ispat Limited",
  },
  {
    id: 317,
    name: "Rimjhim Stainless Limited",
  },
  {
    id: 318,
    name: "Tata Steel Limited, Meramandali",
  },
  {
    id: 319,
    name: "J K CEMENT WORKS ALIGARH",
  },
  {
    id: 320,
    name: "MINDSPACE BUSINESS PARKS PRIVATE LIMITED",
  },
  {
    id: 321,
    name: "SIMCON SOLAR",
  },
  {
    id: 323,
    name: "Haryana Power Purchase Centre",
  },
  {
    id: 324,
    name: "CENTRAL PARK INFRASTRUCTURE DEVLOPMENT PRIVATE LIMITED",
  },
  {
    id: 325,
    name: "Freewings Power & Infra Limited",
  },
  {
    id: 326,
    name: "LANCO ANPARA POWER LIMITED",
  },
  {
    id: 327,
    name: "Novel Sugar Limited",
  },
  {
    id: 328,
    name: "Inox Air Products Pvt Limited",
  },
  {
    id: 329,
    name: "SAI WARDHA POWER GENERATION PRIVATE LIMITED",
  },
  {
    id: 330,
    name: "BEST Undertaking",
  },
  {
    id: 331,
    name: "Maharashtra State Electricity Distribution Co Limited",
  },
  {
    id: 332,
    name: "SMC POWER GENERATION LTD",
  },
  {
    id: 333,
    name: "STEEL AUTHORITY OF INDIA LTD",
  },
  {
    id: 334,
    name: "KESORAM CEMENT",
  },
  {
    id: 335,
    name: "PENNA CEMENT INDUSTRIES LIMITED",
  },
  {
    id: 336,
    name: "AMBATTUR INFRA DEVELOPERS",
  },
  {
    id: 337,
    name: "MY HOME INDUSTRIES PRIVATE LIMITED CPP MELLACHERUVU",
  },
  {
    id: 338,
    name: "Ambashakti Industries Limited",
  },
  {
    id: 339,
    name: "ARIA HOTELS AND CONSULTANCY SERVICES PRIVATE LIMITED (JW MARRIOT, AEROCITY)",
  },
  {
    id: 340,
    name: "AGRAWAL SOLAR POWER VENTURES(RAJASTHAN) PRIVATE LIMITED-RRECL REGISTRATION NO. S/1124/2014",
  },
  {
    id: 341,
    name: "Jaincord Industries Private Limited",
  },
  {
    id: 342,
    name: "PARTH THREAD PRIVATE LIMITED",
  },
  {
    id: 343,
    name: "Timarpur Okhla Waste Management Company Limited",
  },
  {
    id: 344,
    name: "JUBILANT INGREVIA LTD",
  },
  {
    id: 345,
    name: "SUPRIYA SPINNING MILLS PRIVATE LIMITED",
  },
  {
    id: 346,
    name: "PRASUNA VAMSI KRISHNA SPINNING MILLS PRIVATE LIMITED",
  },
  {
    id: 347,
    name: "India Pesticides Limited",
  },
  {
    id: 348,
    name: "Northern Railway Delhi",
  },
  {
    id: 349,
    name: "HIMACHAL PRADESH STATE ELECTRICITY BOARD LIMITED",
  },
  {
    id: 350,
    name: "DIAMOND CEMENT (PROP HEIDELBERGCEMENT INDIA LIMITED)",
  },
  {
    id: 351,
    name: "AGRAWAL SOLAR POWER VENTURES(RAJASTHAN) PRIVATE LIMITED-RRECL REGISTRATION NO. S/832/2011",
  },
  {
    id: 352,
    name: "Bansal High Carbons Private Limited",
  },
  {
    id: 353,
    name: "SHREE RENUKA SUGARS LTD",
  },
  {
    id: 354,
    name: "Petronet LNG Limited",
  },
  {
    id: 355,
    name: "LAURUS LABS LIMITED  VSP 554",
  },
  {
    id: 356,
    name: "KIRLOSKAR FERROUS INDUSTRIES LTD",
  },
  {
    id: 357,
    name: "DALMIA LAMINATORS LTD",
  },
  {
    id: 358,
    name: "Bharathi Cement Corporation Private limited",
  },
  {
    id: 359,
    name: "NSL TEXTILES LIMITED PULIVENDULA",
  },
  {
    id: 360,
    name: "MYLAN LABORATORIES LIMITED PASHAMAILARAM",
  },
  {
    id: 361,
    name: "THE TRAVANCORE COCHIN CHEMICALS LIMITED",
  },
  {
    id: 362,
    name: "SHREE CEMENT LIMITED -KODLA",
  },
  {
    id: 363,
    name: "Juhi Alloys Limited",
  },
  {
    id: 364,
    name: "SLS POWER CORPORATION LTD",
  },
  {
    id: 365,
    name: "SIVA SWATI TEXTILE PRIVATE LIMITED",
  },
  {
    id: 366,
    name: "SHRI TIRUPATI STEEL CAST LIMITED",
  },
  {
    id: 367,
    name: "Balaji Wires Private Limited",
  },
  {
    id: 368,
    name: "ORIENT CEMENT LIMITED",
  },
  {
    id: 369,
    name: "CARBORUNDUM UNIVERSAL LIMITED KORATTY",
  },
  {
    id: 370,
    name: "ESSAR VIZAG TERMINALS LIMITED",
  },
  {
    id: 371,
    name: "A ONE ISPAT PRIVATE LIMITED",
  },
  {
    id: 372,
    name: "SRI LAKSHMI NARASIMHA SPINNING MILLS India PVT LTD",
  },
  {
    id: 373,
    name: "DR REDDYS LABORATORIES LIMITED- DRRSLDCD63",
  },
  {
    id: 374,
    name: "GROWELFEEDS PRIVATE LIMITED",
  },
  {
    id: 375,
    name: "NAVA BHARAT ENERGY INDIA LIMITED",
  },
  {
    id: 376,
    name: "MRF LIMITED SADASIVPET",
  },
  {
    id: 377,
    name: "THE INDIA CEMENTS LIMITED TANDUR",
  },
  {
    id: 378,
    name: "STEEL EXCHANGE INDIA LIMITED VIZIANAGARAM",
  },
  {
    id: 379,
    name: "Bansal Wire Industries Limited B-3",
  },
  {
    id: 380,
    name: "SUNDRAM FASTENERS LIMITED- SUNSLDCD03",
  },
  {
    id: 381,
    name: "ITC LIMITED Saharanpur",
  },
  {
    id: 382,
    name: "ALL INDIA SOCIETY FOR HEALTH AID EDUUCATION & RESEARCH (A.S.H.A)",
  },
  {
    id: 383,
    name: "WELSPUN CAPTIVE POWER GENERATION LIMITED",
  },
  {
    id: 384,
    name: "Teejay India Private Limited",
  },
  {
    id: 385,
    name: "MGM MINERALS LIMITED",
  },
  {
    id: 386,
    name: "Patliputra Cement Works",
  },
  {
    id: 387,
    name: "ZUARI CEMENT LIMITED CPP MELLACHERUVU",
  },
  {
    id: 388,
    name: "PEEKAY ROLLING MILLS PRIVATE LIMITED",
  },
  {
    id: 389,
    name: "NAVA BHARAT VENTURES LTD., Odisha-IPP",
  },
  {
    id: 390,
    name: "RCCPL Private Limited-MP",
  },
  {
    id: 391,
    name: "ARYAN ISPAT & POWER PVT LTD",
  },
  {
    id: 392,
    name: "BALAJI MEDICAL AND DIAGNOSTIC RESEARCH CENTRE",
  },
  {
    id: 394,
    name: "MAGPIE HYDEL CONST OPERATIONS PVT LTD",
  },
  {
    id: 395,
    name: "HYACINTH HOTELS PRIVATE LIMITED (LEMON TREE, AEROCITY, NEW DELHI)",
  },
  {
    id: 396,
    name: "HINDALCO Industries Ltd.(Unit: Aditya Aluminium),Lapanga,Odisha",
  },
  {
    id: 397,
    name: "THE MAHABIR JUTE MILLS LTD",
  },
  {
    id: 398,
    name: "POLYPLEX CORPORATION LIMITED BAZPUR",
  },
  {
    id: 399,
    name: "KIOCL LIMITED",
  },
  {
    id: 402,
    name: "Palatana Plant",
  },
  {
    id: 403,
    name: "CHHATTISGARH STATE POWER DISTRIBUTION COMPANY LIMITED",
  },
  {
    id: 404,
    name: "EROS RESORTS AND HOTELS PRIVATE LIMITED",
  },
  {
    id: 405,
    name: "AGRAWAL SOLAR POWER VENTURES(RAJASTHAN) PRIVATE LIMITED-RRECL REGISTRATION NO. S/1123/2014",
  },
  {
    id: 406,
    name: "SHRIRAM FOUNDRY PRIVATE LIMITED",
  },
  {
    id: 407,
    name: "GOYAL MG GASES P LTD",
  },
  {
    id: 408,
    name: "Bansal Wire Industries Limited B-5&6",
  },
  {
    id: 409,
    name: "M/S Calcom Cement India Ltd Sankardev Nagar",
  },
  {
    id: 410,
    name: "GALLANTT ISPAT LIMITED",
  },
  {
    id: 411,
    name: "Government of Himachal Pradesh",
  },
  {
    id: 412,
    name: "Hindustan Zinc  Limited AGUCHA",
  },
  {
    id: 413,
    name: "TERUMO PENPOL PRIVATE LIMITED",
  },
  {
    id: 414,
    name: "VISHNU BARIUM PRIVATE LIMITED",
  },
  {
    id: 415,
    name: "Jindal Steel & Power Limited, Angul, Odisha",
  },
  {
    id: 416,
    name: "GRIDCO LIMITED",
  },
  {
    id: 418,
    name: "TATA STEEL LIMITED @132kV",
  },
  {
    id: 419,
    name: "JUNIPER HOTELS PRIVATE LIMITED",
  },
  {
    id: 420,
    name: "ORIENT BELL LIMITED I",
  },
  {
    id: 421,
    name: "MAX HEALTHCARE INSTITUTE LIMITED",
  },
  {
    id: 422,
    name: "Jindal India Thermal Power Limited",
  },
  {
    id: 423,
    name: "GBA STEELS & METALS PRIVATE LIMITED",
  },
  {
    id: 424,
    name: "VISION METALIK COMPANY",
  },
  {
    id: 425,
    name: "Bharti Airtel Ltd-224",
  },
  {
    id: 426,
    name: "Bharti Airtel Ltd-234",
  },
  {
    id: 427,
    name: "LULU CONVENTION AND EXHIBITION CENTER PRIVATE LIMITED",
  },
  {
    id: 428,
    name: "EMAMI AGROTECH LIMITED",
  },
  {
    id: 429,
    name: "PENNA CEMENT, BOYAREDDYPALLI (ATP308)",
  },
  {
    id: 430,
    name: "PENNA CEMENT, TALARICHERUVU (ATP230)",
  },
  {
    id: 431,
    name: "MOHAN SPINTEX INDIA LIMITED",
  },
  {
    id: 432,
    name: "NSL TEXTILES LIMITED INKOLLU",
  },
  {
    id: 433,
    name: "PENNA CEMENT, CAPTIVE POWER PLANT (NLG718)",
  },
  {
    id: 434,
    name: "KANORIA CHEMICALS AND INDUSTRIES LIMITED",
  },
  {
    id: 435,
    name: "DEENDAYAL PORT TRUST",
  },
  {
    id: 436,
    name: "PARAMESU BIOTECH PRIVATE LIMITED",
  },
  {
    id: 437,
    name: "Southern Power Distribution Company Of AP LIMITED",
  },
  {
    id: 438,
    name: "THE ANDHRA PETROCHEMICALS LIMITED",
  },
  {
    id: 439,
    name: "Arvind Ltd (Division Arvind Intex Point 2)",
  },
  {
    id: 440,
    name: "INDIAN RAILWAYS GUJARAT",
  },
  {
    id: 442,
    name: "South Eastern Railway",
  },
  {
    id: 443,
    name: "DCM TEXTILES",
  },
  {
    id: 444,
    name: "I T C LIMITED",
  },
  {
    id: 445,
    name: "Bharti Airtel Ltd-184",
  },
  {
    id: 446,
    name: "JK LAKSHMI CEMENT LIMITED (JHAJJAR UNIT)",
  },
  {
    id: 447,
    name: "Asahi India Glass Limited Cons.No. 19989",
  },
  {
    id: 448,
    name: "ARKAY ENERGY RAMESWARM LIMITED",
  },
  {
    id: 449,
    name: "SOUTHERN POWER DISTRIBUTION COMPANY OF TELANGANA LIMITED",
  },
  {
    id: 450,
    name: "SLR METALIKS LIMITED",
  },
  {
    id: 451,
    name: "Keshree Metalurgies Private Limited",
  },
  {
    id: 452,
    name: "NITTA GELATIN INDIA LIMITED KORATTY",
  },
  {
    id: 453,
    name: "THE INDIA CEMENTS LIMITED CPP NALGONDA",
  },
  {
    id: 454,
    name: "THE INDIA CEMENTS LIMITED YERRAGUNTLA",
  },
  {
    id: 455,
    name: "NSL TEXTILES LIMITED KUNCHALAVARIPALEM",
  },
  {
    id: 456,
    name: "MRF LIMITED KOTTAYAM",
  },
  {
    id: 457,
    name: "NSL TEXTILES LIMITED VEERAVALLI",
  },
  {
    id: 458,
    name: "Maharashtra Cement Plant (A Unit of Shree Cement Limited)",
  },
  {
    id: 459,
    name: "PRISM JOHNSON LIMITED (Cement Division)",
  },
  {
    id: 460,
    name: "P & R ENGINEERING SERVICES PRIVATE LIMITED.",
  },
  {
    id: 461,
    name: "Arvind Ltd (Division Arvind Intex Point 1)",
  },
  {
    id: 462,
    name: "MARUTI ISPAT & ENERGY PRIVATE LIMITED",
  },
  {
    id: 463,
    name: "INOX AIR PRODUCTS PRIVATE LIMITED-KERALA",
  },
  {
    id: 464,
    name: "Sakthi Sugars Limited, Appakudal",
  },
  {
    id: 465,
    name: "SAIL SALEM STEEL PLANT STEEL MELTING SHOP",
  },
  {
    id: 466,
    name: "SAIL SALEM STEEL PLANT ROLLING MILLS AND SMS AUXILIARY",
  },
  {
    id: 467,
    name: "NSL TEXTILES LIMITED EDLAPADU",
  },
  {
    id: 468,
    name: "Arvind Ltd (Division Ankur Textiles)",
  },
  {
    id: 469,
    name: "Arvind Limited(HT-8000029)",
  },
  {
    id: 470,
    name: "UNISON HOTELS PRIVATE LIMITED",
  },
  {
    id: 471,
    name: "ALSTHOM INDUSTRIES LIMITED",
  },
  {
    id: 472,
    name: "MYLAN LABORATORIES LIMITED PARAWADA",
  },
  {
    id: 473,
    name: "PRISM JOHNSON LIMITED (Cement Division- Unit II)",
  },
  {
    id: 474,
    name: "U P POWER CORPORATION LTD",
  },
  {
    id: 475,
    name: "DEVKI DEVI FOUNDATION",
  },
  {
    id: 476,
    name: "ESCORTS HEART INSTITUTE AND RESEARCH CENTRE LIMITED",
  },
  {
    id: 479,
    name: "TPTCL(DAGACHHU HYDRO POWER PLANT, BHUTAN)",
  },
  {
    id: 480,
    name: "PENNA CEMENT, KRISHNAPATNAM (NLR938)",
  },
  {
    id: 481,
    name: "BARAGARH HYDRO POWER CO. PRIVATE LIMITED",
  },
  {
    id: 482,
    name: "SATYAM STEELS & ALLOYS",
  },
  {
    id: 483,
    name: "POLYPLEX CORPORATION LIMITED",
  },
  {
    id: 484,
    name: "HINDUSTHAN NATIONAL GLASS & INDUSTRIES LTD- HINSLDCD02",
  },
  {
    id: 485,
    name: "MITTAPALLI SPINNERS PRIVATE LIMITED",
  },
  {
    id: 486,
    name: "HEMADRI CEMENTS LIMITED",
  },
  {
    id: 487,
    name: "Sakthi Sugars Limited, Elumathur",
  },
  {
    id: 488,
    name: "KM Power Pvt Ltd",
  },
  {
    id: 490,
    name: "POWER DEPARTMENT,GOVERNMENT OF SIKKIM",
  },
  {
    id: 491,
    name: "ECOPLUS STEELS PRIVATE LIMITED",
  },
  {
    id: 493,
    name: "CHIEF ELECTRICAL ENGINEER",
  },
  {
    id: 494,
    name: "SMS PHARMACEUTICALS LIMITED",
  },
  {
    id: 495,
    name: "DEVI SEAFOODS",
  },
  {
    id: 496,
    name: "VENNAR CERAMICS LIMITED",
  },
  {
    id: 497,
    name: "ATC LIMITED",
  },
  {
    id: 498,
    name: "SVR SPINNING MILLS PVT LTD",
  },
  {
    id: 499,
    name: "TAB INDIA GRANITES PRIVATE LIMITED",
  },
  {
    id: 500,
    name: "MYLAN LABORATORIES LIMITED,UNIT-1",
  },
  {
    id: 501,
    name: "Reliance Industries Limited Vadodara",
  },
  {
    id: 502,
    name: "ASSAM POWER DISTRIBUTION COMPANY LIMITED",
  },
  {
    id: 503,
    name: "THE ASSAM TUBES LIMITED",
  },
  {
    id: 504,
    name: "ITC Limited PPD Haridwar",
  },
  {
    id: 505,
    name: "SHRI BAJRANG POWER AND ISPAT LIMITED BORJHARA DIVISION",
  },
  {
    id: 507,
    name: "RELIANCE INDUSTRIES LIMITED-SILVASSA",
  },
  {
    id: 508,
    name: "BALAJI ENERGY PRIVATE LIMITED",
  },
  {
    id: 509,
    name: "Sakthi Sugars Limited",
  },
  {
    id: 510,
    name: "Yogindera Powers Limited",
  },
  {
    id: 511,
    name: "SRIVATSA BIOTECH INDIA PRIVATE LIMITED",
  },
  {
    id: 512,
    name: "NCL INDUSTRIES LIMITED-AP",
  },
  {
    id: 513,
    name: "AUROBINDO PHARMA LIMITED",
  },
  {
    id: 514,
    name: "Ravali Spinners Pvt Ltd",
  },
  {
    id: 515,
    name: "GAYATRI POWER PRIVATE LIMITED",
  },
  {
    id: 516,
    name: "ANRAK ALUMINIUM LIMITED",
  },
  {
    id: 517,
    name: "ITC LTD Kidderpore",
  },
  {
    id: 518,
    name: "KOTHARI FERMENTATION AND BIOCHEM LIMITED",
  },
  {
    id: 519,
    name: "SONAL IRONS INDUSTRY PRIVATE LIMITED",
  },
  {
    id: 520,
    name: "SAGAR CEMENTS (R) LIMITED",
  },
  {
    id: 521,
    name: "ARUNODAYA TECHSOLAR POWER PROJECTS PRIVATE LIMITED",
  },
  {
    id: 522,
    name: "cargill india private limited",
  },
  {
    id: 523,
    name: "BIRLA CARBON INDIA PRIVATE LIMITED-TN",
  },
  {
    id: 524,
    name: "Star Wire India Limited Plant-1",
  },
  {
    id: 525,
    name: "Shree Cement Limited (Panipat)",
  },
  {
    id: 526,
    name: "SATYAM ISPAT (NORTH EAST) LIMITED",
  },
  {
    id: 527,
    name: "SATYARATAN STEEL PRIVATE LIMITED",
  },
  {
    id: 528,
    name: "ITC Limited PCPB Haridwar",
  },
  {
    id: 529,
    name: "K K DUPLEX AND PAPER MILLS PRIVATE LIMITED",
  },
  {
    id: 530,
    name: "DOP, Govt. of Arunachal Pradesh",
  },
  {
    id: 531,
    name: "SHREE SALASAR INDUSTRIES PRIVATE LIMITED",
  },
  {
    id: 532,
    name: "SHRI BAJRANG POWER AND ISPAT LIMITED TILDA DIVISION",
  },
  {
    id: 534,
    name: "Power & Electricity Department Government of Mizoram",
  },
  {
    id: 535,
    name: "Ambattur Hotels Private Limited",
  },
  {
    id: 536,
    name: "SENTINI CERMICA PRIVATE LIMITED",
  },
  {
    id: 537,
    name: "MARIS SPINNERS LTD UNIT II",
  },
  {
    id: 538,
    name: "EMAMI PAPER MILLS LIMITED",
  },
  {
    id: 539,
    name: "GMR KAMALANGA ENERGY LIMITED-STU",
  },
  {
    id: 540,
    name: "JHARKHAND BIJLI VITRAN NIGAM LIMITED",
  },
  {
    id: 541,
    name: "SHREE GANESH METALIKS LIMITED",
  },
  {
    id: 542,
    name: "M/s Tata Steel Ltd, FAP, Bamnipal",
  },
  {
    id: 543,
    name: "M/s Tata Steel Ltd, Joda East Iron Mines Ltd",
  },
  {
    id: 544,
    name: "GOPANI IRON AND POWER (INDIA) PRIVATE LIMITED",
  },
  {
    id: 545,
    name: "UTTAM GALVA METALLICS LIMITED",
  },
  {
    id: 546,
    name: "NOVA IRON AND STEEL LIMITED",
  },
  {
    id: 547,
    name: "UMANG DAIRIES LIMITED",
  },
  {
    id: 548,
    name: "ADANI WILMAR LIMITED KNL198",
  },
  {
    id: 549,
    name: "SREE RENGARAJ ISPAT INDUSTRIES PVT LTD",
  },
  {
    id: 550,
    name: "PRECOT LIMITED (A UNIT)",
  },
  {
    id: 551,
    name: "BURAKIA STEEL & ALLOYS",
  },
  {
    id: 553,
    name: "KANTI BROTHERS OILS PVT LIMITED",
  },
  {
    id: 554,
    name: "KHANDALERU POWER COMPANY LIMITED",
  },
  {
    id: 555,
    name: "VISWATEJA SPINNING MILLS PRIVATE LIMITED",
  },
  {
    id: 556,
    name: "VIZAG GENERAL CARGO BERTH PRIVATE LIMITED",
  },
  {
    id: 559,
    name: "BANGLADESH POWER DEVELOPMENT BOARD",
  },
  {
    id: 560,
    name: "TATA STEEL MINING LIMITED",
  },
  {
    id: 561,
    name: "VACMET INDIA LIMITED UNIT-3",
  },
  {
    id: 562,
    name: "KANPUR PLASTIPACK LIMITED UNIT-3",
  },
  {
    id: 563,
    name: "B M M ISPAT LIMITED",
  },
  {
    id: 564,
    name: "Pioneer Carbide Private Limited",
  },
  {
    id: 565,
    name: "SKJ POWER PROJECTS PRIVATE LIMITED",
  },
  {
    id: 566,
    name: "Prayagraj Power Generation Company Limited",
  },
  {
    id: 567,
    name: "GLAND PHARMA LIMITED",
  },
  {
    id: 568,
    name: "NCL INDUSTRIES LIMITED-TG",
  },
  {
    id: 569,
    name: "APOLLO TYRES LIMITED",
  },
  {
    id: 570,
    name: "Divis Laboratories Limited SEZ Unit",
  },
  {
    id: 571,
    name: "Tripura State Electricity Corporation Limited",
  },
  {
    id: 572,
    name: "KANODIA CEMENT LIMITED UNIT-1",
  },
  {
    id: 573,
    name: "KANODIA CEMENT LIMITED",
  },
  {
    id: 574,
    name: "INOX AIR PRODUCTS PRIVATE LIMITED-TN",
  },
  {
    id: 575,
    name: "KKP WEAVING AND PROCESSING MILLS PRIVATE LIMITED",
  },
  {
    id: 576,
    name: "BSL CASTINGS PRIVATE LIMITED",
  },
  {
    id: 577,
    name: "ASTRAL LIMITED",
  },
  {
    id: 578,
    name: "PRECOT LIMITED (C & D Units)",
  },
  {
    id: 579,
    name: "MSP SPONGE IRON LIMITED",
  },
  {
    id: 580,
    name: "Dilip Rerolling Private Limited",
  },
  {
    id: 581,
    name: "SAKKU SPINNING  MILLS  PRIVATE LIMITED",
  },
  {
    id: 582,
    name: "LULU INTERNATIONAL SHOPPING MALL PRIVATE LIMITED, MARRIOTT KOCHI",
  },
  {
    id: 583,
    name: "ELECTROSTEEL CASTINGS LIMITED TPT 2547",
  },
  {
    id: 584,
    name: "ELECTROSTEEL CASTINGS LIMITED TPT 230",
  },
  {
    id: 585,
    name: "ANJANI TILES LIMITED",
  },
  {
    id: 586,
    name: "Mylan Laboratories Limited, unit-2",
  },
  {
    id: 587,
    name: "Parry Sugars Refinery India Pvt LTD",
  },
  {
    id: 588,
    name: "COCHIN SHIPYARD LIMITED",
  },
  {
    id: 591,
    name: "NEPAL ELECTRICITY AUTHORITY TANAKPUR",
  },
  {
    id: 593,
    name: "NEPAL ELECTRICITY AUTHORITY MUZAFFARPUR",
  },
  {
    id: 594,
    name: "Oil and Natural Gas Corporation Limited - Hazira",
  },
  {
    id: 595,
    name: "SHRI BAJRANG POWER AND ISPAT LIMITED TMT DIVISION",
  },
  {
    id: 596,
    name: "M/s Amulfed Dairy( A Unit of GCMMF Ltd)",
  },
  {
    id: 597,
    name: "Vandana Global Limited",
  },
  {
    id: 598,
    name: "Caplin Steriles Limited",
  },
  {
    id: 599,
    name: "P V SPINNING MILLS INDIA PRIVATE  LIMITED",
  },
  {
    id: 600,
    name: "SANMAR MATRIX METALS LIMITED FOUNDRY UNIT 1",
  },
  {
    id: 601,
    name: "GAIL INDIA LIMITED-MP",
  },
  {
    id: 602,
    name: "TOPWORTH URJA AND METALS LIMITED",
  },
  {
    id: 603,
    name: "VEL CASTINGS PVT LTD",
  },
  {
    id: 604,
    name: "Sri Vinayaga Alloys Private Limited",
  },
  {
    id: 605,
    name: "FERRA TECH",
  },
  {
    id: 606,
    name: "SAINT GOBAIN INDIA PRIVATE LIMITED",
  },
  {
    id: 607,
    name: "B L A POWER PRIVATE LIMITED",
  },
  {
    id: 608,
    name: "NEW MOUNT TRADING & INVESTMENT CO LTD",
  },
  {
    id: 609,
    name: "Denso Haryana Private Limited",
  },
  {
    id: 610,
    name: "Sun Pharmaceutical Industries Limited",
  },
  {
    id: 611,
    name: "Ganesha Ecosphere Limited (Kota)",
  },
  {
    id: 612,
    name: "The Indian Wood Products Company Limited",
  },
  {
    id: 613,
    name: "DIVIS LABORATORIES LIMITED",
  },
  {
    id: 614,
    name: "SANMAR MATRIX METALS LIMITED FOUNDRY UNIT 2",
  },
  {
    id: 615,
    name: "RMG POLYVINYL INDIA LIMITED",
  },
  {
    id: 616,
    name: "Sri Vigneswara Steels Private Limited",
  },
  {
    id: 617,
    name: "E I D PARRY, NELLIKUPPAM",
  },
  {
    id: 618,
    name: "K K SPINTEX INDIA PRIVATE LIMITED",
  },
  {
    id: 619,
    name: "ELLENBARRIE INDUSTRIAL GASES LTD",
  },
  {
    id: 620,
    name: "Shyam Metalics & Energy Ltd., Sambalpur",
  },
  {
    id: 621,
    name: "Rampur HPS",
  },
  {
    id: 622,
    name: "Ambica Steels Limited",
  },
  {
    id: 623,
    name: "Navitasys India Private Limited",
  },
  {
    id: 624,
    name: "Amba Shakti Steels Limited Rolling Division",
  },
  {
    id: 625,
    name: "MANJUSHREE TECHNOPACK LIMITED",
  },
  {
    id: 626,
    name: "GOEL ASSOCIATES",
  },
  {
    id: 627,
    name: "ITC Maratha Mumbai",
  },
  {
    id: 628,
    name: "PVR SPINNING AND WEAVING LIMITED",
  },
  {
    id: 629,
    name: "VASUDHA PHARMA CHEM LIMITED",
  },
  {
    id: 630,
    name: "J K CEMENT LIMITED",
  },
  {
    id: 631,
    name: "RUSHIL DECOR LIMITED-AP",
  },
  {
    id: 632,
    name: "Bhavya Cements Private Limited",
  },
  {
    id: 633,
    name: "SHRI SANTHOSH MEENAKSHI TEXTILES PVT LTD",
  },
  {
    id: 634,
    name: "VENKATA NARAYANA ACTIVE INGREDIENTS PRIVATE LIMITED",
  },
  {
    id: 635,
    name: "M.P. POWER MANAGEMENT COMPANY LIMITED",
  },
  {
    id: 636,
    name: "Nathpa Jhakri HPS",
  },
  {
    id: 637,
    name: "Ganesha Ecosphere Limited",
  },
  {
    id: 638,
    name: "WONDER CEMENT LIMITED",
  },
  {
    id: 639,
    name: "Sree Rengaraaj Steel and Alloys Private Limited",
  },
  {
    id: 640,
    name: "Ankur Udyog Ltd.",
  },
  {
    id: 641,
    name: "SHIVA MILLS LIMITED",
  },
  {
    id: 642,
    name: "KRIHAAN TEXCHEM PRIVATE LIMITED",
  },
  {
    id: 643,
    name: "Prime Gold International Limited",
  },
  {
    id: 644,
    name: "sonal vyapar private limited",
  },
  {
    id: 645,
    name: "NEW TIRUPUR AREA DEVELOPMENT CORPORATION LIMITED_HTSC 190",
  },
  {
    id: 646,
    name: "NEW TIRUPUR AREA DEVELOPMENT CORPORATION LIMITED_HTSC 195",
  },
  {
    id: 647,
    name: "ABI SHOWATECH (INDIA) PRIVATE LIMITED",
  },
  {
    id: 648,
    name: "Tinna Rubber and  Infrastructure Limited",
  },
  {
    id: 649,
    name: "MEERA TEXTILES (P) LTD",
  },
  {
    id: 650,
    name: "TULSYAN NEC LTD",
  },
  {
    id: 651,
    name: "SHREE SHYAM ISPAT",
  },
  {
    id: 652,
    name: "LAKSHMIVEL MILLS PRIVATE LIMITED",
  },
  {
    id: 653,
    name: "Hindustan Organic Chemicals Limited",
  },
  {
    id: 654,
    name: "SASI ANAND SPINNING MILLS INDIA PRIVATE LIMITED",
  },
  {
    id: 655,
    name: "VACMET INDIA LIMITED (UNIT-2)",
  },
  {
    id: 656,
    name: "R B Wovens Pvt Limited",
  },
  {
    id: 657,
    name: "CENTURY PLYBOARDS (INDIA) LIMITED",
  },
  {
    id: 658,
    name: "RNB CEMENTS PRIVATE LIMITED",
  },
  {
    id: 659,
    name: "AMAR UDYOG (Plant-ll)",
  },
  {
    id: 660,
    name: "ECO CEMENT INDIA LIMITED",
  },
  {
    id: 661,
    name: "SRI JAYAJOTHI TEXTILE MILLS PRIVATE LTD",
  },
  {
    id: 662,
    name: "SRI JAYAJOTHI TEXTILE MILLS PRIVATE LTD (Expansion)",
  },
  {
    id: 663,
    name: "MSPL LIMITED",
  },
  {
    id: 664,
    name: "KUSALAVA INTERNATIONAL LIMITED",
  },
  {
    id: 665,
    name: "TATA STEEL LIMITED-BOISAR",
  },
  {
    id: 666,
    name: "Sri Jayavilas Subbaraj Spinning Mills Private Limited",
  },
  {
    id: 667,
    name: "SAI LIFE SCIENCES LIMITED",
  },
  {
    id: 668,
    name: "DATTATREYA TEXTILES PRIVATE LIMITED",
  },
  {
    id: 669,
    name: "CHETTINAD CEMENT CORPORATION PRIVATE LIMITED",
  },
  {
    id: 670,
    name: "BHAGIRADHA CHEMICAL & INDUSTRIES LIMITED",
  },
  {
    id: 671,
    name: "AMBIKA COTTON MILLS LTD",
  },
  {
    id: 672,
    name: "L D Goyal Steels Private Limited",
  },
  {
    id: 673,
    name: "PRAHLAD ISPAT PRIVATE LIMITED",
  },
  {
    id: 674,
    name: "SRILANAND MANSIONS PRIVATE LIMITED",
  },
  {
    id: 675,
    name: "PRECOT LIMITED",
  },
  {
    id: 676,
    name: "ASAHI INDIA GLASS LIMITED-TN HT-0424",
  },
  {
    id: 677,
    name: "ELECTROTHERM (INDIA) LIMITED",
  },
  {
    id: 678,
    name: "Goodluck Steel tubes",
  },
  {
    id: 679,
    name: "Good luck industries-1",
  },
  {
    id: 680,
    name: "AMBIKA COTTON MILLS LTD HTSC: 96",
  },
  {
    id: 681,
    name: "Barak Valley Cements Limited",
  },
  {
    id: 682,
    name: "SURYAANS PAPER",
  },
  {
    id: 683,
    name: "Mankameshwar Steels Unit-II Private Limited",
  },
  {
    id: 684,
    name: "Premier Polyfilm Limited",
  },
  {
    id: 685,
    name: "SRI JAIBALAJI STEEL ROLLING MILLS PRIVATE LIMITED",
  },
  {
    id: 686,
    name: "ABI SOORAI GREEN(DIVISION OF ABI SHOWATECH(INDIA) PRIVATE LIMITED",
  },
  {
    id: 687,
    name: "SHRI GIRIJA ALLOY AND POWER (I) PRIVATE LIMITED",
  },
  {
    id: 688,
    name: "GRASIM INDUSTRIES LIMITED-KARWAR",
  },
  {
    id: 689,
    name: "ORCHID PHARMA LIMITED",
  },
  {
    id: 690,
    name: "HBL POWER SYTEMS LIMITED",
  },
  {
    id: 691,
    name: "Kanishk Steel Industries Limited",
  },
  {
    id: 692,
    name: "Sree Jagathguru Textiles Mills Pvt Ltd",
  },
  {
    id: 693,
    name: "CHEMPLAST CUDDALORE VINYLS LIMITED",
  },
  {
    id: 694,
    name: "ESWAR RUBBER PRODUCTS PRIVATE LIMITED",
  },
  {
    id: 695,
    name: "MAA MAHAMAYA ALLOYS Private Limited Unit-1",
  },
  {
    id: 696,
    name: "SRI SUGHAN INTERNATIONAL",
  },
  {
    id: 697,
    name: "MMS Steel & Power Private Limited",
  },
  {
    id: 698,
    name: "SILVER SPRING SPINNERS INDIA P LTD",
  },
  {
    id: 699,
    name: "Agni Steels Private Limited",
  },
  {
    id: 700,
    name: "NEKKANTI SEA FOODS LIMITED",
  },
  {
    id: 701,
    name: "LULU INTERNATIONAL SHOPPING MALLS PRIVATE LIMITED",
  },
  {
    id: 702,
    name: "CHENNAI PETROLEUM CORPORATION LIMITED",
  },
  {
    id: 703,
    name: "ARUNACHALA GOUNDER TEXTILE MILLS PVT LTD",
  },
  {
    id: 704,
    name: "Good luck Industries-2",
  },
  {
    id: 705,
    name: "Ganesha Ecosphere Limited (Rania)",
  },
  {
    id: 706,
    name: "shree salasarhanumanji grains private limited",
  },
  {
    id: 707,
    name: "AVADH ALLOYS P LTD",
  },
  {
    id: 708,
    name: "HARI KRISHNAA SPINNING MILLS PRIVATE LIMITED",
  },
  {
    id: 709,
    name: "THE RAJARATNA MILLS PRIVATE LIMITED-HT0091",
  },
  {
    id: 710,
    name: "ASHOK LEYLAND LIMITED FOUNDRY DIVISION 1072",
  },
  {
    id: 711,
    name: "BROOKEFIELDS ESTATES PRIVATE LIMITED",
  },
  {
    id: 712,
    name: "CENTWIN TEXTILE MILLS PRIVATE LIMITED",
  },
  {
    id: 713,
    name: "SUBBURAJ SPINNING MILLS PRIVATE LIMITED",
  },
  {
    id: 714,
    name: "LAKSHMI MACHINE WORKS LIMITED - FOUNDRY AND MACHINE SHOP",
  },
  {
    id: 715,
    name: "ASHOK LEYLAND LIMITED FOUNDRY DIVISION 1347",
  },
  {
    id: 716,
    name: "Jothi Micro Cast Private Limited",
  },
  {
    id: 717,
    name: "LAKSHMI MACHINE WORKS LTD-UNIT-II",
  },
  {
    id: 718,
    name: "Jai Jagadhambiga Textile Mills (P) Ltd",
  },
  {
    id: 719,
    name: "GUHAN TEXTILES MILLS PVT LTD",
  },
  {
    id: 720,
    name: "Parani Spinning Mills Pvt Ltd",
  },
  {
    id: 721,
    name: "MEENAKSHI UDYOG INDIA PVT LTD",
  },
  {
    id: 723,
    name: "ELECTRICITY DEPARTMENT PUDUCHERRY",
  },
  {
    id: 724,
    name: "Sri Velayudhaswamy Spinning Mills  Private limited, UNIT II",
  },
  {
    id: 725,
    name: "SRI KARTHIKEYA SPINNING & WEAVING MILLS PRIVATE LIMITED B UNIT",
  },
  {
    id: 726,
    name: "VIJAI SPINNERS RJPM PRIVATE LIMITED",
  },
  {
    id: 727,
    name: "SWARUP ROLLING MILLS LIMITED",
  },
  {
    id: 728,
    name: "SOURCEWELL AGRO FOODS PRIVATE LIMITED",
  },
  {
    id: 729,
    name: "SRM INSTITUTE OF SCIENCE AND TECHNOLOGY",
  },
  {
    id: 730,
    name: "JK TYRE AND INDUSTRIES LIMITED ,VIKRANT TYRE ,PLANT-1",
  },
  {
    id: 731,
    name: "JAMNA AUTO INDUSTRIES LTD",
  },
  {
    id: 732,
    name: "Jothi Malleables Private Limited",
  },
  {
    id: 733,
    name: "Sri Shanmugavel Mills Private limited",
  },
  {
    id: 734,
    name: "MAA MAHAMAYA ALLOYS Private Limited Unit-2",
  },
  {
    id: 735,
    name: "AGARWAL FERRO METALLIC PRIVATE LIMITED",
  },
  {
    id: 736,
    name: "SHRI SATGURU METALLOYS PRIVATE LIMITED",
  },
  {
    id: 737,
    name: "RPP  LIMITED",
  },
  {
    id: 738,
    name: "SHRI MOOKAMBIGA SPINNING MILLS PRIVATE LIMITED",
  },
  {
    id: 739,
    name: "DOLLAR INDUSTRIES LIMITED",
  },
  {
    id: 740,
    name: "CHOUDHARY POWER PROJECTS PVT LTD",
  },
  {
    id: 741,
    name: "MOTHI SPINNER PRIVATE LIMITED  UNIT III",
  },
  {
    id: 742,
    name: "J K Lakshmi Cement Ltd Cons. no.63284",
  },
  {
    id: 743,
    name: "Meghmani Organics Ltd.-dahej",
  },
  {
    id: 744,
    name: "G B R METALS PRIVATE LIMITED - FURNACE UNIT",
  },
  {
    id: 745,
    name: "RAS POLYTEX PRIVATE LIMITED",
  },
  {
    id: 746,
    name: "B L A Power Private Limited Unit - 1",
  },
  {
    id: 747,
    name: "KAJARIA CERAMICS LIMITED",
  },
  {
    id: 748,
    name: "INDIAN TONERS AND DEVELOPERS LIMITED",
  },
  {
    id: 749,
    name: "Shreehari Ispat Private Limited",
  },
  {
    id: 750,
    name: "SANCO FOUNDATION",
  },
  {
    id: 751,
    name: "Seshasayee Paper & boards limited",
  },
  {
    id: 752,
    name: "SAI LILAGAR POWER GENERATION LIMITED",
  },
  {
    id: 753,
    name: "Vee Gee Industrial Enterprises Private Limited",
  },
  {
    id: 754,
    name: "Prime India Polymix Private Limited",
  },
  {
    id: 755,
    name: "Jay Bharat Maruti Limited",
  },
  {
    id: 756,
    name: "RAJRIYA INDUSTRIES LLP",
  },
  {
    id: 757,
    name: "SRI KARTHIKEYA SPINNING & WEAVING MILLS PRIVATE LIMITED",
  },
  {
    id: 758,
    name: "BAGALKOT CEMENT AND INDUSTRIES LIMITED",
  },
  {
    id: 759,
    name: "APL HEALTHCARE LTD",
  },
  {
    id: 760,
    name: "SKS Ispat and Power Limited",
  },
  {
    id: 761,
    name: "AKSHAT ROLLER FLOUR MILLS PRIVATE LIMITED",
  },
  {
    id: 762,
    name: "MUZAFFARNAGAR MEDICAL COLLEGE RUN BY FATEH CHAND CHARITABLE TRUST",
  },
  {
    id: 763,
    name: "RAJAH MUTHIAH CHETTIAR CHARITABLE and EDUCATIONAL TRUST",
  },
  {
    id: 764,
    name: "ASIAN HOTELS (NORTH) LIMITED",
  },
  {
    id: 765,
    name: "SARDHANA PAPERS PRIVATE LIMITED",
  },
  {
    id: 766,
    name: "SARDHANA SPINNING MILLS PRIVATE LIMITED",
  },
  {
    id: 767,
    name: "ASK Automotive Private Limited (Unit-Al)",
  },
  {
    id: 768,
    name: "ISGEC Heavy Engineering Limited",
  },
  {
    id: 769,
    name: "THE RAJARATNA MILLS PRIVATE LIMITED-HT0006",
  },
  {
    id: 770,
    name: "Sri Jayamaaruthi yarn Indiaa private Limited",
  },
  {
    id: 771,
    name: "Brakes India Private Limited, Foundry division-B Unit",
  },
  {
    id: 772,
    name: "Gokak Textiles Limited, GPBHT-1",
  },
  {
    id: 773,
    name: "ITC Limited Viralimalai",
  },
  {
    id: 774,
    name: "G B R METALS PRIVATE LIMITED - ROLLINGMILL DIVISION",
  },
  {
    id: 775,
    name: "Brakes India Private Limited 1067",
  },
  {
    id: 776,
    name: "Brakes India Private Limited, Foundry division Unit II",
  },
  {
    id: 777,
    name: "Aster DM Heatthcare Pvt. Ltd.",
  },
  {
    id: 778,
    name: "Sundaram Clayton Limited 244",
  },
  {
    id: 779,
    name: "RAJASHREE SPINTEX PVT LTD",
  },
  {
    id: 780,
    name: "SAKTHI SPINTEX PRIVATE LIMITED",
  },
  {
    id: 781,
    name: "Ostro Energy Private Limited",
  },
  {
    id: 783,
    name: "Jammu and Kashmir Power Development  COPRPORATION LTD BAGLIHAR HEP-2",
  },
  {
    id: 784,
    name: "JAYANTHI TEXTILE PRODUCTS UNIT II",
  },
  {
    id: 785,
    name: "CCL PRODUCTS (INDIA) LIMITED",
  },
  {
    id: 786,
    name: "Ashok Leyland Limited (Foundry division)",
  },
  {
    id: 787,
    name: "Sudhan Spinning Mills Private limited, HTSC: 102",
  },
  {
    id: 788,
    name: "PRABHU SPINNING MILLS PRIVATE LIMITED (Open End Division)",
  },
  {
    id: 789,
    name: "Sri Velayudhaswamy Spinning Mills private limited, OE",
  },
  {
    id: 790,
    name: "Jay Jay Mills (India) Private Limited",
  },
  {
    id: 791,
    name: "PKPN SPINNING MILLS (P) LTD",
  },
  {
    id: 792,
    name: "Christy Friedgram Industry",
  },
  {
    id: 793,
    name: "KUMARAN GIN & PRESSING PVT LTD",
  },
  {
    id: 794,
    name: "SHRI SIDDHI VINAYAGA TEX INDIA PRIVATE LIMITED",
  },
  {
    id: 795,
    name: "GEMINI EDIBLES & FATS INDIA LIMITED",
  },
  {
    id: 796,
    name: "UNITED INDUSTRIES PLASTICS PRIVATE LIMITED",
  },
  {
    id: 797,
    name: "SHREE SIDHBALI STEELS PRIVATE LIMITED",
  },
  {
    id: 798,
    name: "Tecci Park Owners Association",
  },
  {
    id: 799,
    name: "CETEX PETROCHEMICALS LIMITED",
  },
  {
    id: 800,
    name: "SRIPATHI PAPER AND BOARDS PIRVATE LIMITED",
  },
  {
    id: 801,
    name: "Super Sales India Ltd,(HTSC 13)",
  },
  {
    id: 802,
    name: "Super Sales India Ltd (HTSC-155)",
  },
  {
    id: 803,
    name: "MARINE INFRASTRUCTURE DEVELOPER PRIVATE LIMITED",
  },
  {
    id: 804,
    name: "ARUN SPINNING MILLS (P) LTD",
  },
  {
    id: 805,
    name: "CHOLA TEXTILES PRIVATE LIMITED",
  },
  {
    id: 806,
    name: "Sundaram Clayton Limited HTSC 1109",
  },
  {
    id: 807,
    name: "SUNDARAM TEXTILES PRIVATE LIMITED",
  },
  {
    id: 808,
    name: "PANDIAN TEXTILE MILLS PRIVATE LIMITED",
  },
  {
    id: 809,
    name: "PALLAVA SPINNING MILLS PRIVATE LIMITED",
  },
  {
    id: 810,
    name: "HARSHNI TEXTILES PRIVATE LTD",
  },
  {
    id: 811,
    name: "MOTHI SPINNER PRIVATE LIMITED UNIT II",
  },
  {
    id: 812,
    name: "DALMIA CEMENT (BHARAT) LIMITED, Meghalaya",
  },
  {
    id: 813,
    name: "RAYALASEEMA INDUSTRIES INDIA PRIVATE LIMITED",
  },
  {
    id: 814,
    name: "HARIHARAN SPINNERS (I) PRIVATE LIMITED",
  },
  {
    id: 815,
    name: "DELPHI TVS TECHNOLOGIES LIMITED -HTSC 153",
  },
  {
    id: 816,
    name: "Mainetti (India) Pvt Ltd",
  },
  {
    id: 817,
    name: "MOTHI SPINNER PRIVATE LIMITED UNIT IV",
  },
  {
    id: 818,
    name: "K.A.S. INDUSTRIES INDIA PRIVATE LIMITED",
  },
  {
    id: 819,
    name: "jeevaka industries (p) ltd",
  },
  {
    id: 820,
    name: "K M KNITWEAR PRIVATE LIMITED",
  },
  {
    id: 821,
    name: "SHARADHA TERRY PRODUCTS (P) LTD",
  },
  {
    id: 822,
    name: "MOTHI SPINNER PRIVATE LIMITED  UNIT 1",
  },
  {
    id: 823,
    name: "BEEKAY STEEL INDUSTRIES LIMITED",
  },
  {
    id: 824,
    name: "Brindha Cotton Mills Private Limited",
  },
  {
    id: 825,
    name: "ADANI ENNORE CONTAINER TERMINAL PRIVATE LIMITED",
  },
  {
    id: 826,
    name: "GREENTECH INDUSTRIES INDIA PRIVATE LIMITED",
  },
  {
    id: 827,
    name: "Jay Jay Mills (India) Private limited (HTSC_451)",
  },
  {
    id: 828,
    name: "North Western Railway",
  },
  {
    id: 829,
    name: "VICTORY SPINNING MILLS PRIVATE LIMITED",
  },
  {
    id: 830,
    name: "Sri Kuppanna Spinning Mill Private Limited",
  },
  {
    id: 831,
    name: "RISHIK SPINNING PVT LTD",
  },
  {
    id: 832,
    name: "Trinayani cement Private Limited",
  },
  {
    id: 833,
    name: "GULSHAN POLYOLS LIMITED",
  },
  {
    id: 834,
    name: "Sundaram Clayton ltd HTSC 1514",
  },
  {
    id: 835,
    name: "MARKS ENGINEERING WORKS(htsc-0828)",
  },
  {
    id: 836,
    name: "BRAKES INDIA PRIVATE LIMITED, POLAMBAKKAM,HTSC 222",
  },
  {
    id: 837,
    name: "PC SONS CASTING PVT LIMITED",
  },
  {
    id: 838,
    name: "PRABHU SPINNING MILLS PRIVATE LIMITED, HTSC: 148",
  },
  {
    id: 839,
    name: "SRF Limited - Gummidipoondi",
  },
  {
    id: 840,
    name: "Star Wire India Limited Plant-2",
  },
  {
    id: 841,
    name: "M/s HSIL Ltd.",
  },
  {
    id: 842,
    name: "SHAMLI STEELS PVT LTD",
  },
  {
    id: 843,
    name: "I T C LIMITED, Sonar and Royal Bengal",
  },
  {
    id: 844,
    name: "East Delhi Waste Processing Company Limited",
  },
  {
    id: 845,
    name: "OPG Renewable Energy Private Limited",
  },
  {
    id: 846,
    name: "HARTEX RUBBER PVT LIMITED",
  },
  {
    id: 847,
    name: "Udaipur Cement Works Limited",
  },
  {
    id: 848,
    name: "Calpro Specialities Private Limited",
  },
  {
    id: 849,
    name: "SUMITI ALLOYS PRIVATE LIMITED",
  },
  {
    id: 850,
    name: "SHRI HARI PROCESS",
  },
  {
    id: 851,
    name: "Gousia Road Construction Company",
  },
  {
    id: 852,
    name: "BALAJI RUBBER INDUSTRIES PVT LTD",
  },
  {
    id: 853,
    name: "ARUPADAI ARULMURUGAN SPINNERS PRIVATE LIMITED",
  },
  {
    id: 854,
    name: "Magnum Spinning Millss India Private Limited",
  },
  {
    id: 855,
    name: "PREMIER SPG AND WVG MILLS PVT LTD",
  },
  {
    id: 856,
    name: "APOLLO HOSPITALS ENTERPRISE LIMITED",
  },
  {
    id: 857,
    name: "Kumaragiri Spinnerss Private Ltd",
  },
  {
    id: 858,
    name: "vsm weavess india Pvt ltd (HTSC-0227)",
  },
  {
    id: 859,
    name: "SUDIVA SPINNERS PRIVATE LIMITED",
  },
  {
    id: 860,
    name: "INTERGLOBE HOTELS PRIVATE LIMITED",
  },
  {
    id: 861,
    name: "JANAKIRAM STEEL AND POWE PVT LTD",
  },
  {
    id: 862,
    name: "KPR  Mill Limited",
  },
  {
    id: 863,
    name: "KPR Mill Limited ARASUR UNIT",
  },
  {
    id: 864,
    name: "Ashley Alteams India Ltd",
  },
  {
    id: 865,
    name: "LAKSHMI MACHINE WORKS LIMITED",
  },
  {
    id: 866,
    name: "DIVYA SPINNING MILL PRIVATE LIMITED",
  },
  {
    id: 867,
    name: "GLENROCK RUBBER PRODUCTS PRIVATE LIMITED",
  },
  {
    id: 868,
    name: "BHADRESHWAR VIDYUT PRIVATE LIMITED",
  },
  {
    id: 869,
    name: "VISA STEEL LIMITED",
  },
  {
    id: 870,
    name: "Neel Metal Products Limited",
  },
  {
    id: 871,
    name: "SMR AUTOMOTIVE SYSTEMS INDIA LIMITED",
  },
  {
    id: 872,
    name: "Reliance Industries limited Mauda Nagpur",
  },
  {
    id: 873,
    name: "WAVE HOSPITALITY PRIVATE LIMITED",
  },
  {
    id: 874,
    name: "HARI OM STEEL INDUSTRIES",
  },
  {
    id: 875,
    name: "MAHALAXMI CRAFTS AND TISSUES PRIVATE LIMITED",
  },
  {
    id: 876,
    name: "RG SPINNING MILLS PRIVATE LIMITED",
  },
  {
    id: 877,
    name: "NSK Bearings India Private Limited",
  },
  {
    id: 878,
    name: "Voith Paper Fabrics India Limited",
  },
  {
    id: 879,
    name: "Mangalore SEZ Limited",
  },
  {
    id: 880,
    name: "SUGNA METALS LIMITED",
  },
  {
    id: 881,
    name: "SANDEEP PAPER MILLS PVT LTD",
  },
  {
    id: 882,
    name: "JPS STEELS PRIVATE LIMITED",
  },
  {
    id: 883,
    name: "PACIFIC DEVELOPMENT CORPORATION LIMITED",
  },
  {
    id: 884,
    name: "LAKSHMI MACHINE WORKS LTD - MACHINE SHOP",
  },
  {
    id: 885,
    name: "LAKSHMI MACHINE WORKS LTD - UNIT-I",
  },
  {
    id: 886,
    name: "Shreemahakaal Concast Private Limited",
  },
  {
    id: 887,
    name: "CHL LIMITED",
  },
  {
    id: 888,
    name: "Birla Corporation Limited",
  },
  {
    id: 889,
    name: "SNJ SYNTHETICS LIMITED",
  },
  {
    id: 890,
    name: "ARS Steels and Alloy International  Private limited",
  },
  {
    id: 891,
    name: "SHIVA TEXYARN LIMITED",
  },
  {
    id: 892,
    name: "Madras Engineering Industries Private Limited",
  },
  {
    id: 893,
    name: "Sundaram Clayton Ltd  HTSC 903",
  },
  {
    id: 894,
    name: "VACMET INDIA LIMITED",
  },
  {
    id: 895,
    name: "B S ISPAT LIMITED",
  },
  {
    id: 896,
    name: "Anangoor Textile Mills Pvt Ltd (HTSC 201)",
  },
  {
    id: 897,
    name: "Anangoor Textile Mills Pvt Ltd (HTSC 443)",
  },
  {
    id: 898,
    name: "The Ramaraju Surgical Cotton Mills Limited",
  },
  {
    id: 899,
    name: "ORIENT BOARD AND PAPER MILLS PRIVATE LIMITED",
  },
  {
    id: 900,
    name: "DIVINE INFRACON PRIVATE LIMITED",
  },
  {
    id: 901,
    name: "GLAND PHARMA LIMTED",
  },
  {
    id: 902,
    name: "SANDFITS FOUNDRIES PRIVATE LIMITED",
  },
  {
    id: 903,
    name: "ARUPPUKOTTAI SHRI RAMALINGA SPINNERS PRIVATE LIMITED",
  },
  {
    id: 904,
    name: "HI TEC DIE CAST PRIVATE LIMITED",
  },
  {
    id: 905,
    name: "Asahi India Glass Limited, Rewari",
  },
  {
    id: 906,
    name: "INOX AIR PRODUCTS PRIVATE LIMITED, MODINAGAR",
  },
  {
    id: 907,
    name: "Ginni Filaments Limited (Mathura)",
  },
  {
    id: 908,
    name: "LAURUS LABS LIMITED",
  },
  {
    id: 909,
    name: "My Home Industries Private Limited",
  },
  {
    id: 910,
    name: "Rohini Textile Industry Pvt Ltd",
  },
  {
    id: 911,
    name: "INOX AIR PRODUCTS PRIVATE LIMITED, NOIDA",
  },
  {
    id: 912,
    name: "GLAND PHARMA LIMITED MCL766",
  },
  {
    id: 913,
    name: "KASIM TEXTILE MILLS PRIVATE LIMITED HT-0255",
  },
  {
    id: 914,
    name: "Rialto Enterprises Pvt. Ltd.",
  },
  {
    id: 915,
    name: "HPCL MITTAL PIPELINES LTD Cons. No.29603",
  },
  {
    id: 916,
    name: "BHAVANI INDUSTRIES INDIA LLP",
  },
  {
    id: 917,
    name: "CHETTINAD CEMENT CORPORATION PRIVATE LIMITED (KARIKALI WORKS)",
  },
  {
    id: 918,
    name: "India Yamaha Motor Private Limited",
  },
  {
    id: 919,
    name: "SHIRAGUPPI SUGAR WORKS LIMITED",
  },
  {
    id: 920,
    name: "Hindustan Coca Cola Beverages Pvt Ltd",
  },
  {
    id: 921,
    name: "HINDUSTHAN NATIONAL GLASS & INDUSTRIES LIMITED HARYANA",
  },
  {
    id: 922,
    name: "MICHELIN INDIA PRIVATE LIMITED",
  },
  {
    id: 923,
    name: "NEPAL ELECTRICITY AUTHORITY-MIDDLE MARSYANGDI",
  },
  {
    id: 924,
    name: "MAITHAN ALLOYS LIMITED",
  },
  {
    id: 925,
    name: "TAJ SATS AIR CATERING LIMITED",
  },
  {
    id: 926,
    name: "SHREE RENUKA SUGARS LIMITED ATHANI",
  },
  {
    id: 927,
    name: "SHREE RENUKA SUGARS LIMITED MUNOLI",
  },
  {
    id: 928,
    name: "SHREE RENUKA SUGARS LIMITED HAVALGA",
  },
  {
    id: 929,
    name: "AADHI VINAYAGA SPINNERS",
  },
  {
    id: 930,
    name: "TAMIL NADU NEWSPRINT AND PAPERS LIMITED  UNIT 1",
  },
  {
    id: 931,
    name: "Tamilnadu Petroproducts Limited",
  },
  {
    id: 932,
    name: "KANDAGIRI SPINNING MILLS LIMITED",
  },
  {
    id: 933,
    name: "AACHI MASALA FOODS PVT LTD HTSC 2009",
  },
  {
    id: 934,
    name: "SAMBANDAM SIVA TEXTILES PRIVATE LIMITED",
  },
  {
    id: 935,
    name: "Tasoula Energy Private Limited",
  },
  {
    id: 936,
    name: "HPCL MITTAL PIPELINES LIMITED",
  },
  {
    id: 937,
    name: "ENERSHELL ALLOYS AND STEEL PRIVATE LIMITED",
  },
  {
    id: 938,
    name: "HINDALCO INDUSTRIES LIMITED- HINSLDCD04",
  },
  {
    id: 939,
    name: "Saudagar Enterprise",
  },
  {
    id: 940,
    name: "DHARANI TEXTILES PRIVATE LIMITED HTSC-0135",
  },
  {
    id: 941,
    name: "FREE LOOK FASHIONS",
  },
  {
    id: 942,
    name: "SRI VENKATA LAKSHMI NARASIMHA SPINNING MILLS PRIVATE LIMITED GNT762",
  },
  {
    id: 943,
    name: "N S P KNITTING MILLS",
  },
  {
    id: 944,
    name: "TAMILNADU GENERATION AND DISTRIBUTION CORPORATION LIMITED",
  },
  {
    id: 945,
    name: "Sudarsanam Spinning Mills(HT SC 0005)",
  },
  {
    id: 946,
    name: "GAIL INDIA LIMITED,PATA",
  },
  {
    id: 947,
    name: "ACC LIMITED, HP",
  },
  {
    id: 948,
    name: "SRIPATHI PAPER & BOARDS PRIVATE LIMITED UNIT-II",
  },
  {
    id: 949,
    name: "RAJAPALAYAM MILLS LIMITED FABRIC DIVISION",
  },
  {
    id: 950,
    name: "KPR SUGAR MILL LIMITED",
  },
  {
    id: 951,
    name: "Premier Tyres Ltd",
  },
  {
    id: 952,
    name: "BASF CATALYSTS INDIA PRIVATE LIMITED",
  },
  {
    id: 953,
    name: "AUROBINDO PHARMA LTD unit8",
  },
  {
    id: 954,
    name: "Aurobindo pharma ltd unit SGR644",
  },
  {
    id: 955,
    name: "EVEREADY SPINNING MILLS PVT.LTD - UNIT - IV HTSC-0347",
  },
  {
    id: 956,
    name: "VEEJAY YARNS & FABRICS PRIVATE LIMITED",
  },
  {
    id: 957,
    name: "SRI KRISHNA ALLOYS",
  },
  {
    id: 958,
    name: "GRETA ENERGY LIMITED",
  },
  {
    id: 959,
    name: "Polyhose India Rubber Pvt  Ltd  HTSC 452",
  },
  {
    id: 960,
    name: "CAPARO ENGINEERING INDIA LIMITED - FORGING 632",
  },
  {
    id: 961,
    name: "RANGER COTTON MILLS INDIA PVT LTD",
  },
  {
    id: 962,
    name: "Lloyds Metals And Energy Limited",
  },
  {
    id: 963,
    name: "MAHA SHIV SHAKTI STEEL ROLLING MILLS PVT LIMITED RJN1927",
  },
  {
    id: 964,
    name: "SUDARSHAN BEOPAR COMPANY LIMITED",
  },
  {
    id: 965,
    name: "RELIANCE CHEMOTEX INDUSTRIES LIMITED",
  },
  {
    id: 966,
    name: "Prakash Industries Limited,Champa",
  },
  {
    id: 967,
    name: "Antique Marbonite  Pvt Limited",
  },
  {
    id: 968,
    name: "ITC Limited PSPD Bollaram",
  },
  {
    id: 969,
    name: "Acecon Vitrified Pvt Ltd",
  },
  {
    id: 970,
    name: "LINDE INDIA LIMITED",
  },
  {
    id: 971,
    name: "Ultratech Cement Limited, Unit - Jhajjar Cement Works, Jharli",
  },
  {
    id: 972,
    name: "Sundram Fasteners Limited HTSC 1688",
  },
  {
    id: 973,
    name: "AUROBINDO PHARMA LTD UNIT III",
  },
  {
    id: 974,
    name: "SRI VENKATESWARA SPINNING MILLS",
  },
  {
    id: 975,
    name: "VEEJAY SYNTEX PRIVATE LIMITED",
  },
  {
    id: 976,
    name: "JSW CEMENT LIMITED,KALINGANAGAR",
  },
  {
    id: 977,
    name: "JSW ENERGY LIMITED, KARNATAKA",
  },
  {
    id: 978,
    name: "Hoin mal sons enterprises Private Limited",
  },
  {
    id: 979,
    name: "HINDUSTAN PETROLEUM CORPORATION LTD",
  },
  {
    id: 980,
    name: "RAMYA SPINNING MILLS PRIVATE LIMITED",
  },
  {
    id: 981,
    name: "SIFCO METAL INDUSTRIES",
  },
  {
    id: 982,
    name: "NARBHERAM POWER AND STEEL PRIVATE LIMITED",
  },
  {
    id: 983,
    name: "MUNJAL KIRIU INDUSTRIES PVT LTD",
  },
  {
    id: 984,
    name: "UMASHAKTI STEELS PRIVATE LIMITED",
  },
  {
    id: 985,
    name: "Dalmia Cement Bharat Limited",
  },
  {
    id: 986,
    name: "PPG ASIAN PAINTS PRIVATE LIMITED",
  },
  {
    id: 987,
    name: "SRI DHANALAKSHMI COTTON & RICE MILLS PRIVATE LIMITED",
  },
  {
    id: 988,
    name: "TATA STEEL LIMITED @400 kV",
  },
  {
    id: 989,
    name: "M/s. GUJARAT ALKALIES AND CHEMICALS LIMITED - 13032",
  },
  {
    id: 990,
    name: "KAVERI YARNS AND FABRICS LIMITED",
  },
  {
    id: 991,
    name: "Garden Silk Mills Ltd, Jolwa Division",
  },
  {
    id: 992,
    name: "ANANTHAPUR ENERGY PROJECTS PRIVATE LIMITED1",
  },
  {
    id: 993,
    name: "Adani Power Ltd-Stage-3 (U-9)",
  },
  {
    id: 994,
    name: "SURIYA SPINNING MILLS",
  },
  {
    id: 995,
    name: "KALLAM TEXTILES LIMITED1155",
  },
  {
    id: 996,
    name: "Hindware Limited, Bahadurgarh",
  },
  {
    id: 997,
    name: "JAI JAGDAMBA METALLOYS LIMITED",
  },
  {
    id: 998,
    name: "India Dyeing Mills P Ltd HTSC-69",
  },
  {
    id: 999,
    name: "DMRC LTD  THROUGH CONCESSIONAIRE M/S PACIFIC DEVELOPMENT CORPORATION LIMITED",
  },
  {
    id: 1000,
    name: "Max Super Speciality Hospital",
  },
  {
    id: 1001,
    name: "SHREE SHAILJA IRON AND STEELS PRIVATE LIMITED",
  },
  {
    id: 1002,
    name: "SALASAAR IRON AND STEELS PVT LTD",
  },
  {
    id: 1003,
    name: "Supertex Mills (India) Pvt Ltd",
  },
  {
    id: 1004,
    name: "SANTHI PROCESSING UNIT PRIVATE LIMITED",
  },
  {
    id: 1005,
    name: "PMP IRON AND STEELS INDIA LTD",
  },
  {
    id: 1006,
    name: "AUROBINDO PHARMA LTD UNIT 5",
  },
  {
    id: 1007,
    name: "SRI RAAM DYEING FACTORY HTSC 0126",
  },
  {
    id: 1008,
    name: "SATHAVAHANA ISPAT LIMITED",
  },
  {
    id: 1009,
    name: "TIRUPATHY YARNTEX SPINNERS PRIVATE LIMITED",
  },
  {
    id: 1010,
    name: "Poomer Spinning mills",
  },
  {
    id: 1011,
    name: "AMRIT BOTTLERS PRIVATE LIMITED-FAIZABAD",
  },
  {
    id: 1012,
    name: "SMARTCHEM TECHNOLOGIES LIMITED SKL092",
  },
  {
    id: 1013,
    name: "BPCL (99917)",
  },
  {
    id: 1014,
    name: "INDO MIM PRIVATE LIMITED",
  },
  {
    id: 1015,
    name: "JAMMU & KASHMIR STATE POWER DEVELOPMENT COPRPORATION LIMITED",
  },
  {
    id: 1016,
    name: "Deccan Fine Chemicals (India) Pvt Ltd Cons.No.39600",
  },
  {
    id: 1017,
    name: "SONAL IRONS INDUSTRY PRIVATE LIMITED HTSC-0354",
  },
  {
    id: 1018,
    name: "RANA STEELS INDIA LTD.( UNIT-2)",
  },
  {
    id: 1019,
    name: "Athani Sugars Ltd",
  },
  {
    id: 1020,
    name: "SMRC AUTOMOTIVE PRODUCTS INDIA LIMITED",
  },
  {
    id: 1021,
    name: "Hindustan Zinc Limited Zawar",
  },
  {
    id: 1022,
    name: "KSV COTTON MILLS PRIVATE LIMITED",
  },
  {
    id: 1023,
    name: "Hyundai Motor India Ltd HTSC-277",
  },
  {
    id: 1024,
    name: "BRAKES INDIA PRIVATE LTD HTSC 1113",
  },
  {
    id: 1025,
    name: "ISGEC Heavy Engineering Limited, Uttar Pradesh",
  },
  {
    id: 1026,
    name: "GUJARAT NARMADA VALLEY FERTILIZERS & CHEMICALS LTD CONS. NO. 39014",
  },
  {
    id: 1027,
    name: "TOYOTA TSUSHO INDIA PRIVATE LIMITED",
  },
  {
    id: 1028,
    name: "EASTERNBULK LIME PRODUCTS PRIVATE LIMITED HTSC_350",
  },
  {
    id: 1029,
    name: "K.G.S Mills Unit of The Kadri Mills(CBE) Private Limited.",
  },
  {
    id: 1030,
    name: "MSN LABORATORIES PRIVATE LIMITED",
  },
  {
    id: 1031,
    name: "AVANEETHA TEXTILES (P) LTD",
  },
  {
    id: 1032,
    name: "AUROFOOD PVT.LTD HT SC 0038",
  },
  {
    id: 1033,
    name: "BHALKESHWAR SUGAR",
  },
  {
    id: 1034,
    name: "Parth Engineering",
  },
  {
    id: 1035,
    name: "SPARSH INDUSTRIES PRIVATE LIMITED",
  },
  {
    id: 1036,
    name: "SGD PHARMA INDIA LIMITED 983",
  },
  {
    id: 1037,
    name: "Simhadri FSP 15 MW",
  },
  {
    id: 1038,
    name: "Simhadri Floating solar (10 MW)",
  },
  {
    id: 1039,
    name: "SREE PALANI ANDAVAR ALLOYS AND STEELS PRIVATE LIMITED (HTSC_346)",
  },
  {
    id: 1040,
    name: "Akshara Spinning Mills Private Limited HTSC 137",
  },
  {
    id: 1041,
    name: "SRI PARAMESWARI SPINNING MILLS PRIVATE LIMITED (HTSC-0249)",
  },
  {
    id: 1042,
    name: "THE K C P LIMITED",
  },
  {
    id: 1043,
    name: "SALAL POWER STATION",
  },
  {
    id: 1044,
    name: "SHAMANUR SUGARS LIMITED",
  },
  {
    id: 1045,
    name: "Bhuvaneswari Cotspin India P Ltd Unit 2",
  },
  {
    id: 1046,
    name: "TRISHULI NEPAL ELECTRICITY AUTHORITY",
  },
  {
    id: 1047,
    name: "PALLAVA TEXTILES PRIVATE LIMITED (HTSC-0261)",
  },
  {
    id: 1048,
    name: "Vish Wind Infrastrukture LLP Phase III",
  },
  {
    id: 1049,
    name: "MATSAYANAYAGI STEELS AND FOUNDRIES PRIVATE LIMITED",
  },
  {
    id: 1050,
    name: "SD International Pvt Ltd (AL-18B & 19)",
  },
  {
    id: 1051,
    name: "SRI SARAVANA MILLS PRIVATE LIMITED UNIT SSM FINE YARNS",
  },
  {
    id: 1052,
    name: "GHCL LIMITED HTSC 3",
  },
  {
    id: 1053,
    name: "SRI SARAVANA MILLS PRIVATE LIMITED SPINNING UNIT I",
  },
  {
    id: 1054,
    name: "MS AGARWAL FOUNDRIES PVT LTD",
  },
  {
    id: 1055,
    name: "SRG Apparels Limited",
  },
  {
    id: 1056,
    name: "Pioneer Jellice India Private Limited",
  },
  {
    id: 1057,
    name: "SRI RAMCO SPINNERS",
  },
  {
    id: 1058,
    name: "LIKHU-iV NEA",
  },
  {
    id: 1059,
    name: "DEVIGHAT NEPAL ELECTRICITY AUTHORITY",
  },
  {
    id: 1060,
    name: "KALI GANDAKI NEPAL ELECTRICITY AUTHORITY",
  },
  {
    id: 1061,
    name: "MARSYANGDI NEPAL ELECTRICITY AUTHORITY",
  },
  {
    id: 1062,
    name: "DAVANAGERE SUGAR COMPANY LTD",
  },
  {
    id: 1063,
    name: "PALLAVA TEXTILES PRIVATE LIMITED(HT.SC.NO.300)",
  },
  {
    id: 1064,
    name: "PALLAVA TEXTILES PRIVATE LIMITED(HT.SC.NO.279)",
  },
  {
    id: 1065,
    name: "EID PARRY BAGALKOT",
  },
  {
    id: 1066,
    name: "INTERNATIONAL TOBACCO CO. LTD",
  },
  {
    id: 1067,
    name: "ORBION PHARMACEUTICALS PRIVATE LIMITED",
  },
  {
    id: 1068,
    name: "SRI JAYAJOTHI AND COMPANY PRIVATE LIMITED (HTSC-0170)",
  },
  {
    id: 1069,
    name: "VIRAJ STEEL & Energy Pvt.Ltd",
  },
  {
    id: 1070,
    name: "Malladi Drugs and Pharmaceuticals Limited",
  },
  {
    id: 1071,
    name: "Tamilnadu Petroproducts Limited HTSC 1584",
  },
  {
    id: 1072,
    name: "Adani Power Ltd Stage-3 (U-7&8)",
  },
  {
    id: 1073,
    name: "Sasan Power Limited",
  },
  {
    id: 1074,
    name: "JAGRITI STEEL PRIVATE LIMITED RJN1102",
  },
  {
    id: 1075,
    name: "KARTHIKEYA PAPER AND BOARDS LTD",
  },
  {
    id: 1076,
    name: "Otsuka Pharmaceutical India Pvt Ltd",
  },
  {
    id: 1077,
    name: "GUNTUR SPINNING MILLS PRIVATE LIMITED",
  },
  {
    id: 1078,
    name: "Woco Tech Elastomere Noida Limited",
  },
  {
    id: 1079,
    name: "ASTRAL LTD CON.18396",
  },
  {
    id: 1080,
    name: "BRIJBIHARI CONCAST PRIVATE LIMITED",
  },
  {
    id: 1081,
    name: "SUDHESH INDUSTRIES PRIVATE LIMITED",
  },
  {
    id: 1082,
    name: "Indian additives limited 1550",
  },
  {
    id: 1083,
    name: "RAJAPALAYAM MILLS LIMITED, D UNIT",
  },
  {
    id: 1084,
    name: "JK TYRE & INDUSTRIES LTD HTSC 917",
  },
  {
    id: 1085,
    name: "SRI DHANALAKSHMI COTTON & RICE MILLS PRIVATE LIMITED Textile Division",
  },
  {
    id: 1086,
    name: "kanpur plastipack limited D19-20 (UNIT-01)",
  },
  {
    id: 1087,
    name: "SBESS Services Projectco Two Private Limited",
  },
  {
    id: 1088,
    name: "JAYA VELU SPINNING MILLS PRIVATE LIMITED (HTSC_232)",
  },
  {
    id: 1089,
    name: "DRREDDYS LABORATORIESLIMITEDCTO",
  },
  {
    id: 1090,
    name: "Ambuja Cements Limited_Rauri",
  },
  {
    id: 1091,
    name: "Ambuja Cements Limited_Suli",
  },
  {
    id: 1092,
    name: "VISH WIND INFRASTRUKTURE LLP PHASE I",
  },
  {
    id: 1093,
    name: "SHAKTI KRAFTS & TISSUES",
  },
  {
    id: 1094,
    name: "BARNALA STEEL INDUSTRIES PRIVATE LIMITED",
  },
  {
    id: 1095,
    name: "JAYDEEP COTTON FIBRES PRIVATE LIMITED",
  },
  {
    id: 1096,
    name: "KOSEI MINDA ALUMINUM COMPANY PRIVATE LIMITED",
  },
  {
    id: 1097,
    name: "ARUPPUKOTTAI SRI JAYAVILAS PRIVATE LIMITED (HTSC-0068)",
  },
  {
    id: 1098,
    name: "Kalpana Cotton Mills",
  },
  {
    id: 1099,
    name: "Oil and Natural Gas Corporation Limited",
  },
  {
    id: 1100,
    name: "HSIL LIMITED",
  },
  {
    id: 1101,
    name: "MANSAROWAR ISPAT INDIA PRIVATE LIMITED",
  },
  {
    id: 1102,
    name: "Dalmia Laminators Limited Unit-2 HTSC 1963",
  },
  {
    id: 1103,
    name: "CHENNAI PETROLEUM CORPORATION LIMITED HTSC 1169",
  },
  {
    id: 1104,
    name: "Amrita Institute of  Medical Sciences And Research Centre",
  },
  {
    id: 1105,
    name: "Shree Radhey Radhey Ispat Private Limited",
  },
  {
    id: 1106,
    name: "BIRD AIRPORT HOTEL PRIVATE LIMITED",
  },
  {
    id: 1107,
    name: "The Pudukkottai  District Co operative  Spinning Mills Ltd",
  },
  {
    id: 1108,
    name: "JK TYRE & INDUSTRIES LIMITED,TRUCK RADIAL, PLANT-2",
  },
  {
    id: 1110,
    name: "Dadra and Nagar Haveli and Daman and Diu Power Distribution Corporation Lim",
  },
  {
    id: 1111,
    name: "HINDUSTHAN NATIONAL GLASS & INDUSTRIES LIMITED, UTTARAKHAND- HINSLDCD44",
  },
  {
    id: 1112,
    name: "NATCO PHARMA LIMITED-CHEMICAL DIVISION",
  },
  {
    id: 1113,
    name: "NATCO PHARMA LIMITED PHARMA DIVISION",
  },
  {
    id: 1114,
    name: "JAI HIND WIRE ROD MILLS LIMITED (HTSC_137)",
  },
  {
    id: 1115,
    name: "SRI LUXMI TULASI AGRO PAPER PVT LTD",
  },
  {
    id: 1116,
    name: "KWALITY MILK FOODS LTD",
  },
  {
    id: 1117,
    name: "ADANI WILMAR LIMITED",
  },
  {
    id: 1118,
    name: "Pressana Flour Mills Private Limited",
  },
  {
    id: 1119,
    name: "ABC Renewable Energy (RJ-01) Private Limited",
  },
  {
    id: 1120,
    name: "JINDAL INDUSTRIES PRIVATE LIMITED",
  },
  {
    id: 1121,
    name: "RAJAPALAIYAM TEXTILES",
  },
  {
    id: 1122,
    name: "SAINI ALLOYS LIMITED",
  },
  {
    id: 1123,
    name: "FERRO ALLOYS CORPORATION LIMITED",
  },
  {
    id: 1124,
    name: "HSIL LIMITED",
  },
  {
    id: 1125,
    name: "SOWMIYA TEXTILES PRIVATE LIMITED",
  },
  {
    id: 1126,
    name: "RANA INDUSTRIES",
  },
  {
    id: 1127,
    name: "RAJASTHAN TEXTILE MILLS",
  },
  {
    id: 1128,
    name: "TVS SRICHAKRA LIMITED",
  },
  {
    id: 1129,
    name: "DCM SHRIRAM LIMITED, Kota Rajasthan",
  },
  {
    id: 1130,
    name: "CHAMBAL FERTILISERS AND  CHEMICALS LTD",
  },
  {
    id: 1131,
    name: "LOYAL TEXTILE MILLS LTD (HT SC 70)",
  },
  {
    id: 1132,
    name: "Hindustan Unilever Limited",
  },
  {
    id: 1133,
    name: "Sri Hariprasath Textiles P ltd",
  },
  {
    id: 1134,
    name: "GOODYEAR INDIA LTD-BALLABGARH DISTT FARIDABAD(HR)",
  },
  {
    id: 1135,
    name: "Koyas Fasteners Private Limited HTSC 537",
  },
  {
    id: 1136,
    name: "Ramagundam Floating solar",
  },
  {
    id: 1137,
    name: "NATEMS SOLAR POWER PRIVATE LIMITED",
  },
  {
    id: 1138,
    name: "N G A STEELS PRIVATE LIMITED",
  },
  {
    id: 1139,
    name: "SNN Textiles Private Limited",
  },
  {
    id: 1140,
    name: "GRASIM INDUSTRIES LIMITED,CHEMICAL DIVISION ,GANJAM",
  },
  {
    id: 1141,
    name: "ARCELORMITTAL NIPPON STEEL INDIA LTD., Paradeep/Orissa",
  },
  {
    id: 1142,
    name: "Doyang HPS, NEEPCO",
  },
  {
    id: 1143,
    name: "THE KADRI MILLS (CBE) PRIVATE LIMITED",
  },
  {
    id: 1144,
    name: "Amrit Bottlers Pvt. Ltd. Hotel Hilton Garden Inn",
  },
  {
    id: 1145,
    name: "JC BIOTECH PRIVATE LIMITED 352",
  },
  {
    id: 1146,
    name: "ANUGRAHA FASHION MILL PRIVATE LIMITED",
  },
  {
    id: 1147,
    name: "EVEREADY SPINNING MILLS PVT. LTD - UNIT - II HTSC-0177",
  },
  {
    id: 1148,
    name: "P K LAXMI MILL INDIA PVT LTD",
  },
  {
    id: 1149,
    name: "SOUTH INDIA SPINNING MILLS PRIVATE LIMITED",
  },
  {
    id: 1150,
    name: "STEEL EXCHANGE INDIA LIMITED KOTHAPETA",
  },
  {
    id: 1151,
    name: "SANGAM MILK PRODUCER COMPANY LIMITED..",
  },
  {
    id: 1152,
    name: "SL LUMAX LIMITED",
  },
  {
    id: 1153,
    name: "STANDARD SPINNING AND WEAVING MILLS LIMITED",
  },
  {
    id: 1154,
    name: "GREENPANEL INDUSTRIES LIMITED-CHOTOOR-AP",
  },
  {
    id: 1155,
    name: "Adisankara Spinning Mills Private Limited",
  },
  {
    id: 1156,
    name: "Sundram Fasteners Limited HTSC 1496",
  },
  {
    id: 1157,
    name: "RELIANCE INDUSTRIES LIMITED PATALGANGA",
  },
  {
    id: 1158,
    name: "GINNI FILAMENTS LIMITED-GUJ",
  },
  {
    id: 1159,
    name: "UNITED FOUNDRIES PRIVATE LIMITED",
  },
  {
    id: 1160,
    name: "KUSALAVA INTERNATIONAL LTD VJA3243",
  },
  {
    id: 1161,
    name: "Denso Haryana Pvt. Ltd., Jhajjar",
  },
  {
    id: 1162,
    name: "Hindalco Industries Ltd ,Dahej",
  },
  {
    id: 1163,
    name: "DEEVYASHATI INDIA PRIVATE LIMITED",
  },
  {
    id: 1164,
    name: "LOYAL TEXTILE MILLS LTD",
  },
  {
    id: 1165,
    name: "GESTAMP AUTOMOTIVE CHENNAI PRIVATE LIMITED HTSC 955",
  },
  {
    id: 1166,
    name: "HIRANYAKESHI SAHAKARI SAKKARE KARKHANE NIYAMIT",
  },
  {
    id: 1167,
    name: "ASHOK PROCESS HTSC 0340",
  },
  {
    id: 1168,
    name: "K L RATHI STEELS LTD",
  },
  {
    id: 1169,
    name: "Sundram Fasteners Limited",
  },
  {
    id: 1170,
    name: "NTPC KOLDAM",
  },
  {
    id: 1171,
    name: "ADARSH KNITWEAR P LTD",
  },
  {
    id: 1172,
    name: "RANE (MADRAS) LIMITED SGR739",
  },
  {
    id: 1173,
    name: "MIOT HOSPITALS PRIVATE LIMITED",
  },
  {
    id: 1174,
    name: "BONFIGLIOLI TRANSMISSIONS PRIVATE LIMITED",
  },
  {
    id: 1175,
    name: "CAPARO ENGINEERING INDIA LTD",
  },
  {
    id: 1176,
    name: "NAVIN FLUORINE INTERNATIONAL LIMITED",
  },
  {
    id: 1177,
    name: "VALLI TEXTILE MILLS (HT SC 292)",
  },
  {
    id: 1178,
    name: "SMC Foods Limited",
  },
  {
    id: 1179,
    name: "Adani Wilmar Limited NLR401",
  },
  {
    id: 1180,
    name: "Adani Wilmar Limited (NLR541)",
  },
  {
    id: 1181,
    name: "Shri Mahavir Ferro Alloys Pvt. Limited",
  },
  {
    id: 1182,
    name: "BPCL (01426)",
  },
  {
    id: 1183,
    name: "BPCL (99918)",
  },
  {
    id: 1184,
    name: "India Power Corporation Limited",
  },
  {
    id: 1185,
    name: "BHARTI AIRTEL LIMITED (Moradabad)",
  },
  {
    id: 1186,
    name: "AMPLUS RJ SOLAR Pvt. Ltd",
  },
  {
    id: 1187,
    name: "VICTORY SPINNING MILLS PRIVATE LIMITED (HTSC-0351)",
  },
  {
    id: 1188,
    name: "VALLI TEXTILE MILLS (HTSC 65)",
  },
  {
    id: 1189,
    name: "Ultramarine & Pigments Ltd.",
  },
  {
    id: 1190,
    name: "TOPCEM INDIA",
  },
  {
    id: 1191,
    name: "Sundram Fasteners Limited- SUNSLDCD95",
  },
  {
    id: 1192,
    name: "I T C Limited ITC Centre Project",
  },
  {
    id: 1193,
    name: "SAINT - GOBAIN INDIA PRIVATE LIMITED.",
  },
  {
    id: 1194,
    name: "RAJAPALAYAM TEXTILE LIMITED",
  },
  {
    id: 1195,
    name: "TADAS WIND ENERGY PRIVATE LIMITED",
  },
  {
    id: 1196,
    name: "TAMIL NADU CEMENTS CORPORATION LIMITED",
  },
  {
    id: 1197,
    name: "THRIVENI EARTHMOVERS PRIVATE LIMITED - 527",
  },
  {
    id: 1198,
    name: "VODAFONE IDEA LIMITED, Udyog Nagar",
  },
  {
    id: 1199,
    name: "chettinad cement corporation private limited - Puliyur",
  },
  {
    id: 1200,
    name: "TAMIL NADU NEWSPRINT AND PAPERS LIMITED",
  },
  {
    id: 1201,
    name: "Kothari Sugars and Chemicals limited unit I",
  },
  {
    id: 1202,
    name: "ARUMUGA FABRICS PRIVATE LIMITED HTSC 0207",
  },
  {
    id: 1203,
    name: "VASANTHI FOUNDRY UNIT 003",
  },
  {
    id: 1204,
    name: "Delphi TVS Technologies Limited HT 678",
  },
  {
    id: 1205,
    name: "JAINARAIN FABTECH PRIVATE LIMITED",
  },
  {
    id: 1206,
    name: "MASS N-ERGY PRIVATE LIMITED",
  },
  {
    id: 1207,
    name: "MAGPIE HYDEL CONSTRUCTION OPERATION INDUSTRIES (P) LTD",
  },
  {
    id: 1208,
    name: "KDA ISPAT PVT LIMITED",
  },
  {
    id: 1209,
    name: "NOVARES INDIA AUTOMOTIVE PRIVATE LTD HTSC 766",
  },
  {
    id: 1210,
    name: "PAPER PACKAGING PRIVATE LIMITED",
  },
  {
    id: 1211,
    name: "Lucky Yarn Tex India Private Limited",
  },
  {
    id: 1212,
    name: "INDO SHELL CAST PRIVATE LIMITED(HTSC 232)",
  },
  {
    id: 1213,
    name: "INDO SHELLCAST PRIVATE LIMITED(HTSC 104)",
  },
  {
    id: 1214,
    name: "LULU INTERNATIONAL SHOPPING MALL PRIVATE LIMITED",
  },
  {
    id: 1215,
    name: "Rajpur Hydro Power Private Limited",
  },
  {
    id: 1216,
    name: "PARSONS NUTRITIONALS PRIVATE LIMITED",
  },
  {
    id: 1217,
    name: "Jay Bharat Maruti Limited Plant-3",
  },
  {
    id: 1218,
    name: "M/s Shell Energy India Pvt Ltd Cons No 11669",
  },
  {
    id: 1219,
    name: "Southern Alloy Foundries Private Limited HT 1100",
  },
  {
    id: 1220,
    name: "BAHL PAPER MILLS LIMITED",
  },
  {
    id: 1221,
    name: "BHAARATHI SPINTEX INDIA PRIVATE LIMITED (HTSC-0350)",
  },
  {
    id: 1222,
    name: "SUNDARAM CLAYTON LIMITED HTSC 737",
  },
  {
    id: 1223,
    name: "Platinum Alloys Private Limited",
  },
  {
    id: 1224,
    name: "DONGWOO SURFACETECH INDIA PRIVATE LIMITED",
  },
  {
    id: 1225,
    name: "PUNJAB GENERAL INDUSTRIES PRIVATE LIMITED",
  },
  {
    id: 1226,
    name: "Sadhu Forging Limited (Gear Div.)",
  },
  {
    id: 1227,
    name: "MRN CANE POWER INDIA LIMITED",
  },
  {
    id: 1228,
    name: "PGP Glass Pvt Ltd-Jambusar",
  },
  {
    id: 1229,
    name: "JAYANACHIAR TEXTILE MILLS (P) LTD",
  },
  {
    id: 1230,
    name: "RBA EXPORTS PVT LTD",
  },
  {
    id: 1231,
    name: "Aryam steels private limited",
  },
  {
    id: 1232,
    name: "SANDHYA SPINNING MILL LIMITED",
  },
  {
    id: 1233,
    name: "Mehala carona textiles (p) ltd (HTSC 118)",
  },
  {
    id: 1234,
    name: "Mehala carona textiles (p) ltd (HTSC 72)",
  },
  {
    id: 1235,
    name: "VTM LIMITED",
  },
  {
    id: 1236,
    name: "GUJARMAL MODI HOSPITAL AND RESEARCH CENTRE FOR MEDICAL SCIENCES",
  },
  {
    id: 1237,
    name: "NACHIAR SPINNING MILLS PRIVATE LIMITED",
  },
  {
    id: 1238,
    name: "Gujarat Fluorochemicals Limited-Ranjitnagar",
  },
  {
    id: 1239,
    name: "Ved Cellulose Limited",
  },
  {
    id: 1240,
    name: "Gokak Power and Energy Limited",
  },
  {
    id: 1241,
    name: "Sri Vasudeva Textiles Private Limited",
  },
  {
    id: 1242,
    name: "METROCHEM API PRIVATE LIMITED VSP1120",
  },
  {
    id: 1243,
    name: "TVS SRICHAKRA LIMITED (HTSC-126)",
  },
  {
    id: 1244,
    name: "AUTOMOTIVE AXLES LIMITED",
  },
  {
    id: 1245,
    name: "HINDUSTAN PETROLEUM CORPORATION LIMITED",
  },
  {
    id: 1246,
    name: "PRIDE HOTELS LIMITED",
  },
  {
    id: 1247,
    name: "BST Textile Mills Pvt Ltd",
  },
  {
    id: 1249,
    name: "MAX SPECIALITY FILMS LIMITED",
  },
  {
    id: 1250,
    name: "HARIOM PIPE INDUSTRIES LTD",
  },
  {
    id: 1251,
    name: "HINDUSTAN AERONAUTICS LIMITED",
  },
  {
    id: 1252,
    name: "ROCKMAN INDUSTRIES LIMITED,Bawal,Rewari,Haryana",
  },
  {
    id: 1253,
    name: "EL FORGE LIMITED",
  },
  {
    id: 1254,
    name: "ASHOK TEXTILE MILLS PRIVATE LIMITED HTSC-0181",
  },
  {
    id: 1255,
    name: "SRI VARI TEXTILES",
  },
  {
    id: 1256,
    name: "GROWEL PROCESSORS PRIVATE LIMITED",
  },
  {
    id: 1257,
    name: "MANGALORE COAL TERMINAL PRIVATE LIMITED",
  },
  {
    id: 1258,
    name: "vsm weavess india Pvt ltd (HTSC-0388)",
  },
  {
    id: 1259,
    name: "PSK ARUN TEX PRIVATE LIMITED",
  },
  {
    id: 1260,
    name: "Praxair India Private Limited",
  },
  {
    id: 1261,
    name: "Coastal Gujarat Power Limited",
  },
  {
    id: 1262,
    name: "Chettinad Cement Corporation Private Limited-Ariyalur",
  },
  {
    id: 1263,
    name: "SRI GOMATHY MILLS PRIVATELIMITED (HTSC -0004)",
  },
  {
    id: 1264,
    name: "SANGEETH TEXTILES PRIVATE LIMITED",
  },
  {
    id: 1265,
    name: "COTTON BLOSSOM INDIA PRIVATE LIMITED",
  },
  {
    id: 1266,
    name: "NTPC Kawas Solar PV",
  },
  {
    id: 1267,
    name: "ITC Limited ITD Munger",
  },
  {
    id: 1268,
    name: "NSL Sugars Limited (Aland)",
  },
  {
    id: 1269,
    name: "SHRI RATHI STEEL LIMITED",
  },
  {
    id: 1270,
    name: "GOPAL SPONGE & POWER PRIVATE LIMITED",
  },
  {
    id: 1271,
    name: "Tehri HPP",
  },
  {
    id: 1272,
    name: "Akshera Papers",
  },
  {
    id: 1273,
    name: "LOYAL TEXTILE MILLS LTD (HTSC 227)",
  },
  {
    id: 1274,
    name: "GAURSONS INDIA PRIVATE LIMITED",
  },
  {
    id: 1275,
    name: "INDIAN CANE POWER LTD",
  },
  {
    id: 1276,
    name: "AACHI MASALA FOODS PRIVATE LIMITED HTSC 2090",
  },
  {
    id: 1277,
    name: "GOLDEN SPINNING MILLS PRIVATE LTD",
  },
  {
    id: 1278,
    name: "MEENAKSHI SMELTER & ROLLERS PVT LTD-SGR787",
  },
  {
    id: 1279,
    name: "vsm weavess India Pvt ltd (HTSC-0454)",
  },
  {
    id: 1280,
    name: "DLF EMPORIO LIMITED",
  },
  {
    id: 1281,
    name: "DLF PROMENADE LIMITED",
  },
  {
    id: 1282,
    name: "SARAVANAGIRI SPINNING MILL PVT LTD",
  },
  {
    id: 1283,
    name: "THE KCP LIMITED GNT 327",
  },
  {
    id: 1284,
    name: "ASCENT CIRCUITS PVT LTD HTSC No.0246",
  },
  {
    id: 1285,
    name: "ADANI POWER LTD STAGE 1 (Unit No 1 to 4)",
  },
  {
    id: 1286,
    name: "SRI HARINI TEXTILES LIMITED",
  },
  {
    id: 1287,
    name: "THIAGARAJAR MILLS PRIVATE LIMITED (HTSC-0153)",
  },
  {
    id: 1288,
    name: "BRADKEN INDIA PRIVATE LIMITED",
  },
  {
    id: 1289,
    name: "RCCPL PRIVATE LIMITED RAEBARELI UTTAR PRADESH",
  },
  {
    id: 1290,
    name: "TUBEINVESTMENTSOFINDIALIMITED UNIT TIDCINDIA",
  },
  {
    id: 1291,
    name: "Grasim Industries Limited Unit:Indian Rayon",
  },
  {
    id: 1292,
    name: "Gujarat Narmada Valley Fertilizers & Chemicals Ltd-No.40562",
  },
  {
    id: 1293,
    name: "KKP SPINNING MILLS PRIVATE LIMITED (HTSC_175)",
  },
  {
    id: 1294,
    name: "Deepak Phenolics Ltd",
  },
  {
    id: 1295,
    name: "ZUARI CEMENT LIMITED KADAPA",
  },
  {
    id: 1296,
    name: "Sri Periyanayaki Amman Spinning Mills",
  },
  {
    id: 1297,
    name: "TATA MOTORS LIMITED,PANTNAGAR",
  },
  {
    id: 1298,
    name: "SHREE DIGVIJAY CEMENT CO LIMITED",
  },
  {
    id: 1299,
    name: "MAGPIE HYDEL CONSTRUCTION OPERATION INDUSTRIES PVT LTD",
  },
  {
    id: 1300,
    name: "Shah alloys Ltd, Santej",
  },
  {
    id: 1301,
    name: "THRIVENI EARTHMOVERS PRIVATE LIMITED - 329",
  },
  {
    id: 1302,
    name: "Sri Kumaraguru Mill Limited",
  },
  {
    id: 1303,
    name: "Chuzachen HEP",
  },
  {
    id: 1304,
    name: "KRV Spinning Mills Private Limited",
  },
  {
    id: 1305,
    name: "JAGANNATH TEXTILE COMPANY LIMITED",
  },
  {
    id: 1306,
    name: "NIRMAL FIBRES PRIVATE LIMITED",
  },
  {
    id: 1307,
    name: "HINDUSTAN TEXTILES B UNIT HTSC 99",
  },
  {
    id: 1308,
    name: "OPG Power Generation Private Limited 230KV",
  },
  {
    id: 1309,
    name: "M/s IFFCO(Plant-Kandla)",
  },
  {
    id: 1310,
    name: "Vish Wind Infrastrukture LLP Phase II",
  },
  {
    id: 1311,
    name: "ITC Limited PSPD BCM",
  },
  {
    id: 1312,
    name: "Sundram Fasteners Limited HTSC 1396",
  },
  {
    id: 1313,
    name: "Kumaragiri Spinnerss Pvt Ltd UNIT-2",
  },
  {
    id: 1314,
    name: "PIRAMAL PHARMA LIMITED",
  },
  {
    id: 1315,
    name: "STEEL STRIPS WHEELS LTD",
  },
  {
    id: 1316,
    name: "TRAVANCORE TITANIUM PRODUCTS LIMITED",
  },
  {
    id: 1317,
    name: "SRI JAYAJOTHI AND COMPANY PRIVATE LIMITED (HTSC-0228)",
  },
  {
    id: 1318,
    name: "Tanda Cement Works (A unit of Ultratech Cement Limited)",
  },
  {
    id: 1319,
    name: "SHUBHLAXMI POLYTEX LIMITED",
  },
  {
    id: 1320,
    name: "Shri Jagannath Steels & Power Ltd",
  },
  {
    id: 1321,
    name: "MOTHERSON SUMI SYSTEMS LIMITED HTSC-1376",
  },
  {
    id: 1322,
    name: "WELSPUN METALLICS LIMITED.Con.No.33362",
  },
  {
    id: 1323,
    name: "TORRENT PHARMACEUTICAL LIMITED",
  },
  {
    id: 1324,
    name: "SD International Private Limited (BL-12)",
  },
  {
    id: 1325,
    name: "KPR SUGAR AND APPEARLS LIMITED",
  },
  {
    id: 1326,
    name: "ESWAR RUBBER PRODUCTS PVT LTD",
  },
  {
    id: 1327,
    name: "Mohan Spintex India Limited, Unit 4, Mallavalli",
  },
  {
    id: 1328,
    name: "TOYOTA KIRLOSKAR AUTO PARTS PRIVATE LIMITED",
  },
  {
    id: 1329,
    name: "NILACHAL SPINNING MILLS PRIVATE LIMITED",
  },
  {
    id: 1330,
    name: "ARAVIND CERAMICS INDUSTRIES LTD",
  },
  {
    id: 1331,
    name: "Jaypee Bina Thermal Power Plant",
  },
  {
    id: 1332,
    name: "SA Textiless Private Limited",
  },
  {
    id: 1333,
    name: "SRI VIGNESH YARNS PRIVATE LIMITED",
  },
  {
    id: 1334,
    name: "S.S.SPINNING MILLS",
  },
  {
    id: 1335,
    name: "ADANI HYBRID ENERGY JAISALMER THREE LIMITED AHS",
  },
  {
    id: 1336,
    name: "ADANI HYBRID ENERGY JAISALMER THREE LIMITED AHW",
  },
  {
    id: 1337,
    name: "OPG Energy Private Limited",
  },
  {
    id: 1338,
    name: "VEHLNA STEELS AND ALLOYS PRIVATE LIMITED",
  },
  {
    id: 1339,
    name: "SWASTIK GRAINS PRODUCTS PRIVATE LIMITED",
  },
  {
    id: 1340,
    name: "TANJORE POWER LIMITED",
  },
  {
    id: 1341,
    name: "THE RAMCO CEMENTS LIMITED- THESLDCD66",
  },
  {
    id: 1342,
    name: "RAJAPALAYAM MILLS LIMITED, C UNIT",
  },
  {
    id: 1343,
    name: "KPR Mill Limited - Garments DIvision",
  },
  {
    id: 1344,
    name: "SRI VISHNU SHANKAR MILL LIMITED",
  },
  {
    id: 1345,
    name: "JINDAL QUALITY TUBULAR LIMITED",
  },
  {
    id: 1346,
    name: "KISHANGANGA POWER STATION",
  },
  {
    id: 1347,
    name: "URI II POWER STATION",
  },
  {
    id: 1348,
    name: "CHAMERA II  POWER STATION",
  },
  {
    id: 1349,
    name: "GOODLUCK ENGINEERING COMPANY",
  },
  {
    id: 1350,
    name: "TVS SRICHAKRA LIMITED (HTSC-0045)",
  },
  {
    id: 1351,
    name: "SURYA BATTERIES",
  },
  {
    id: 1352,
    name: "The Metal Powder Company Limited",
  },
  {
    id: 1353,
    name: "ASHOK LEYLAND LIMITED (HTSC_24)",
  },
  {
    id: 1354,
    name: "HERO MOTOCORP LIMITED",
  },
  {
    id: 1355,
    name: "GODAVARI BIOREFINERIES LIMITED",
  },
  {
    id: 1356,
    name: "PFIZER HEALTHCARE INDIA PRIVATE LIMITED",
  },
  {
    id: 1357,
    name: "LINCOLN ELECTRIC COMPANY (INDIA) PRIVATE LIMITED HTSC 701.",
  },
  {
    id: 1358,
    name: "AADITIYA ASWIN PAPER MILL PVT LTD",
  },
  {
    id: 1359,
    name: "NEKKANTI MEGA FOOD PARK PRIVATE LIMITED",
  },
  {
    id: 1360,
    name: "VASAVADATTA CEMENT PROP KESORAM INDUSTRIES SEDAM LIMITED",
  },
  {
    id: 1361,
    name: "DHAKSHAN TEXTILES PRIVATE LIMITED (HTSC_92)",
  },
  {
    id: 1362,
    name: "SRI JAGANNATHA SPINNERS PRIVATE LIMITED HTSC 106",
  },
  {
    id: 1363,
    name: "SRI CHAMUNDESWARI SUGARS LIMITED",
  },
  {
    id: 1364,
    name: "CARBORUNDUM UNIVERSAL LIMITED HTSC0028",
  },
  {
    id: 1365,
    name: "CARBORUNDUM UNIVERSAL LIMITED HTSC 1024",
  },
  {
    id: 1366,
    name: "Rungta Mines Ltd Karakolha SID",
  },
  {
    id: 1367,
    name: "P I Industries Ltd Cons.No.39453",
  },
  {
    id: 1368,
    name: "Hindustan Zinc Limited Dariba",
  },
  {
    id: 1369,
    name: "Hindustan Zinc Limited Chanderia",
  },
  {
    id: 1370,
    name: "UltraTech Cement Limited- ULTSLDCD70",
  },
  {
    id: 1371,
    name: "Ruchi Soya Industries Ltd",
  },
  {
    id: 1372,
    name: "Saint Gobain India Pvt Ltd",
  },
  {
    id: 1373,
    name: "HARIMADHAVAA ALLOYS PRIVATE LIMITED",
  },
  {
    id: 1374,
    name: "DEV SHREE COTSYN PRIVATE LIMITED",
  },
  {
    id: 1375,
    name: "SRIPATHI PAPER AND BOARDS (P) LTD",
  },
  {
    id: 1376,
    name: "VICTUS DYEINGS",
  },
  {
    id: 1377,
    name: "JOCIL LIMITED",
  },
  {
    id: 1378,
    name: "BANNARI AMMAN SUGARS LIMITED, ALAGANCHI",
  },
  {
    id: 1379,
    name: "SRI MOULI TEXTILES PRIVATE LIMITED",
  },
  {
    id: 1380,
    name: "PUSHPIT STEELS PRIVATE LIMITED",
  },
  {
    id: 1381,
    name: "ITC Mughal Sheraton",
  },
  {
    id: 1382,
    name: "GE (UTILITY) M.E.S. CHANDIMANDIR",
  },
  {
    id: 1383,
    name: "Sawra Kuddu HEP",
  },
  {
    id: 1384,
    name: "SRI SUBAM TEXTILES (HTSC_162)",
  },
  {
    id: 1385,
    name: "RANGA WEAVES INDIA PRIVATE LIMITED",
  },
  {
    id: 1386,
    name: "ACSEN TEX (P)LTD",
  },
  {
    id: 1387,
    name: "Sri Navdurga Billets Pvt Ltd MBN725",
  },
  {
    id: 1388,
    name: "MEJA URJA NIGAM PRIVATE LIMITED",
  },
  {
    id: 1389,
    name: "Bhuvaneswari Cotspin India P Ltd",
  },
  {
    id: 1390,
    name: "Adani Wilmar Ltd Cons.No.62671",
  },
  {
    id: 1391,
    name: "SUNIL ISPAT AND POWER PRIVATE LIMITED",
  },
  {
    id: 1392,
    name: "SREENIVASA BALAJI PAPERS PVT LTD",
  },
  {
    id: 1393,
    name: "ITC Limited Corporate Office Kolkatta",
  },
  {
    id: 1394,
    name: "U.S.M.ALLOYS & CASTINGS PVT LTD",
  },
  {
    id: 1395,
    name: "Narmada Sugar Pvt. Ltd.",
  },
  {
    id: 1396,
    name: "KJS AHLUWALIA, Steel and Power Divison",
  },
  {
    id: 1397,
    name: "Sundaram Clayton Ltd HTSC 1290",
  },
  {
    id: 1398,
    name: "Lucas TVS Limited",
  },
  {
    id: 1399,
    name: "NALCO METAL PRODUCTS LIMITED",
  },
  {
    id: 1400,
    name: "Sundram Fasteners Limited HTSC 23",
  },
  {
    id: 1401,
    name: "Sundram Fasteners Limited HTSC 1739",
  },
  {
    id: 1402,
    name: "V. O. CHIDAMBARANAR PORT AUTHORITY",
  },
  {
    id: 1403,
    name: "Sundram Fasteners Limited HTSC 1150",
  },
  {
    id: 1404,
    name: "Indian Steel Co. Ltd",
  },
  {
    id: 1405,
    name: "KUNDAN CASTINGS PRIVATE LIMITED",
  },
  {
    id: 1406,
    name: "Shri Ramalinga Mills Private Limited",
  },
  {
    id: 1407,
    name: "Banaskantha District Co operative Milk Producers Union Ltd",
  },
  {
    id: 1408,
    name: "Mrinal spinning mills (UNIT II)(Unit of Rakshas Enterprises)",
  },
  {
    id: 1409,
    name: "STEEL AUTHORITY OF INDIA LIMITED,ROURKELA STEEL PLANT",
  },
  {
    id: 1410,
    name: "DR REDDYS LABORATORIES LIMITED unit 1",
  },
  {
    id: 1411,
    name: "JSW ISPAT SPECIAL PRODUCTS LIMITED",
  },
  {
    id: 1412,
    name: "Brindavan Bottlers Private Limited, Unnao Unit",
  },
  {
    id: 1413,
    name: "Bannari Amman Sugars Limited, Alathukombai",
  },
  {
    id: 1414,
    name: "J K Cement Ltd Cons.No.60614",
  },
  {
    id: 1415,
    name: "Naga Limited",
  },
  {
    id: 1416,
    name: "Naga Limited Foods HTSC 27",
  },
  {
    id: 1417,
    name: "THE KANYAKUMARI DISTRICT COOPERATIVE SPINNING MILLS LTD",
  },
  {
    id: 1418,
    name: "Ultratech Cement Limited (Unit Aligarh Cement Works)",
  },
  {
    id: 1419,
    name: "WORLD WIDE IRON & STEELS PRIVATE LIMITED",
  },
  {
    id: 1420,
    name: "SMS LIFESCIENCES INDIA LIMITED",
  },
  {
    id: 1421,
    name: "ELLENBARRIE INDUSTRIAL GASES LIMITED",
  },
  {
    id: 1422,
    name: "Agarwal foundries",
  },
  {
    id: 1423,
    name: "JK Tyre & Industries Limited",
  },
  {
    id: 1424,
    name: "TIRUPUR EXPORT KNITWEAR INDUSTRIAL COMPLEX",
  },
  {
    id: 1425,
    name: "Tube Products of India Limited",
  },
  {
    id: 1426,
    name: "KURINJI SPINNING MILLS PRIVATE LIMITED",
  },
  {
    id: 1427,
    name: "Hindustan Petroleum Corporation Limited Mumbai Refinery",
  },
  {
    id: 1428,
    name: "CEAT LIMITED.",
  },
  {
    id: 1429,
    name: "Jindal Saw Ltd, Samaghogha",
  },
  {
    id: 1430,
    name: "ASTRAL LIMITED CON.19799",
  },
  {
    id: 1431,
    name: "Adani Wilmar Ltd-Dhrub",
  },
  {
    id: 1432,
    name: "Koteshwar HEP",
  },
  {
    id: 1433,
    name: "Dikchu Hydro Electric Project (Sneha Kinetic Power Projects Pvt. Ltd.)",
  },
  {
    id: 1434,
    name: "SOUTH INDIA KRISHNA OIL AND FATS PRIVATE LIMITED",
  },
  {
    id: 1435,
    name: "Dalmia Laminators Ltd HTSC 1851",
  },
  {
    id: 1436,
    name: "Aurobindo Pharma ltd unit XII",
  },
  {
    id: 1437,
    name: "MATRIX ROLLER MILL PRIVATE LIMITED Unit-2",
  },
  {
    id: 1438,
    name: "ITC LIMITED WIND FARM ANANTAPUR",
  },
  {
    id: 1439,
    name: "The Ramco Cements Limited, Odisha",
  },
  {
    id: 1440,
    name: "SHYAM CENTURY FERROUS LIMITED",
  },
  {
    id: 1441,
    name: "Hubergroup India Pvt Ltd",
  },
  {
    id: 1442,
    name: "Sabarkantha District Cooperative Milk Producers Union Ltd",
  },
  {
    id: 1443,
    name: "BATELI TEA CO LTD",
  },
  {
    id: 1444,
    name: "ILC Iron and Steel Private Limited",
  },
  {
    id: 1445,
    name: "Rajashree Polyfil(A Division Of Century Enka Ltd)",
  },
  {
    id: 1446,
    name: "NESTLE INDIA LIMITED",
  },
  {
    id: 1447,
    name: "NAVEEN COTTON MILL PRIVATE LIMITED",
  },
  {
    id: 1448,
    name: "Malladi Drugs and pharmaceuticals Limited Unit 3",
  },
  {
    id: 1449,
    name: "KRISHNA GANGA SPINNING MILLS PRIVATE LIMITED  CRD471",
  },
  {
    id: 1450,
    name: "GMR BAJOLI HOLI HYDROPOWER PRIVATE LIMITED",
  },
  {
    id: 1451,
    name: "Kovai Medical Center and Hospital Ltd",
  },
  {
    id: 1452,
    name: "ORIENT BELL LIMITED.",
  },
  {
    id: 1453,
    name: "Senapathy Whiteley Private limited",
  },
  {
    id: 1454,
    name: "DVC BTPS",
  },
  {
    id: 1455,
    name: "DVC DSTPS",
  },
  {
    id: 1456,
    name: "DVC RTPS",
  },
  {
    id: 1457,
    name: "Damodar Valley Corporation",
  },
  {
    id: 1458,
    name: "Inox Air Products Pvt Limited Cons.No.30145",
  },
  {
    id: 1459,
    name: "BINJUSARIA ISPAT PVT LTD",
  },
  {
    id: 1460,
    name: "THE DHAMRA PORT COMPANY LIMITED",
  },
  {
    id: 1461,
    name: "MOULI SPINNER LIMITED (HT.SC. NO. 258)",
  },
  {
    id: 1462,
    name: "DALMIA CEMENT (BHARAT) LIMITED, Dalmiapuram",
  },
  {
    id: 1463,
    name: "VEDAGIRI HI TECH SPINNING MILLS PRIVATE LIMITED",
  },
  {
    id: 1464,
    name: "Aequs SEZ Private Limited",
  },
  {
    id: 1465,
    name: "Athi Maharaja Alloys India Private Limited",
  },
  {
    id: 1466,
    name: "AMBUJA CEMENTS LIMITED_Nalagarh",
  },
  {
    id: 1467,
    name: "Solu Hydropower Project NEPAL ELECTRICITY AUTHORITY",
  },
  {
    id: 1468,
    name: "MDA MINERAL DHATU (AP) PRIVATE LIMITED",
  },
  {
    id: 1469,
    name: "Indian sugar Manufacturing Company Limited",
  },
  {
    id: 1470,
    name: "Piccadily Agro Industries Limited",
  },
  {
    id: 1471,
    name: "SANDFITS FOUNDRIES PVT LTD",
  },
  {
    id: 1472,
    name: "Texmo Precision Castings",
  },
  {
    id: 1473,
    name: "GANSUN GLOBAL SOLUTIONS (INDIA) PRIVATE LIMITED",
  },
  {
    id: 1474,
    name: "PALLAVA TEXTILES PRIVATE LIMITED- PALSLDCD14",
  },
  {
    id: 1475,
    name: "RAJAPALAIYAM SPINTEXT",
  },
  {
    id: 1476,
    name: "Radha Smelters Private Limited",
  },
  {
    id: 1477,
    name: "SMC POWER GENERATION LIMITED (UNIT II)",
  },
  {
    id: 1478,
    name: "RAMCO TEXTILE MILL",
  },
  {
    id: 1479,
    name: "DECCAN CEMENTS LIMITED",
  },
  {
    id: 1480,
    name: "SAMBANDAM SPINNING MILLS LIMITED",
  },
  {
    id: 1481,
    name: "The Krishnagiri District Cooperative Spinning Mills Ltd",
  },
  {
    id: 1482,
    name: "Chiripal Poly Films Limited",
  },
  {
    id: 1483,
    name: "ATC Tires Pvt Ltd",
  },
  {
    id: 1484,
    name: "MAHESH EDIBLE OIL INDUSTRIES LIMITED",
  },
  {
    id: 1485,
    name: "GANGA PAPER MILL",
  },
  {
    id: 1486,
    name: "SURYA ROSHNI LTD, BAHADURGARH",
  },
  {
    id: 1487,
    name: "THIAGARAJAR MILLS PRIVATE LIMITED (HTSC-0010)",
  },
  {
    id: 1488,
    name: "KIE Engineering pvt ltd",
  },
  {
    id: 1489,
    name: "APOLLO TYRES LIMITED  TPT2568",
  },
  {
    id: 1490,
    name: "AMRIT BOTTLERS PRIVATE LIMITED",
  },
  {
    id: 1491,
    name: "Murugappa Morgan Thermal Ceramics Limited",
  },
  {
    id: 1492,
    name: "LODHI PROPERTY COMPANY LIMITED",
  },
  {
    id: 1493,
    name: "RANA ISPAT PVT LTD",
  },
  {
    id: 1494,
    name: "GANESHA ECOSPHERE LIMITED, Rudrapur",
  },
  {
    id: 1495,
    name: "SRI VISHNU SHANKAR MILL LIMITED-UNIT-II",
  },
  {
    id: 1496,
    name: "TEESTA V POWER STATION",
  },
  {
    id: 1497,
    name: "RANGIT POWER STATION",
  },
  {
    id: 1498,
    name: "PHARMAZELL (INDIA) PRIVATE LIMITED",
  },
  {
    id: 1499,
    name: "MANALI SUGARS LIMITED",
  },
  {
    id: 1500,
    name: "SH MANISH KHANDUJA AIRTEL (Ganganagar)",
  },
  {
    id: 1501,
    name: "Maruti Suzuki India Limited, Gurgaon",
  },
  {
    id: 1502,
    name: "VISTA FURNISHING LIMITED, Haridwar",
  },
  {
    id: 1503,
    name: "MAITHAN ISPAT LIMITED",
  },
  {
    id: 1504,
    name: "SRI JAYAJOTHI AND COMPANY PRIVATE LIMITED (HTSC-0009)",
  },
  {
    id: 1505,
    name: "Air Liquide North India Private Limited",
  },
  {
    id: 1506,
    name: "ASAHI INDIA GLASS LIMITED, Haridwar",
  },
  {
    id: 1507,
    name: "RADIANT BAR PRIVATE LIMITED",
  },
  {
    id: 1508,
    name: "MANTRI METALLICS PRIVATE LIMITED",
  },
  {
    id: 1509,
    name: "JORETHANG LOOP HEP, DANS ENERGY PRIVATE LIMITED",
  },
  {
    id: 1510,
    name: "VASWANI INDUSTRIES LIMITED",
  },
  {
    id: 1511,
    name: "DHAULIGANGA POWER STATION",
  },
  {
    id: 1512,
    name: "SEWA II POWER STATION",
  },
  {
    id: 1513,
    name: "V.P. TEX PRIVATE LIMITED",
  },
  {
    id: 1514,
    name: "GEM SUGARS LTD",
  },
  {
    id: 1515,
    name: "RUNGTA MINES LIMITED DHENKANAL STEEL PLANT",
  },
  {
    id: 1516,
    name: "SATISH SUGARS LIMITED",
  },
  {
    id: 1517,
    name: "SRI LAKSHMI GANESH SPINNING MILLS OE DIVISION (HTSC - 0319)",
  },
  {
    id: 1518,
    name: "COSMOS FERROUS PRIVATE LIMITED",
  },
  {
    id: 1519,
    name: "Central Railway",
  },
  {
    id: 1520,
    name: "E I D PARRY, Pugalur",
  },
  {
    id: 1521,
    name: "RELIANCE INDUSTRIES LIMITED-BARABANKI MANUFACTURING DIVISION",
  },
  {
    id: 1522,
    name: "BRINDAVAN AGRO INDUSTRIES PVT LTD",
  },
  {
    id: 1523,
    name: "BASF INDIA LIMITED",
  },
  {
    id: 1524,
    name: "IDEAL ENERGY PROJECTS LIMITED",
  },
  {
    id: 1525,
    name: "HINDUSTAN UNILEVERLIMITED",
  },
  {
    id: 1526,
    name: "SHREE KEDARNATH SUGAR AND AGRO PRODUCTS LIMITED",
  },
  {
    id: 1527,
    name: "Shri Prabhulingeshwar Sugars and Chemicals Limited",
  },
  {
    id: 1528,
    name: "M/s Steelcast Ltd - Bhavnagar",
  },
  {
    id: 1529,
    name: "Maruti Suzuki India Limited",
  },
  {
    id: 1530,
    name: "RELIANCE COMMUNICATIONS LTD",
  },
  {
    id: 1531,
    name: "SANDHYA SPINNING MILL LIMITED-UNIT-II",
  },
  {
    id: 1532,
    name: "Sundram Fasteners Limited HTSC 548",
  },
  {
    id: 1533,
    name: "Madura Coats Private Limited HTSC No 36",
  },
  {
    id: 1534,
    name: "Madura Coats Private Limited HTSC No 2",
  },
  {
    id: 1535,
    name: "RELIANCE JIO INFOCOMM LTD- Chennai AG3",
  },
  {
    id: 1536,
    name: "HINDUSTAN TEXTILES",
  },
  {
    id: 1537,
    name: "GOWTHAMI SPINTEX (INDIA) LTD",
  },
  {
    id: 1538,
    name: "TATA MOTORS LIMITED, LKO",
  },
  {
    id: 1539,
    name: "CHHATTISGARH STEEL & POWER LIMITED",
  },
  {
    id: 1540,
    name: "Chanju II (Cosmos Hydro Power Private Limited)",
  },
  {
    id: 1541,
    name: "Core Green Sugar & Fuels Pvt Ltd",
  },
  {
    id: 1542,
    name: "MAA PARVATI STEEL PRIVATE LIMITED",
  },
  {
    id: 1543,
    name: "Kanodia Cement Limited Unit-2",
  },
  {
    id: 1544,
    name: "Heubach Colour Pvt Ltd",
  },
  {
    id: 1545,
    name: "INDIAN OIL CORPORATION LIMITED HTSC078",
  },
  {
    id: 1546,
    name: "DR REDDYS LABORATORIES LIMITED- DRRSLDCD37",
  },
  {
    id: 1547,
    name: "CRAFTSMAN AUTOMATION LTD HTSC 989",
  },
  {
    id: 1548,
    name: "Inox air products pvt limited",
  },
  {
    id: 1549,
    name: "Punjab State Power Corporation Limited",
  },
  {
    id: 1550,
    name: "Suven Pharmaceuticals Limited SGR813",
  },
  {
    id: 1551,
    name: "RAVINDRANATH GE MEDICAL ASSOCIATES PVT LTD",
  },
  {
    id: 1552,
    name: "A B HOTELS LIMITED",
  },
  {
    id: 1553,
    name: "BAIRASIUL POWER STATION",
  },
  {
    id: 1554,
    name: "ADANI HYBRID ENERGY JAISALMER FOUR LIMITED AHS",
  },
  {
    id: 1555,
    name: "LONE CYPRESS VENTURES PRIVATE LIMITED (SHERKOT-II)",
  },
  {
    id: 1556,
    name: "Jamkhandi Sugars Limited (Unit-1)",
  },
  {
    id: 1557,
    name: "Adwaith textiles Private Limited",
  },
  {
    id: 1558,
    name: "KM POWER PRIVATE LIMITED UNIT 2",
  },
  {
    id: 1559,
    name: "MARKS ENGINEERING WORKS (HTSC 724)",
  },
  {
    id: 1560,
    name: "V M D MILLS PRIVATE LIMITED",
  },
  {
    id: 1561,
    name: "SHRI DHANALAKSHMI SPINNTEX PVT LTD (HTSC 265)",
  },
  {
    id: 1562,
    name: "Continental India Private Limited",
  },
  {
    id: 1563,
    name: "Aurobindo Pharma ltd SGR584",
  },
  {
    id: 1564,
    name: "L&T VALVES LIMITED, Kancheepuram",
  },
  {
    id: 1565,
    name: "Rathi Steel and Power Limited",
  },
  {
    id: 1566,
    name: "Lanxess India Pvt Ltd",
  },
  {
    id: 1567,
    name: "Kolyat Solar PV Project (Shambu ki Burj )",
  },
  {
    id: 1568,
    name: "ADANI HYBRID ENERGY JAISALMER FOUR LIMITED AHW",
  },
  {
    id: 1569,
    name: "TEHRI IRON AND STEEL CASTING LIMITED",
  },
  {
    id: 1570,
    name: "BHARATIYA RESERVE BANK NOTE MUDRAN PRIVATE LIMITED",
  },
  {
    id: 1571,
    name: "SRI DHANALAKSHMI COTTON & RICE MILLS PRIVATE LIMITED unit-II",
  },
  {
    id: 1572,
    name: "HUHTAMAKI INDIA LIMITED",
  },
  {
    id: 1573,
    name: "Bluemount Paper and Boards Ltd",
  },
  {
    id: 1574,
    name: "GM SUGAR AND ENERGY LIMITED",
  },
  {
    id: 1575,
    name: "Jamkhandi Sugars Limited (Unit-2)",
  },
  {
    id: 1576,
    name: "VISHWARAJ SUGAR INDUSTRIES LIMITED",
  },
  {
    id: 1577,
    name: "Gujarat Refinery,Con.13006",
  },
  {
    id: 1578,
    name: "RLJ Infracement Private Limited",
  },
  {
    id: 1579,
    name: "SONIA STEEL INDIA PRIVATE LIMITED",
  },
  {
    id: 1580,
    name: "SRI LAKSHMI SARASWATHI TEXTILES (ARNI) LIMITED",
  },
  {
    id: 1581,
    name: "JR METAL CHENNAI LIMITED HTSC 1923",
  },
  {
    id: 1582,
    name: "SCHNEIDER ELECTRIC INDIA PRIVATE LIMITED",
  },
  {
    id: 1583,
    name: "PRISMJOHNSON LIMITED",
  },
  {
    id: 1584,
    name: "THIEH INGOTS PVT.LTD",
  },
  {
    id: 1585,
    name: "KAMENG HYDRO POWER STATION",
  },
  {
    id: 1586,
    name: "CHAMERA III  POWER STATION",
  },
  {
    id: 1587,
    name: "PARBATI III POWER STATION",
  },
  {
    id: 1588,
    name: "TANAKPUR POWER STATION",
  },
  {
    id: 1589,
    name: "DULHASTI POWER STATION",
  },
  {
    id: 1590,
    name: "LONE CYPRESS VENTURES PRIVATE LIMITED (SHERKOT-I)",
  },
  {
    id: 1591,
    name: "M/s Ultra Tech Cement Ltd.",
  },
  {
    id: 1592,
    name: "GARRISON ENGINEER U EM MILATARY ENGINEER SERVICE MEERUT CANTT",
  },
  {
    id: 1593,
    name: "CHERAN SPINNER PRIVATE LIMITED",
  },
  {
    id: 1594,
    name: "MYLAN LABORATORIES LTD",
  },
  {
    id: 1595,
    name: "RUSHIL DECOR LIMITED_KAR",
  },
  {
    id: 1596,
    name: "TVS UPASANA LIMITED HTSC 1308",
  },
  {
    id: 1597,
    name: "TVS UPASANA LIMITED HTSC 330",
  },
  {
    id: 1598,
    name: "KKP TEXTILES PRIVATE LIMITED (HTSC_257)",
  },
  {
    id: 1599,
    name: "ARUN TEXTILES PVT LTD",
  },
  {
    id: 1600,
    name: "EID HALIYAL",
  },
  {
    id: 1601,
    name: "CHAUDHRY STEELS PRIVATE LIMITED",
  },
  {
    id: 1602,
    name: "Carborundum Universal Limited HTSC 130",
  },
  {
    id: 1603,
    name: "JSW ISPAT SPECIAL PRODUCTS LIMITED.",
  },
  {
    id: 1604,
    name: "NIRANI SUGARS LIMITED",
  },
  {
    id: 1605,
    name: "RAMAA SHYAMA PAPERS PRIVATE LIMITED",
  },
  {
    id: 1606,
    name: "MATRIX ROLLER MILL PRIVATE LIMITED (Unit1)",
  },
  {
    id: 1607,
    name: "BANNARI AMMAN SUGARS LIMITED",
  },
  {
    id: 1608,
    name: "KPR Mill Limited-Quantum Knits 3",
  },
  {
    id: 1609,
    name: "Pashupati Metallics",
  },
  {
    id: 1610,
    name: "SRI SARAVANA MILLS PRIVATE LIMITED UNIT II",
  },
  {
    id: 1611,
    name: "Vinayak Steels Limited",
  },
  {
    id: 1612,
    name: "B L KAPUR MEMORIAL HOSPITAL",
  },
  {
    id: 1613,
    name: "DR REDDYSLABORATORIES LIMITED(FTO-7)",
  },
  {
    id: 1614,
    name: "SRI MAHAVIR STEEL",
  },
  {
    id: 1615,
    name: "VISTA FURNISHING LIMITED-MRT",
  },
  {
    id: 1616,
    name: "ARISTOCRAFT PAPERS PRIVATE LIMITED",
  },
  {
    id: 1617,
    name: "WHEELS INDIA LTD",
  },
  {
    id: 1618,
    name: "LOKTAK POWER STATION",
  },
  {
    id: 1619,
    name: "Hindustan Coca Cola Beverages Private Limited",
  },
  {
    id: 1620,
    name: "Sri Rammohan textiles",
  },
  {
    id: 1621,
    name: "Arun smelters private limited",
  },
  {
    id: 1622,
    name: "GKN DRIVELINE (INDIA) LTD HTSC 677",
  },
  {
    id: 1623,
    name: "GIRI EXPORTS",
  },
  {
    id: 1624,
    name: "ALPINE KNITS INDIA PVT LTD",
  },
  {
    id: 1625,
    name: "SRI AMMAN SIZING AND WEAVING MILLS",
  },
  {
    id: 1626,
    name: "ADANI POWER MAHARASHTRA LIMITED.",
  },
  {
    id: 1627,
    name: "Shakthi Murugan Textiles",
  },
  {
    id: 1628,
    name: "Dadri Cement Works (A unit of Ultratech Cement Limited)",
  },
  {
    id: 1629,
    name: "Dindigul Steel Rolling Mills Pvt Ltd HTSC 286",
  },
  {
    id: 1630,
    name: "THIRUMURUGAN SPINNERS",
  },
  {
    id: 1631,
    name: "Sree Karpagambal Mills Limited",
  },
  {
    id: 1632,
    name: "SLMG BEVERAGES Private Limited",
  },
  {
    id: 1633,
    name: "SRI KUMARAN STEELS INDIA PRIVATE LIMITED",
  },
  {
    id: 1634,
    name: "K P R MILL LIMITED",
  },
  {
    id: 1635,
    name: "CHOLA SPINNING MILLS PRIVATE LIMITED III",
  },
  {
    id: 1636,
    name: "Hindustan Unilever Limited Khewra Sonepat",
  },
  {
    id: 1637,
    name: "DUGGAR FIBER PVT LTD",
  },
  {
    id: 1638,
    name: "RICO AUTO INDUSTRIES LIMITED",
  },
  {
    id: 1639,
    name: "M/S OSWAL GLOBAL (Pvt). Ltd.",
  },
  {
    id: 1640,
    name: "MANGLAM METALS",
  },
  {
    id: 1641,
    name: "SHAHI EXPORTS PRIVATE LIMITED GHAZIABAD",
  },
  {
    id: 1642,
    name: "Ultratech Cement Limited Unit Vikram Cement Works Neemuch",
  },
  {
    id: 1643,
    name: "Haq Steels and Metaliks Limited Cons no 34202",
  },
  {
    id: 1644,
    name: "TAGROS CHEMICALS INDIA PRIVATE LIMITED",
  },
  {
    id: 1645,
    name: "SREE JAYAMURUGAN ALLOYS PVT LTD",
  },
  {
    id: 1646,
    name: "Chilime Hydro Power Project NEPAL ELECTRICITY AUTHORITY",
  },
  {
    id: 1647,
    name: "DCM SHRIRAM LIMITED-GUJ",
  },
  {
    id: 1648,
    name: "NSL Sugars Tungabhadra Limited",
  },
  {
    id: 1649,
    name: "UNICAST ALLOYS PRIVATE LIMITED",
  },
  {
    id: 1650,
    name: "SARVOTTAM ROLLING MILLS PRIVATE LIMITED UNIT II",
  },
  {
    id: 1651,
    name: "INDO SHELL  CAST  PRIVATE  LIMITED(HTSC 338)",
  },
  {
    id: 1652,
    name: "APEX COCO AND SOLAR ENERGY LIMITED",
  },
  {
    id: 1653,
    name: "Sudarsanam Spinning Mills(HT SC 0310)",
  },
  {
    id: 1654,
    name: "Anandeshwar Industries Private  Limited",
  },
  {
    id: 1655,
    name: "Nawla Ispat Private Limited",
  },
  {
    id: 1656,
    name: "GOKUL AGRO RESOURCES LIMITED",
  },
  {
    id: 1657,
    name: "Pricol Limited (HTSC 45)",
  },
  {
    id: 1658,
    name: "UTTARAKHAND POWER CORPORATION LIMITED",
  },
  {
    id: 1659,
    name: "DABUR INDIA LIMITED SAHIBABAD",
  },
  {
    id: 1660,
    name: "SHRI DURGA KHANDSARI SUGAR MILLS",
  },
  {
    id: 1661,
    name: "UTTAR PRADESH METRO RAIL CORPORATION LIMITED (MSPA RSS)",
  },
  {
    id: 1662,
    name: "UTTAR PRADESH METRO RAIL CORPORATION LIMITED (TPNR RSS)",
  },
  {
    id: 1663,
    name: "DR REDDYS LABORATORIES LIMITED CTO VI",
  },
  {
    id: 1664,
    name: "SenthilKumar Textile Mills Private Limited- Unit I",
  },
  {
    id: 1665,
    name: "Prince yarnn india limited",
  },
  {
    id: 1666,
    name: "WHEELS INDIA LIMITED 1085",
  },
  {
    id: 1667,
    name: "SARVOTTAM ROLLING MILLS PRIVATE LIMITED UNIT I",
  },
  {
    id: 1668,
    name: "MAHAN ENERGEN LIMITED.",
  },
  {
    id: 1669,
    name: "Vijayanagar Sugar Private Limited",
  },
  {
    id: 1670,
    name: "Dindigul Steel Rolling Mills(P) Ltd",
  },
  {
    id: 1671,
    name: "Denso India Private Limited",
  },
  {
    id: 1672,
    name: "Soubhagya Laxmi Sugars Private Limited",
  },
  {
    id: 1673,
    name: "PATCHALA SPINTEX PRIVATE LIMITED GNT3161",
  },
  {
    id: 1674,
    name: "EVEREADY SPINNING MILLS PVT. LTD. - UNIT-III HTSC-0282",
  },
  {
    id: 1675,
    name: "UNIPRES INDIA PRIVATE LIMITED",
  },
  {
    id: 1676,
    name: "Adani Power Limited Stage-2_STU",
  },
  {
    id: 1677,
    name: "Adani Power Limited Stage 2",
  },
  {
    id: 1678,
    name: "KPR MIll Limited K.Patti Unit",
  },
  {
    id: 1679,
    name: "KPR Mill Limited - Processing DIvision",
  },
  {
    id: 1680,
    name: "ANNA CO -OPERATIVE SPINNING MILLS LTD",
  },
  {
    id: 1681,
    name: "SML Films Ltd",
  },
  {
    id: 1682,
    name: "Akshara Spinning Mills Private Limited Unit II",
  },
  {
    id: 1683,
    name: "ORIENTAL CARBON AND CHEMICALS LIMITED, Dharuhera",
  },
  {
    id: 1684,
    name: "Ultratech Cement Limited (Unit - Sikandrabad Cement Works)",
  },
  {
    id: 1685,
    name: "Maruti Suzuki India Ltd., IMT Manesar, Gurgaon",
  },
  {
    id: 1686,
    name: "VEDANTA LTD LANJIGARH",
  },
  {
    id: 1687,
    name: "SURIYAGIRI SPINNING MILLS PRIVATE LIMITED",
  },
  {
    id: 1688,
    name: "EUGIA PHARMA SPECIALITIES LTD SGR1203",
  },
  {
    id: 1689,
    name: "Aurobindo Pharma Ltd Unit 7",
  },
  {
    id: 1690,
    name: "Sunrise knitting mills private limited",
  },
  {
    id: 1691,
    name: "Sterling Agro Industries Limited",
  },
  {
    id: 1692,
    name: "Dalmia Cement Bharat Ltd, Unit kapilas Cement Manufacturing Works",
  },
  {
    id: 1693,
    name: "LONE CYPRESS VENTURES PRIVATE LIMITED",
  },
  {
    id: 1694,
    name: "ULTRATECH CEMENT LTD. UNIT MAIHAR CEMENT WORKS",
  },
  {
    id: 1695,
    name: "SNJ SUGARS AND PRODUCTS LIMITED",
  },
  {
    id: 1696,
    name: "Andhra Pradesh Central Power Distribution Corporation Limited",
  },
  {
    id: 1697,
    name: "GAMA INFRAPROP PRIVATE LIMITED",
  },
  {
    id: 1698,
    name: "MANIRA ENERGY PRIVATE LIMITED",
  },
  {
    id: 1699,
    name: "Waaree Energies Limited Cons.No.12201",
  },
  {
    id: 1700,
    name: "SHANTINIKETAN PROPERTIES PRIVATE LIMITED",
  },
  {
    id: 1701,
    name: "Ambuja Cements Limited_RABRIYAWAS",
  },
  {
    id: 1702,
    name: "Mayflex Cement Industries Private Limited",
  },
  {
    id: 1703,
    name: "WIND FIVE RENERGY LIMITED",
  },
  {
    id: 1704,
    name: "NTPC NOKHRA Solar PV",
  },
  {
    id: 1705,
    name: "Clean Max Scorpius Pvt Ltd 625 MW",
  },
  {
    id: 1706,
    name: "Clean Max Matahari Pvt Ltd 3 3 MW",
  },
  {
    id: 1707,
    name: "Clean Max Matahari Pvt Ltd 3125 MW",
  },
  {
    id: 1708,
    name: "CHAMUNDA PAPERS PVT LTD",
  },
  {
    id: 1709,
    name: "JAI RAJ ISPAT LIMITED",
  },
  {
    id: 1710,
    name: "MAHALAKSHMI PROFILES PVT LTD",
  },
  {
    id: 1711,
    name: "Sikkim Urja Limited",
  },
  {
    id: 1712,
    name: "JINDAL ALUMINIUM LIMITED",
  },
  {
    id: 1713,
    name: "Reliance Innoventures Private Limited",
  },
  {
    id: 1714,
    name: "Chendhoor Murughan yarn tex india Private limited",
  },
  {
    id: 1715,
    name: "AMARJOTHI SPINNING MILLS LIMITED (HTSC-085)",
  },
  {
    id: 1716,
    name: "Cisco Systems India Private Limited",
  },
  {
    id: 1717,
    name: "BELLA PREMIER HAPPY HYGIENE CARE PRIVATE LTD",
  },
  {
    id: 1718,
    name: "CHAMUNDESWARI BUILD TECH PRIVATE LIMITEDED",
  },
  {
    id: 1719,
    name: "Shilpa Medicare Limited 0.6MW",
  },
  {
    id: 1720,
    name: "Mothi Spinner Private Limited HTSC 557",
  },
  {
    id: 1721,
    name: "NSL RENEWABLE POWER PRIVATE LIMITED(NSL)",
  },
  {
    id: 1722,
    name: "MSPL LTD",
  },
  {
    id: 1723,
    name: "GHODAWAT ENERGY PRIVATE LIMITED",
  },
  {
    id: 1724,
    name: "NSL NSL RENEWABLE POWER PRIVATE LIMITED",
  },
  {
    id: 1725,
    name: "VIBRANT GREENTECH INDIA PRIVATE LIMITED",
  },
  {
    id: 1726,
    name: "Mahesh Edible Oil Corporation Private Limited",
  },
  {
    id: 1727,
    name: "JOTHI MELTERS (INDIA) PRIVATE LIMITED",
  },
  {
    id: 1728,
    name: "Eicher Motors LTD- HTSC 1212",
  },
  {
    id: 1729,
    name: "ATC Tires Private Limited",
  },
  {
    id: 1730,
    name: "O2 Renewable Energy IV Private Limited",
  },
  {
    id: 1731,
    name: "Clean Max Pluto Solar Power LLP 27",
  },
  {
    id: 1732,
    name: "Reliance Jio Info comm Limited -Lucknow",
  },
  {
    id: 1733,
    name: "MODERN GLASS INDUSTRIES",
  },
  {
    id: 1734,
    name: "SOLAIRE SURYA URJA PRIVATE LIMITED PLOT 10",
  },
  {
    id: 1735,
    name: "SBT Apparels Private Limited (HTSc-279)",
  },
  {
    id: 1736,
    name: "NTS Power_",
  },
  {
    id: 1737,
    name: "THE BHARATHI CO-OP SPINNING MILLS LTD",
  },
  {
    id: 1738,
    name: "Seaview Developers Private Limited",
  },
  {
    id: 1739,
    name: "PRABHAT AGRI BIOTECH LIMITED",
  },
  {
    id: 1740,
    name: "SARAYU CLEANGEN PRIVATE LIMITED",
  },
  {
    id: 1741,
    name: "TP Saurya Limited",
  },
  {
    id: 1742,
    name: "MERINO INDUSTRIES LIMITED",
  },
  {
    id: 1743,
    name: "UltraTech cement Limited (HT-0053)",
  },
  {
    id: 1744,
    name: "APOLLO TYRES LTD HTSC 0774",
  },
  {
    id: 1745,
    name: "V THANGAVEL AND SONS PRIVATE LIMITED-288",
  },
  {
    id: 1746,
    name: "VASUDHA PHARMA CHEM LIMITED VSP1415",
  },
  {
    id: 1747,
    name: "Nayara Energy Limited",
  },
  {
    id: 1748,
    name: "Shree Cement Limited JOBNER",
  },
  {
    id: 1749,
    name: "Vodafone Idea Limited (Mawana Road, Meerut)",
  },
  {
    id: 1750,
    name: "Clean Max Scorpius Power LLP 27",
  },
  {
    id: 1751,
    name: "Clean Max Scorpius Power LLP 2MW",
  },
  {
    id: 1752,
    name: "Aakriti Hotels Private Limited",
  },
  {
    id: 1753,
    name: "Clean Max Pluto Solar Power LLP",
  },
  {
    id: 1754,
    name: "O2 RENEWABLE ENERGY V PRIVATE LIMITED MP-2MP-2",
  },
  {
    id: 1755,
    name: "MITSUBA INDIA PRIVATE LIMITED",
  },
  {
    id: 1756,
    name: "Solara Active Pharma Sciences Limited",
  },
  {
    id: 1757,
    name: "Tashiding HEP, Shiga Energy Private Limited",
  },
  {
    id: 1758,
    name: "RAJAPALAYAM MILLS LTD",
  },
  {
    id: 1759,
    name: "NEW TIRUPUR AREA DEVELOPMENT CORPORATION LIMITED_HTSC No 100",
  },
  {
    id: 1760,
    name: "PARAMPUJYA SOLAR ENERGY PRIVATE LIMITED",
  },
  {
    id: 1761,
    name: "Bangur Cement Unit (A Unit of Shree Cement Limited)",
  },
  {
    id: 1762,
    name: "N.P. AGRO (INDIA) INDUSTRIES PRIVATE LIMITED",
  },
  {
    id: 1763,
    name: "Chandpur Enterprises Limited",
  },
  {
    id: 1764,
    name: "PIONEER POWER CORPORATION LIMITED",
  },
  {
    id: 1765,
    name: "NTPC Jhanor Gandhar GPS",
  },
  {
    id: 1766,
    name: "SINTEX INDUSTRIES LTD. Cons. No. 43369",
  },
  {
    id: 1767,
    name: "ADHUNIK POWER & NATURAL RESOURCES LIMITED",
  },
  {
    id: 1768,
    name: "G R SPONGE AND POWER LIMITED",
  },
  {
    id: 1769,
    name: "V K S M COTTON MILLS P LTD",
  },
  {
    id: 1770,
    name: "BALRAMPUR CHINI MILLS LTD",
  },
  {
    id: 1771,
    name: "SANVIJAY ALLOYS AND POWER LIMITED",
  },
  {
    id: 1772,
    name: "ANAND ISPAT UDYOG LIMITED RJN1884",
  },
  {
    id: 1773,
    name: "NUVOCO VISTAS CORPORATION LIMITED, ARASMETA",
  },
  {
    id: 1774,
    name: "Adishakti Smelters Private Limited",
  },
  {
    id: 1775,
    name: "Vodafone Idea Limited - HTSC No.993",
  },
  {
    id: 1776,
    name: "Kabeli B-1 Hydro Power Project NEPAL ELECTRICITY AUTHORITY",
  },
  {
    id: 1777,
    name: "Lower Modi Hydro Power Project NEPAL ELECTRICITY AUTHORITY",
  },
  {
    id: 1778,
    name: "SMIIEL (A Unit of SAMVARDHANA MOTHERSON INTERNATIONAL LIMITED)",
  },
  {
    id: 1780,
    name: "UT Chandigarh",
  },
  {
    id: 1781,
    name: "DHARIWAL STU OTH",
  },
  {
    id: 1782,
    name: "Reliance Polyesters Ltd Cons.No.40561",
  },
  {
    id: 1783,
    name: "SAURASHTRA CEMENT LIMITED, Cons.No.21421",
  },
  {
    id: 1784,
    name: "Ratnagiri Gas & Power Private Limited",
  },
  {
    id: 1785,
    name: "VASUDHA PHARMA CHEM LIMITED UNIT-5 VSP 1617",
  },
  {
    id: 1786,
    name: "Sakthi Auto Component Limited",
  },
  {
    id: 1787,
    name: "S.A.AANANDAN MILL LIMITED",
  },
  {
    id: 1788,
    name: "SHRI BALKISHAN AGARWAL GLASS INDUSTRIES PRIVATE LIMITED",
  },
  {
    id: 1789,
    name: "SEIL ENERGY INDIA LIMITED",
  },
  {
    id: 1790,
    name: "Clean Max Plutus Pvt Ltd",
  },
  {
    id: 1791,
    name: "ISHARAYS ENERGY THREE PRIVATE LIMITED",
  },
  {
    id: 1792,
    name: "Clean Max Plutus Private Limited 0.9MW",
  },
  {
    id: 1793,
    name: "Apollo Pipes Limited",
  },
  {
    id: 1794,
    name: "IG3 Infra Limited",
  },
  {
    id: 1795,
    name: "SUMUKH RENEWABLE SOLUTIONS",
  },
  {
    id: 1796,
    name: "ENGINEERED POWER RESOURCES INDIA PRIVATE LIMITED",
  },
  {
    id: 1797,
    name: "HINDUPUR STEEL AND ALLOYS PRIVATE LIMITED",
  },
  {
    id: 1798,
    name: "RAMACHANDRA POLYPACKS PRIVATE LIMITED",
  },
  {
    id: 1799,
    name: "Clean Max Scorpius Power LLP 3125MW",
  },
  {
    id: 1800,
    name: "ULTRATECH CEMENT LIMITED UNIT:CUTTACK CEMENT WORKS",
  },
  {
    id: 1801,
    name: "Savita Oil Technologies Limited",
  },
  {
    id: 1802,
    name: "NTPC Ettayapuram Solar PV",
  },
  {
    id: 1803,
    name: "TUBE INVESTMENTS OF INDIA LIMITED (TI METAL FORMING) HTSC 079",
  },
  {
    id: 1804,
    name: "ADANI WIND ENERGY KUTCHH FIVE LIMITED",
  },
  {
    id: 1805,
    name: "PUNJAB HYDRO POWER PRIVATE LIMITED BHANUBHURA",
  },
  {
    id: 1806,
    name: "South Western Railway",
  },
  {
    id: 1807,
    name: "Gujarat Fluorochemical Ltd Dahej",
  },
  {
    id: 1808,
    name: "FPEL PHOENIX PRIVATE LIMITED",
  },
  {
    id: 1809,
    name: "PRIME STEEL PROCESSORS PRIVATE LIMITED",
  },
  {
    id: 1810,
    name: "Khivraj Tech Park Pvt Ltd HTSC 749",
  },
  {
    id: 1811,
    name: "Rajalakshmi Paper Mills Private Limited, htsc 30",
  },
  {
    id: 1812,
    name: "RHL PROFILES LIMITED",
  },
  {
    id: 1813,
    name: "SCAN ENERGY AND POWER LIMITED",
  },
  {
    id: 1814,
    name: "NSL Krishnaveni sugars limited",
  },
  {
    id: 1815,
    name: "JAYALAKSHMI EXPORTS & IMPORTS PRIVATE LIMITED",
  },
  {
    id: 1816,
    name: "VEH SRISHTI ENERGY PRIVATE LIMITED",
  },
  {
    id: 1817,
    name: "Sunvik Steels PVT LTD",
  },
  {
    id: 1818,
    name: "MATRIX POWER WIND PVT LTD",
  },
  {
    id: 1819,
    name: "Clean Max Saura Pvt Ltd 3 3 MW",
  },
  {
    id: 1820,
    name: "PRIME STEEL PROCESSORS PRIVATE LIMITED, PRISLDCI21",
  },
  {
    id: 1821,
    name: "BHAVANA HYDRO ELECTRIC PRIVATE LIMITED",
  },
  {
    id: 1822,
    name: "Nuvoco vistas corporation limited nimbol unit",
  },
  {
    id: 1823,
    name: "Clean Max Uranus Pvt Ltd 4.95 MW",
  },
  {
    id: 1824,
    name: "ITC LIMITED HTSC 880",
  },
  {
    id: 1825,
    name: "NTPC ANTA  GPS LF",
  },
  {
    id: 1826,
    name: "Maruti Clean Coal and Power Limited",
  },
  {
    id: 1827,
    name: "ACB (INDIA) LIMITED",
  },
  {
    id: 1828,
    name: "ReNew Surya Ravi Private Limited",
  },
  {
    id: 1829,
    name: "Grasim Industries Limited.",
  },
  {
    id: 1830,
    name: "SEQUENCE FERRO PRIVATE LIMITED",
  },
  {
    id: 1831,
    name: "NANDAGUDI OILS AND AGRO INDUSTRIES LLP.,",
  },
  {
    id: 1832,
    name: "M HANUMANTHA RAO (Gudikalkeri)",
  },
  {
    id: 1833,
    name: "COROMANDEL ELECTRIC COMPANY LIMITED",
  },
  {
    id: 1834,
    name: "Alok Industries Ltd.",
  },
  {
    id: 1835,
    name: "KARPAGA VINAYAGA EDUCATIONAL TRUST",
  },
  {
    id: 1836,
    name: "AM RAGHAVENDRA",
  },
  {
    id: 1837,
    name: "Sri Shanmugavel Mills Private Limited, HT SC 0236",
  },
  {
    id: 1838,
    name: "Sunvik Steels Pvt Ltd 5MW",
  },
  {
    id: 1839,
    name: "SEP ENERGY PRIVATE LIMITED",
  },
  {
    id: 1840,
    name: "Renew Sandur Green Energy Private Limited Solar",
  },
  {
    id: 1841,
    name: "OMR MALL DEVELOPERS PRIVATE LIMITED",
  },
  {
    id: 1842,
    name: "SREE ISWARYA TEXTILES PRIVATE LIMITED",
  },
  {
    id: 1843,
    name: "Clean Max Scorpius Pvt Ltd 9.9MW",
  },
  {
    id: 1844,
    name: "Clean Max Thennal Private Limited 4 05",
  },
  {
    id: 1845,
    name: "SRI KUMARASWAMY MINERAL EXPORTS PRIVATE LIMITED (KST85)",
  },
  {
    id: 1846,
    name: "SOUTHWEST HYDRO POWER P L",
  },
  {
    id: 1847,
    name: "MANGAL INDUSTRIES LIMITED - PTM",
  },
  {
    id: 1848,
    name: "Nirani Energy Private Limited Phase (4)",
  },
  {
    id: 1849,
    name: "LAURUS LABS LIMITED  VSP 1202",
  },
  {
    id: 1850,
    name: "PUNJAB HYDRO POWER PRIVATE LIMITED SALAR",
  },
  {
    id: 1851,
    name: "PUNJAB HYDRO POWER PRIVATE LIMITED DOLOWAL",
  },
  {
    id: 1852,
    name: "NALARI FERRO ALLOYS PRIVATE LIMITED",
  },
  {
    id: 1853,
    name: "Jindal Saw Limited",
  },
  {
    id: 1854,
    name: "Mahalaxmi Vidyut Private Limited",
  },
  {
    id: 1855,
    name: "Diamond Cement(Prop. Heidelberg Cement India Limited-Imlai)",
  },
  {
    id: 1856,
    name: "VIJAY VELAVAN SPINNING MILLS PRIVATE LIMITED HTSC-276",
  },
  {
    id: 1857,
    name: "Honda Motorcycle & Scooter India Private Limited 5.4 MW",
  },
  {
    id: 1858,
    name: "Lalpur Wind Energy Private Limited",
  },
  {
    id: 1859,
    name: "MSPL LTD-4.75 MW",
  },
  {
    id: 1860,
    name: "SRI KUMARASWAMY MINERAL EXPORTS PRIVATE LIMITED (KST076)",
  },
  {
    id: 1861,
    name: "SREE KADERI AMBAL MILLS PRIVATE LIMITED HTSC 75",
  },
  {
    id: 1862,
    name: "TRK TEXTILE(INDIA) PRIVATE LIMITED HTSC 0436",
  },
  {
    id: 1863,
    name: "Quality Needles Private Limited",
  },
  {
    id: 1864,
    name: "Demo WIND FARM PVT LTD",
  },
  {
    id: 1865,
    name: "Clean Max Tav Pvt Ltd 2.7MW",
  },
  {
    id: 1866,
    name: "Nirani Energy Private Limited Phase (2)",
  },
  {
    id: 1867,
    name: "Nirani Energy Private Limited Phase (1)",
  },
  {
    id: 1868,
    name: "Harsha International",
  },
  {
    id: 1869,
    name: "JSW CEMENT LIMITED-AP",
  },
  {
    id: 1870,
    name: "GREENPANEL INDUSTRIES LIMITED UNIT 2",
  },
  {
    id: 1871,
    name: "RUNGTA MINES LIMITED , KAMANDA STEEL PLANT POST KOIRA DIST SUNDERGARH ODISHA",
  },
  {
    id: 1872,
    name: "GANGA BAG UDYOG PRIVATE LIMITED Unit -II",
  },
  {
    id: 1873,
    name: "NATIONAL OXYGEN LIMITED",
  },
  {
    id: 1874,
    name: "Nagai Power Pvt Ltd",
  },
  {
    id: 1875,
    name: "NTPC SAIL POWER COMPANY LIMITED",
  },
  {
    id: 1876,
    name: "NUVOCO VISTAS CORPORATION LIMITED, SONADIH",
  },
  {
    id: 1877,
    name: "CHENNAI METRO RAIL LIMITED 1843",
  },
  {
    id: 1878,
    name: "SREE KADERI AMBAL MILLS PRIVATE LIMITED HTSC 46",
  },
  {
    id: 1879,
    name: "SRI KUMARASWAMY MINERAL EXPORTS PRIVATE LIMITED (12.6MW)",
  },
  {
    id: 1880,
    name: "Nirani Energy Private Limited Phase (3)",
  },
  {
    id: 1881,
    name: "TEHRI IRON & STEEL INDUSTRIES",
  },
  {
    id: 1882,
    name: "MASAYA SOLAR ENERGY PRIVATE LIMITED",
  },
  {
    id: 1883,
    name: "AVAADA SUNRAYS ENERGY PRIVATE LIMITED",
  },
  {
    id: 1884,
    name: "GURUVAYURAPPAN TEXTILES PRIVATE LIMITED",
  },
  {
    id: 1885,
    name: "KUTCH CHEMICAL INDUSTRIES LIMITED",
  },
  {
    id: 1886,
    name: "Krishnanchal pulp & papers private limited",
  },
  {
    id: 1887,
    name: "Sai Krishna Steel Industries",
  },
  {
    id: 1888,
    name: "Vodafone Idea Limited (Sec-63, Noida)",
  },
  {
    id: 1889,
    name: "M HANUMANTHA RAO (Kadekoppa)",
  },
  {
    id: 1890,
    name: "Shalimar Corp Limited",
  },
  {
    id: 1891,
    name: "SOHAM RENEWABLE ENERGY INDIA PRIVATE LIMITED",
  },
  {
    id: 1892,
    name: "MAITHAN ALLOYS LIMITED VSP981",
  },
  {
    id: 1893,
    name: "Creamy Foods Limited",
  },
  {
    id: 1894,
    name: "Gallantt Ispat Limited Cons. No.31459",
  },
  {
    id: 1895,
    name: "Jindal Power Limited, Stage-1",
  },
  {
    id: 1896,
    name: "NATIONAL ALUMINIUM COMPANY LIMITED-OD",
  },
  {
    id: 1897,
    name: "RATHI STEEL AND POWER LIMITED(ROLLING MILL)",
  },
  {
    id: 1898,
    name: "RADIANCE KA SUNRISE THREE PRIVATE LIMITED",
  },
  {
    id: 1899,
    name: "Renew Green (KAK-TWO) Private Limited Solar",
  },
  {
    id: 1900,
    name: "KAJARIA CERAMICS LIMITED TPT2320",
  },
  {
    id: 1901,
    name: "CHIDANAND BASAPRABHU KORE SAHAKARI SAKKARE KARKHANE NIYAMIT,CHIKODI",
  },
  {
    id: 1902,
    name: "THE INDIA CEMENTS LIMITED",
  },
  {
    id: 1903,
    name: "Chettinad cement Corporation Private LimitedGNT3974",
  },
  {
    id: 1904,
    name: "Crest Steel and Power Private Limited",
  },
  {
    id: 1905,
    name: "TPL-Dholera Discom",
  },
  {
    id: 1906,
    name: "Abhay Solvents Private Limited",
  },
  {
    id: 1907,
    name: "Vish Wind Infrastrukture LLP",
  },
  {
    id: 1908,
    name: "PARBATI II HE PROJECT",
  },
  {
    id: 1909,
    name: "JINDAL STEEL & POWER LTD",
  },
  {
    id: 1910,
    name: "SRI KARVEMBU TEXTILES PRIVATE LIMITED 0379",
  },
  {
    id: 1911,
    name: "Sree Lakshmi Venkateswara Spinning Mills Private Limited (HT Sc - 0238)",
  },
  {
    id: 1912,
    name: "USHA SPINCOAT PRIVATE LIMITED VJA3105",
  },
  {
    id: 1913,
    name: "ENNORE COAL TERMINAL PVT LTD HTSC 1906",
  },
  {
    id: 1914,
    name: "KTV HEALTH FOOD PRIVATE LIMITED HTSC No 197",
  },
  {
    id: 1915,
    name: "AVON ENERGIES AND INVESTMENTS PRIVATE LIMITED, GANJBASODA",
  },
  {
    id: 1916,
    name: "AVON ENERGIES AND INVESTMENTS PRIVATE LIMITED,Sironj 1",
  },
  {
    id: 1917,
    name: "Jaideep Ispat and Alloys Pvt Ltd.",
  },
  {
    id: 1918,
    name: "KAMACHI INDUSTRIES LIMITED",
  },
  {
    id: 1919,
    name: "MANIHAMSA POWER PROJECTS LIMITED (RJY944)",
  },
  {
    id: 1920,
    name: "NSL SUGARS LIMITED, KOPPA",
  },
  {
    id: 1921,
    name: "AVON ENERGIES AND INVESTMENTS PRIVATE LIMITED, Sironj 2",
  },
  {
    id: 1922,
    name: "ARTHANARI LOOM CENTRE TEXTILE PVT LTD 0329",
  },
  {
    id: 1923,
    name: "BALAJI ENERGY PRIVATE LIMITED NLR 2159",
  },
  {
    id: 1924,
    name: "ARUN VYAPAR UDYOG PRIVATE LIMITED",
  },
  {
    id: 1925,
    name: "CRAFTSMAN AUTOMATION LIMITED (HTSC-0488)",
  },
  {
    id: 1926,
    name: "J. K. CEMENT Ltd, JHARLI, JHAJJAR",
  },
  {
    id: 1927,
    name: "SA POWER UTILITIES PRIVATE LIMITED",
  },
  {
    id: 1928,
    name: "Reliance JIO Infocomm Ltd Cons.No.34415",
  },
  {
    id: 1929,
    name: "Cargill India Private Limited VJA3198",
  },
  {
    id: 1930,
    name: "NLC Tamilnadu Power Limited",
  },
  {
    id: 1932,
    name: "ANY seller - WR Region",
  },
  {
    id: 1933,
    name: "ANY seller - SR Region",
  },
  {
    id: 1936,
    name: "ANY seller - NER Region",
  },
  {
    id: 1937,
    name: "ANY seller - ER Region",
  },
  {
    id: 1938,
    name: "ANY seller - NR Region",
  },
  {
    id: 1939,
    name: "SURYAURJA TWO PRIVATE LIMITED",
  },
  {
    id: 1940,
    name: "IOCL Panipat Refinery",
  },
  {
    id: 1941,
    name: "Garrison Engineer (Utility) Ambala Cantt",
  },
  {
    id: 1942,
    name: "JINDAL STAINLESS LIMITED, HISAR 125005 (HARYANA)",
  },
  {
    id: 1943,
    name: "Basochhu Hydropower Plant Bhutan",
  },
  {
    id: 1944,
    name: "YESHASHVI STEELS & ALLOYS PRIVATE LIMITED",
  },
  {
    id: 1945,
    name: "BKG MINING PRIVATE LIMITED",
  },
  {
    id: 1946,
    name: "THAKUR INDUSTRIES",
  },
  {
    id: 1947,
    name: "Vamshadhara Paper Mills Limited HTSC 1763",
  },
  {
    id: 1948,
    name: "J K Cement Works, Mangrol",
  },
  {
    id: 1949,
    name: "RHYTHM REAL FOOD PRODUCTS",
  },
  {
    id: 1950,
    name: "KTV HEALTH FOOD PVT LTD HTSC NO 1931",
  },
  {
    id: 1951,
    name: "Kundan Hydro (Gangtok)Private Limited, Kalez Khola(HEP)",
  },
  {
    id: 1952,
    name: "CHAMERA I  POWER STATION",
  },
  {
    id: 1953,
    name: "Sri Shanmugavel Mills private limited, HTSC 0446",
  },
  {
    id: 1954,
    name: "WIND WORLD WIND FARMS (KARNATAKA) LIMITED",
  },
  {
    id: 1955,
    name: "URI I POWER STATION",
  },
  {
    id: 1956,
    name: "Amway India Enterprises Limited HTSC 0390",
  },
  {
    id: 1957,
    name: "DOLPHIN DIE CAST PVTLTD",
  },
  {
    id: 1958,
    name: "SIMCON SOLAR, IMLANI",
  },
  {
    id: 1959,
    name: "J K Cement Works, Nimbahera",
  },
  {
    id: 1960,
    name: "BHAGWATI POWER AND STEEL LIMITED",
  },
  {
    id: 1961,
    name: "BODAL CHEMICALS LIMITED",
  },
  {
    id: 1962,
    name: "SURYADEV ALLOYS AND POWER PRIVATE LIMITED",
  },
  {
    id: 1963,
    name: "The Ugar Sugar Works Limited, Kalaburgi Unit 2",
  },
  {
    id: 1964,
    name: "NREL-Dayapar  Wind",
  },
  {
    id: 1965,
    name: "Aravind Ceramic Industries Limited",
  },
  {
    id: 1966,
    name: "M/s A ONE STEELS INDIA PVT LTD (ATP351)",
  },
  {
    id: 1967,
    name: "Reliance Industries Limited-Hazira",
  },
  {
    id: 1968,
    name: "CHENNIAPPA YARN SPINNERS PRIVATE LIMITED HTSC-0165",
  },
  {
    id: 1969,
    name: "S P SPINNING MILLS PRIVATE LIMITED",
  },
  {
    id: 1970,
    name: "WALWHAN RENEWABLE ENERGY LIMITED",
  },
  {
    id: 1971,
    name: "Dalmia Cement (Bharat) Ltd. Kadapa , AP",
  },
  {
    id: 1972,
    name: "Birla Cellulosic",
  },
  {
    id: 1973,
    name: "SRI RANILAKSHMI TEXTILES PRIVATE LIMITED HTSC 0017",
  },
  {
    id: 1974,
    name: "NTPC Vindhyachal Stage I",
  },
  {
    id: 1975,
    name: "TUTICORIN ALKALI CHEMICALS AND FERTILIZERS LIMITED",
  },
  {
    id: 1976,
    name: "SBSR Power Cleantech Eleven Private Limited",
  },
  {
    id: 1977,
    name: "AEML SEEPZ Limited",
  },
  {
    id: 1978,
    name: "MOTHERLAND TEXTILE INDIA PRIVATE LIMITED HT SC 0351",
  },
  {
    id: 1979,
    name: "THARUN TEXSPIN MILLS PRIVATE LIMITED",
  },
  {
    id: 1980,
    name: "Adani Power Ltd-Stage-3 (U-9) STU",
  },
  {
    id: 1981,
    name: "Jammu and Kashmir Power Corporation Ltd.",
  },
  {
    id: 1982,
    name: "NTPC Devikoot Solar PV station",
  },
  {
    id: 1983,
    name: "SOLAIRE SURYA URJA PRIVATE LIMITED (PLOT 08)",
  },
  {
    id: 1984,
    name: "Hwashin Automotive India Pvt Ltd HTSC 387",
  },
  {
    id: 1985,
    name: "NATIONAL ALUMINIUM COMPANY LIMITED AP",
  },
  {
    id: 1986,
    name: "SRF Ltd- Manali",
  },
  {
    id: 1987,
    name: "DALMIA CEMENT (BHARAT) LIMITED, ARIYALUR",
  },
  {
    id: 1988,
    name: "SUN GLASS WORKS PRIVATE LIMITED",
  },
  {
    id: 1989,
    name: "Adani Power Limited - Raigarh TPP",
  },
  {
    id: 1990,
    name: "M/s Gujarat Alkalies & Chemicals Limited",
  },
  {
    id: 1991,
    name: "ITC LIMITED-MNK 01",
  },
  {
    id: 1992,
    name: "ITC LIMITED-MNK 02",
  },
  {
    id: 1993,
    name: "ITC LIMITED-MNK05",
  },
  {
    id: 1994,
    name: "H L AGRO PRODUCTS PRIVATE LIMITED",
  },
  {
    id: 1995,
    name: "NTPC Dadri Stage I",
  },
  {
    id: 1996,
    name: "NTPC Kawas GPS",
  },
  {
    id: 1997,
    name: "NTPC Kawas GPS RLNG",
  },
  {
    id: 1998,
    name: "The Tata Power Co Ltd (MTPS)",
  },
  {
    id: 1999,
    name: "EASTMAN EXPORTS GLOBAL CLOTHING PRIVATE LIMITED-HTSC No.181",
  },
  {
    id: 2000,
    name: "SANDHYA HYDRO POWER PROJECTS BALARGHA PRIVATE LIMITED",
  },
  {
    id: 2001,
    name: "PCBL (TN) Limited",
  },
  {
    id: 2002,
    name: "LAN SPIN TEX PRIVATE LIMITED HTSC-0293",
  },
  {
    id: 2003,
    name: "EMAMI LIMITED",
  },
  {
    id: 2004,
    name: "NACL INDUSTRIES LIMITED",
  },
  {
    id: 2005,
    name: "HATSUN AGRO PRODUCT LIMITED - 204",
  },
  {
    id: 2006,
    name: "RELIANCE INDUSTRIES LIMITED-Jio World Centre",
  },
  {
    id: 2007,
    name: "BALRAMPUR CHINI MILLS LTD. Unit HCM",
  },
  {
    id: 2008,
    name: "Druk Green Power Corporation Limited (DGPCL-Bhutan)",
  },
  {
    id: 2009,
    name: "CONTINUUM POWER TRADING (TN) PRIVATE LIMITED",
  },
  {
    id: 2010,
    name: "CARBORUNDUM UNIVERSAL LIMITED KALAMASSERY",
  },
  {
    id: 2011,
    name: "S.N.N. TULASI NARAYANA SPINNERS PRIVATE LIMITED",
  },
  {
    id: 2012,
    name: "Naitwar Mori HPS",
  },
  {
    id: 2013,
    name: "Sundram Fasteners Limited HTSC 1766",
  },
  {
    id: 2014,
    name: "BHARAT ALUMINIUM COMPANY LTD (Bulk Consumer)",
  },
  {
    id: 2015,
    name: "Tata Steel Limited Ferro Alloys Plant Balasore",
  },
  {
    id: 2016,
    name: "Murugan TEXTILES (HTSC No. 328)",
  },
  {
    id: 2017,
    name: "Divyalakshmi Textiles Private Limited (HT Sc - 269)",
  },
  {
    id: 2018,
    name: "VMC STEEL AND ALLOYS INDUSTRY",
  },
  {
    id: 2019,
    name: "KANSAI NEROLAC PAINTS LIMITED",
  },
  {
    id: 2020,
    name: "Eicher Motors Limited0979",
  },
  {
    id: 2021,
    name: "MASTERJI METALLOYS PVT. LTD.",
  },
  {
    id: 2022,
    name: "Manali Petrochemicals Limited 1449 -Plant 1",
  },
  {
    id: 2023,
    name: "Manali Petrochemicals Limited 1459 - Plant 2",
  },
  {
    id: 2024,
    name: "ASHOK LEYLAND LIMITED (HTSC_171)",
  },
  {
    id: 2025,
    name: "SPACE TEXTILES PRIVATE LIMITED",
  },
  {
    id: 2026,
    name: "EASTMAN EXPORTS GLOBAL CLOTHING PRIVATE LIMITED",
  },
  {
    id: 2027,
    name: "Kopili 1 IN",
  },
  {
    id: 2028,
    name: "M G Associates",
  },
  {
    id: 2029,
    name: "NIDAR UTILITIES PANVEL LLP",
  },
  {
    id: 2030,
    name: "DESIGNCO PRIVATE LIMITED",
  },
  {
    id: 2031,
    name: "RAC PAPERS LIMITED",
  },
  {
    id: 2032,
    name: "MRF LIMITED (HTSC 1180)",
  },
  {
    id: 2033,
    name: "BANNARI AMMAN SPINNING MILLS LIMITED",
  },
  {
    id: 2034,
    name: "SHRIGOVIND POLYTEX PRIVATE LIMITED",
  },
  {
    id: 2035,
    name: "NTPC North Karanpura  STPS infirm ( UNIT # 2 )",
  },
  {
    id: 2036,
    name: "SRI VENKATACHALAPATHY SPINNING MILLS PRIVATE LIMITED HTSC 0155",
  },
  {
    id: 2037,
    name: "Sarvesh Multi Plast India Private Limited HT 0362",
  },
  {
    id: 2038,
    name: "RIPL_U5 AMT",
  },
  {
    id: 2039,
    name: "PIEM HOTELS LIMITED - TAJ MAHAL",
  },
  {
    id: 2040,
    name: "SRI M S T SMELTERS PRIVATE LIMITED",
  },
  {
    id: 2041,
    name: "HYGIENE PLUS PRIVATE LIMITED",
  },
  {
    id: 2042,
    name: "BANNARI AMMAN SPINNING MILLS LIMITED, UNIT II",
  },
  {
    id: 2043,
    name: "BHATIA COKE & ENERGY LIMITED",
  },
  {
    id: 2044,
    name: "GROWEL FEEDS PRIVATE LIMITED VJA 3562",
  },
  {
    id: 2045,
    name: "TEXMO INDUSTRIES - PUMP DIVISION HTSC 30",
  },
  {
    id: 2046,
    name: "Bony Polymers Private Limited, Faridabad",
  },
  {
    id: 2047,
    name: "MAGIC WIRES PRIVATE LIMITED",
  },
  {
    id: 2048,
    name: "VAMSHADHARA PAPER MILLS LIMITED SKL044",
  },
  {
    id: 2049,
    name: "CHARISHMA HOTEL PVT LTD 1 MW",
  },
  {
    id: 2050,
    name: "MRF LIMITED (HTSC 1030)",
  },
  {
    id: 2051,
    name: "M/s Linde India Limited",
  },
  {
    id: 2052,
    name: "Clean Max Tav Pvt Ltd 2475",
  },
  {
    id: 2053,
    name: "Khivraj Tech Park Pvt Ltd HTSC 606",
  },
  {
    id: 2054,
    name: "Bunge India Private Limited HTSC-004",
  },
  {
    id: 2055,
    name: "Prima Products Pvt Ltd",
  },
  {
    id: 2056,
    name: "Shalimar Malls Private Limited",
  },
  {
    id: 2057,
    name: "L.S.SPINNING MILLS PRIVATE LIMITED",
  },
  {
    id: 2058,
    name: "POLYPACK INDUSTRIES",
  },
  {
    id: 2059,
    name: "East Central Railway DVC",
  },
  {
    id: 2060,
    name: "MAHAKAUSHAL SUGAR AND POWER INDUSTRIES LIMITED",
  },
  {
    id: 2061,
    name: "Rattha Holding Company Private Limited",
  },
  {
    id: 2062,
    name: "VIJAY MAHIENDRA SPINNTEX PRIVATE LIMITED",
  },
  {
    id: 2063,
    name: "BALAJI ENERGY PRIVATE LIMITED  NLR 2160",
  },
  {
    id: 2064,
    name: "E.I.D PARRRY (INDIA) LTD",
  },
  {
    id: 2065,
    name: "NTPC AURAIYA GPS LF",
  },
  {
    id: 2066,
    name: "Jubilant Infrastructure Limited",
  },
  {
    id: 2067,
    name: "Clean Max Deneb Power LLP 27",
  },
  {
    id: 2068,
    name: "IB VOGT SOLAR FOUR PRIVATE LIMITED",
  },
  {
    id: 2069,
    name: "BALASORE ALLOYS LIMITED",
  },
  {
    id: 2070,
    name: "Rangineni steel Pvt Ltd",
  },
  {
    id: 2071,
    name: "KRISHNAPOULTRY TEX MILL INDIA PRIVATE LIMITED",
  },
  {
    id: 2072,
    name: "PILKINGTON AUTOMOTIVE INDIA PRIVATE LIMITED",
  },
  {
    id: 2073,
    name: "SNJ BREWERIES PRIVATE LIMITED  HTSC 858",
  },
  {
    id: 2074,
    name: "VEL CASTINGS PRIVATE LIMITED",
  },
  {
    id: 2075,
    name: "Hariom Industries Limited",
  },
  {
    id: 2076,
    name: "Adani Power Limited - Tiroda TPP",
  },
  {
    id: 2077,
    name: "AMARJOTHI SPINNING MILLS LIMITED HTSC 036",
  },
  {
    id: 2078,
    name: "ELATE POLYTEX PRIVATE LIMITED",
  },
  {
    id: 2079,
    name: "Structural Insulation And Glazing Company Private Limited",
  },
  {
    id: 2080,
    name: "Kundan Hydro (Gangtok)Private Limited, Lower Lagyap (HEP)",
  },
  {
    id: 2081,
    name: "NTPC Kawas GPS_COMGAS",
  },
  {
    id: 2082,
    name: "Adani Power Limited - Kawai TPP",
  },
  {
    id: 2083,
    name: "UltraTechCementLtd RawanCementWorks",
  },
  {
    id: 2084,
    name: "Amarbhaw Power Private Limited",
  },
  {
    id: 2085,
    name: "SUNDARAM AUTO COMPONENTS LIMITED, HTSC No  122",
  },
  {
    id: 2086,
    name: "HATSUN AGRO PRODUCT LIMITED 0149",
  },
  {
    id: 2087,
    name: "Tube Investments of India Ltd, HTSC NO 099094100297",
  },
  {
    id: 2088,
    name: "SHREE AEKANYA STEELS LLP",
  },
  {
    id: 2089,
    name: "DEVASHREE ISPAT PRIVATE LIMITED RJN773",
  },
  {
    id: 2090,
    name: "KANTI BROTHERS OILS PRIVATE LIMITED (KNL738)",
  },
  {
    id: 2091,
    name: "V GUARD INDUSTRIES LIMITED HTSC-553",
  },
  {
    id: 2092,
    name: "LUCKYYARN TEX INDIA PRIVATE LIMITED (HT Sc - 558)",
  },
  {
    id: 2093,
    name: "Nirani Energy Private Limited Phase (6)",
  },
  {
    id: 2094,
    name: "Nirani Energy Private Limited Phase (5)",
  },
  {
    id: 2095,
    name: "GASHA STEELS PRIVATE LIMITED",
  },
  {
    id: 2096,
    name: "Disha Industries Private Limited",
  },
  {
    id: 2097,
    name: "Laxmi Rolling and Strips Private Limited",
  },
  {
    id: 2098,
    name: "DEVPRIYA INDUSTRIES PRIVATE LIMITED",
  },
  {
    id: 2099,
    name: "The Ugar Sugar Works Limited, Belagavi (Unit-1)",
  },
  {
    id: 2100,
    name: "Eicher Motors Limited(Unit Royal Enfield)",
  },
  {
    id: 2101,
    name: "Nandi Sahakari Sakkare Karkhane Niyamit",
  },
  {
    id: 2102,
    name: "Belgaum Sugars Private Limited",
  },
  {
    id: 2103,
    name: "Rajshree Sugars & Chemicals Ltd, Unit-1",
  },
  {
    id: 2104,
    name: "UNILEVER INDIA EXPORTS LIMITED",
  },
  {
    id: 2105,
    name: "BLUE RIDGE UNIT B TOWER 9 TO 14 CO OPERATIVE HOUSING SOCIETY LTD",
  },
  {
    id: 2106,
    name: "Phillips Carbon Black Ltd-Durgapur",
  },
  {
    id: 2107,
    name: "Adani Power Limited-Raipur TPP",
  },
  {
    id: 2108,
    name: "RENEW SANDUR GREEN ENERGY PRIVATE LIMITED WIND",
  },
  {
    id: 2109,
    name: "Uniparts India LTD",
  },
  {
    id: 2110,
    name: "SHIVASHAKTI SUGARS LIMITED",
  },
  {
    id: 2111,
    name: "Ranba Castings Limited HTSC-171",
  },
  {
    id: 2112,
    name: "SURESH SHARMA",
  },
  {
    id: 2113,
    name: "FREEWINGS POWER & INFRA LIMITED UNIT 2",
  },
  {
    id: 2114,
    name: "MANTORA OIL PRODUCTS PRIVATE LIMITED",
  },
  {
    id: 2115,
    name: "Devprayag paper mill private limited",
  },
  {
    id: 2116,
    name: "SAURASHTRA CEMENT LIMITED",
  },
  {
    id: 2117,
    name: "NEA Nepal Dordi Khola Hydropower Project",
  },
  {
    id: 2118,
    name: "Reliance Jio Infocomm Ltd",
  },
  {
    id: 2119,
    name: "SAA AB ENGINEERING PRIVATE LIMITED",
  },
  {
    id: 2120,
    name: "Dimo Castings Private Limited",
  },
  {
    id: 2121,
    name: "POWERCON CEMENT PRIVATE LIMITED",
  },
  {
    id: 2122,
    name: "Ultratech Cement Limited (Unit Sidhi Cement Works)",
  },
  {
    id: 2123,
    name: "RELIANCE INDUSTRIES LIMITED -ASOJ",
  },
  {
    id: 2124,
    name: "CESSNA GARDEN DEVELOPERS PRIVATE LIMITED-S7HT169",
  },
  {
    id: 2125,
    name: "CESSNA GARDEN DEVELOPERS PRIVATE LIMITED-S7HT170",
  },
  {
    id: 2126,
    name: "Coimbatore Polytex Pvt Ltd",
  },
  {
    id: 2127,
    name: "DALMIA CEMENT (BHARAT) LIMITED (RCW)",
  },
  {
    id: 2128,
    name: "Patel Shanti Steels Private Limited",
  },
  {
    id: 2129,
    name: "WELSPUN INDIA LIMITED",
  },
  {
    id: 2130,
    name: "CONTINENTAL CARBON ECO TECHNOLOGY PVT LTD CONS.NO.12145",
  },
  {
    id: 2131,
    name: "Clean Max Arnav Pvt Ltd 6.25 MW",
  },
  {
    id: 2132,
    name: "RITVIK STEEL PRIVATE LIMITED",
  },
  {
    id: 2133,
    name: "ANS PAPER MILLS PRIVATE LTD",
  },
  {
    id: 2134,
    name: "SRI MUNI PACHAIYAPPAN TEXILES PVT.LTD",
  },
  {
    id: 2135,
    name: "Jindal Power Limited, Stage-2",
  },
  {
    id: 2136,
    name: "Rongnichu HEP",
  },
  {
    id: 2137,
    name: "FPEL CELESTICAL PRIVATE LIMITED",
  },
  {
    id: 2138,
    name: "Ratnagiri Gas and Power Private Limited-LTRLNG",
  },
  {
    id: 2139,
    name: "AMAN ROLLING MILLS PRIVATE LIMITED",
  },
  {
    id: 2140,
    name: "MANSUKHMAL INVESTMENTS PRIVATE LIMITED",
  },
  {
    id: 2141,
    name: "Northern Railway-Haryana",
  },
  {
    id: 2142,
    name: "HL MANDO ANAND INDIA PRIVATE LIMITED",
  },
  {
    id: 2143,
    name: "RRD TEX PRIVATE LIMITED HTSC-0208",
  },
  {
    id: 2144,
    name: "The Tata Power Company Limited Haldia Division",
  },
  {
    id: 2145,
    name: "ORISSA SPONGE IRON AND STEEL LIMITED",
  },
  {
    id: 2146,
    name: "Ranganadi Hydro Power Station",
  },
  {
    id: 2147,
    name: "ARUMUGAM SPINNING MILLS PVT LTD HTSC 0136",
  },
  {
    id: 2148,
    name: "SRI SHANMUGAVEL MILLS PRIVATE LIMITED, HT SC 0310",
  },
  {
    id: 2149,
    name: "MSPL Ltd-3.80",
  },
  {
    id: 2150,
    name: "ULTRAMARINE & PIGMENTS LTD",
  },
  {
    id: 2151,
    name: "O2 RENEWABLE ENERGY V PRIVATE LIMITED MP-5",
  },
  {
    id: 2152,
    name: "J.K. FENNER (INDIA) LIMITED SGR034",
  },
  {
    id: 2153,
    name: "Kousthuba Spinners Pvt ltd HTSC-228",
  },
  {
    id: 2154,
    name: "FALCON MARINE EXPORTS LIMITED",
  },
  {
    id: 2155,
    name: "VODAFONE IDEA LIMITED - HTSC No.869",
  },
  {
    id: 2156,
    name: "Vodafone Idea Limited (Civil Lines, Meerut)",
  },
  {
    id: 2157,
    name: "Clean Max Theia Pvt Ltd",
  },
  {
    id: 2158,
    name: "KUNDAN HYDRO (GANGTOK) PRIVATE LIMITED.  Meyong Chu",
  },
  {
    id: 2159,
    name: "GTN Enterprises Limited",
  },
  {
    id: 2160,
    name: "L S Mills Limited (HT Sc-007)",
  },
  {
    id: 2161,
    name: "L S Mills Limited (HT Sc-021)",
  },
  {
    id: 2162,
    name: "L S Mills Limited (HT Sc-033)",
  },
  {
    id: 2163,
    name: "MSQ Steel Private Limited",
  },
  {
    id: 2164,
    name: "SHREE CEMENT LIMITED - SCL CSEB",
  },
  {
    id: 2165,
    name: "Gujarat Fluorochemicals Ltd Cons.No.63867",
  },
  {
    id: 2166,
    name: "ARS ENERGY PRIVATE LIMITED",
  },
  {
    id: 2167,
    name: "KRG TEXTILE MILLS PRIVATE LIMITED HTSC 570",
  },
  {
    id: 2168,
    name: "L D GOYAL STEELS PVT LTD BADA GAON",
  },
  {
    id: 2169,
    name: "THANUSH ISPAT PRIVATE LIMITED",
  },
  {
    id: 2170,
    name: "Canara PCC Poles",
  },
  {
    id: 2171,
    name: "NTPC JhanorGandhar GPS RLNG",
  },
  {
    id: 2172,
    name: "NTPC  Jhanor Gandhar GPS_COMGAS",
  },
  {
    id: 2173,
    name: "O2 RENEWABLE ENERGY V PRIVATE LIMITED MP-4",
  },
  {
    id: 2174,
    name: "Philips Carbon Black Ltd, Mundra",
  },
  {
    id: 2175,
    name: "Petronet MHB Ltd",
  },
  {
    id: 2176,
    name: "MONARCH PLAZA COMFORTS PVT LTD",
  },
  {
    id: 2177,
    name: "GREEN INFRA CLEAN WIND POWER LTD",
  },
  {
    id: 2178,
    name: "P M P Textiles Spinning Mills Ltd",
  },
  {
    id: 2179,
    name: "SANGAL INDUSTRIES PRIVATE LIMITED",
  },
  {
    id: 2180,
    name: "OSWIN WOOD PANELS PVT LTD, A.P",
  },
  {
    id: 2181,
    name: "PGP Glass Pvt Ltd-Kosamba",
  },
  {
    id: 2182,
    name: "Torrent Power 1147.5 Mw Sugen Ccpp Collective",
  },
  {
    id: 2183,
    name: "Odisha Cement Plant (A Unit of Shree Cement Limited)",
  },
  {
    id: 2184,
    name: "KANODIA CEM PRIVATE LIMITED",
  },
  {
    id: 2185,
    name: "Nahar Industrial Enterprises Limited unit nahar sugar",
  },
  {
    id: 2186,
    name: "SJLT TEXTILES PRIVATE LIMITED HTSC 0203",
  },
  {
    id: 2187,
    name: "The Ramco Cements Limited HT 0730",
  },
  {
    id: 2188,
    name: "OPG Power Generation Private Limited 230KV Unit 2",
  },
  {
    id: 2189,
    name: "OPG Power Generation Private Limited 230KV Unit 4",
  },
  {
    id: 2190,
    name: "OPG Power Generation Private Limited Unit 1",
  },
  {
    id: 2191,
    name: "CHOLA SPINNING MILLS PRIVATE LIMITED HTSC-0210",
  },
  {
    id: 2192,
    name: "Thenpandian Spinning Mills India Private Limted (HTsc - 062)",
  },
  {
    id: 2193,
    name: "SCHLOSS CHENNAI PRIVATE LIMITED",
  },
  {
    id: 2194,
    name: "INOX AIR PRODUCTS PRIVATE LIMITED HTSC 818",
  },
  {
    id: 2195,
    name: "LAURUS LABS LIMITED (VSP1267)",
  },
  {
    id: 2196,
    name: "LAURUS LABS LIMITED  VSP 1509",
  },
  {
    id: 2197,
    name: "Karnataka Renewable Energy Development Limited",
  },
  {
    id: 2198,
    name: "Clean Max Deneb Power LLP 4.05MW",
  },
  {
    id: 2199,
    name: "Renault Nissan Automotive India Pvt. Ltd HTSC 759",
  },
  {
    id: 2200,
    name: "M/s Deepak Nitrite Limited,Nandesari",
  },
  {
    id: 2201,
    name: "RAIN CII CARBON (VIZAG) LIMITED",
  },
  {
    id: 2202,
    name: "Indian Oil Corporation limited (HTSC NO.132)",
  },
  {
    id: 2203,
    name: "G.R. KRISHNA FERRO ALLOYS PRIVATE LIMITED",
  },
  {
    id: 2204,
    name: "THAKUR PRASAD SAO AND SONS PVT LTD UNIT IV",
  },
  {
    id: 2205,
    name: "SKS Power Generation Chhattisgarh Limited",
  },
  {
    id: 2206,
    name: "Adani Electricity Mumbai Limited",
  },
  {
    id: 2207,
    name: "ADITYA BIRLA RENEWABLES SOLAR LIMITED",
  },
  {
    id: 2208,
    name: "Sri Nanjundappa Construction",
  },
  {
    id: 2209,
    name: "EVEREADY SPINNING MILLS PRIVATE LIMITED HTSC-0104",
  },
  {
    id: 2210,
    name: "Hindustan Unilever Limited HT SC 323",
  },
  {
    id: 2211,
    name: "Nuvoco vistas corporation limited",
  },
  {
    id: 2212,
    name: "OSTRO KANNADA POWER PRIVATE  LIMITED",
  },
  {
    id: 2213,
    name: "SARMANGAL SYNTHETICS PRIVATE LIMITED HTSC-588",
  },
  {
    id: 2214,
    name: "Selvi Spinning Mill",
  },
  {
    id: 2215,
    name: "MANGALORE REFINERY AND PETROCHEMICALS LIMITED",
  },
  {
    id: 2216,
    name: "MANGALORE REFINERY AND PETROCHEMICALS LTD",
  },
  {
    id: 2217,
    name: "FP CYGNUS PRIVATE LIMITED",
  },
  {
    id: 2218,
    name: "RAMGAD MINERALS AND MINING LIMITED",
  },
  {
    id: 2219,
    name: "BLA POWER PRIVATE LIMITED",
  },
  {
    id: 2220,
    name: "BIDAR RUBBER AND RECLAIMS PRIVATE LIMITED",
  },
  {
    id: 2221,
    name: "SRI SHANMUGAVEL MILLS PRIVATE LIMITED HTSC 0306",
  },
  {
    id: 2222,
    name: "ELECTROSTEEL CASTINGS LIMITED HTSC 1142",
  },
  {
    id: 2223,
    name: "UMA MAHESWARI TEXTILES HTSC 646",
  },
  {
    id: 2224,
    name: "ORIENT BELL LIMITED II",
  },
  {
    id: 2225,
    name: "PCBL LIMITED",
  },
  {
    id: 2226,
    name: "MS GLOBAL INDIA AUTOMOTIVE PRIVATE LIMITED",
  },
  {
    id: 2227,
    name: "Pacific Development Corporation Limited (Business Park)",
  },
  {
    id: 2228,
    name: "SUNSURE SOLARPARK EIGHT PRIVATE LIMITED.",
  },
  {
    id: 2229,
    name: "CHERAN SPINNING MILLS PVT LTD",
  },
  {
    id: 2230,
    name: "FPEL MAX VOLTE SOLAR PRIVATE LIMITED",
  },
  {
    id: 2231,
    name: "LVS Power Private Limited",
  },
  {
    id: 2232,
    name: "Tadas Wind Energy Private Limited-Karnata",
  },
  {
    id: 2233,
    name: "ARTHANARI LOOM CENTRE TEXTILE PRIVATE LIMITED",
  },
  {
    id: 2234,
    name: "SARMANGAL SYNTHETICS (PRIVATE) LIMITED (HTSc-596)",
  },
  {
    id: 2235,
    name: "Mahindra and Mahindra Ltd HT-0739",
  },
  {
    id: 2236,
    name: "Reliance Industries limited Dahej",
  },
  {
    id: 2237,
    name: "Vodafone Idea Limited (Ashok Marg, Lucknow)",
  },
  {
    id: 2238,
    name: "INOX GREEN ENERGY SERVICES LIMITED",
  },
  {
    id: 2239,
    name: "GARRISON ENGINEER WEST BAREILLY",
  },
  {
    id: 2240,
    name: "D B Power Limited",
  },
  {
    id: 2241,
    name: "SRB BOARDS INDIA PRIVATE LIMITED",
  },
  {
    id: 2242,
    name: "RUNGTA MINES LIMITED FERRO ALLOYS DIVISION DHENKANALL",
  },
  {
    id: 2243,
    name: "Ultratech cement limited unit kotputli",
  },
  {
    id: 2244,
    name: "GRASIM INDUSTRIES LIMITED RJY1693",
  },
  {
    id: 2245,
    name: "SHILPA MEDICARE LIMITED",
  },
  {
    id: 2246,
    name: "THE INDIA CEMENTS LIMITED CHILAMKUR",
  },
  {
    id: 2247,
    name: "MS AGARWAL FOUNDRIES PRIVATE LIMITED NLR406",
  },
  {
    id: 2248,
    name: "NPCIL KAKRAPAR ATOMIC POWER STATION UNITS 3 & 4",
  },
  {
    id: 2249,
    name: "SHANTI GOPAL CONCAST LIMITED",
  },
  {
    id: 2250,
    name: "Jindal Steel & Power Ltd , DCPP",
  },
  {
    id: 2251,
    name: "PALLAVA TEXTILES PRIVATE LIMITED- PALSLDCD87",
  },
  {
    id: 2252,
    name: "GROWEL ENERGY COMPANY LIMITED",
  },
  {
    id: 2253,
    name: "HIRA ELECTRO SMELTERS LIMITED",
  },
  {
    id: 2254,
    name: "NEA Nepal Upper Chameliya Hydropower Project",
  },
  {
    id: 2255,
    name: "NEA Nepal Solu Khola (Dudhkoshi) Hydropower Project",
  },
  {
    id: 2256,
    name: "SUNDARAM ALLOYS LIMITED VSP1205",
  },
  {
    id: 2257,
    name: "NEA Nepal Upper Dordi A Hydropower Project",
  },
  {
    id: 2258,
    name: "HINDALCO INDUSTRIES LIMITED- HINSLDCD93",
  },
  {
    id: 2259,
    name: "MOHAN MUSHROOM FARMS",
  },
  {
    id: 2260,
    name: "Mangal Industries Ltd - ARGC",
  },
  {
    id: 2261,
    name: "TAGOOR CHEMICALS PRIVATE LIMITED",
  },
  {
    id: 2262,
    name: "AMARJOTHI SPINNING MILLS LIMITED(HTSC-157)",
  },
  {
    id: 2263,
    name: "HATSUN AGRO PRODUCT LIMITED - HTSC 1599",
  },
  {
    id: 2264,
    name: "SRI AMMAN TEXTILES",
  },
  {
    id: 2265,
    name: "MEGHALAYA CEMENTS LIMITED",
  },
  {
    id: 2266,
    name: "Sisecam Flat Glass India Pvt Ltd",
  },
  {
    id: 2267,
    name: "ADANI SOLAR ENERGY JAISALMER TWO PRIVATE LIMITED(Project-2)",
  },
  {
    id: 2268,
    name: "Apollo Metalex Private Limited",
  },
  {
    id: 2269,
    name: "ITC LIMITED-MNK06",
  },
  {
    id: 2270,
    name: "BHOLE BABA MILK FOOD INDUSTRIES LIMITED",
  },
  {
    id: 2271,
    name: "RENEW WIND ENERGY KARNATAKA PRIVATE LIMITED",
  },
  {
    id: 2272,
    name: "CHENNAI METRO RAIL LIMITED 2608",
  },
  {
    id: 2273,
    name: "SAMSUNG INDIA ELECTRONICS PRIVATE LIMITED",
  },
  {
    id: 2274,
    name: "SRINIVASAN CHARITABALE AND EDUCATIONAL TRUST",
  },
  {
    id: 2275,
    name: "Clean Max Taiyo Pvt Ltd 2.7 MW",
  },
  {
    id: 2276,
    name: "Coromandel International Limited",
  },
  {
    id: 2277,
    name: "Vidya Polymer Private Limited Unit: J-25A",
  },
  {
    id: 2278,
    name: "PAWAN IMPEX PRIVATE LIMITED",
  },
  {
    id: 2279,
    name: "Pare Hydro Power Station",
  },
  {
    id: 2280,
    name: "Hindustan Unilever Limited Haridwar",
  },
  {
    id: 2281,
    name: "Lakshmi Machine Works Limited HT SC 0368",
  },
  {
    id: 2282,
    name: "SRF Limited HTSC 0022",
  },
  {
    id: 2283,
    name: "Designco Export Private Limited",
  },
  {
    id: 2284,
    name: "THE GE MES GAILE STADIUM",
  },
  {
    id: 2285,
    name: "SREE RAJASEKAR SPINNING MILLS PRIVATE LTD",
  },
  {
    id: 2286,
    name: "BORGWARNER MORSE SYSTEMS INDIA PRIVATE LIMITED HTSC 0139",
  },
  {
    id: 2287,
    name: "North Central Railway Prayagraj",
  },
  {
    id: 2288,
    name: "BHARATSTEEL ROLLING MILLS",
  },
  {
    id: 2289,
    name: "Bongaigaon Thermal Power Station  NTPC",
  },
  {
    id: 2290,
    name: "ITC LIMITED-MNK09",
  },
  {
    id: 2291,
    name: "Ambizione Infrastructure Private Limited",
  },
  {
    id: 2292,
    name: "GOLDEN TOWER INFRATECH PRIVATE LIMITED",
  },
  {
    id: 2293,
    name: "Kopili Power Station NEEPCO",
  },
  {
    id: 2294,
    name: "NAHAR INDUSTRIAL ENTERPRISES LIMITED UNIT LALRU",
  },
  {
    id: 2295,
    name: "NAHAR INDUSTRIAL ENTERPRISES LIMITED (UNIT SAMBHAV SPINNING  MILLS)",
  },
  {
    id: 2296,
    name: "TATA ELECTRONICS PRIVATE LIMITED HT 0755",
  },
  {
    id: 2297,
    name: "Filatex India Limited",
  },
  {
    id: 2298,
    name: "MSP METALLICS LIMITED",
  },
  {
    id: 2299,
    name: "THE MADRAS SILKS INDIA PRIVATE LIMITED",
  },
  {
    id: 2300,
    name: "Purbanchal Timber Industries (A Division of Century Plyboards (I) ltd",
  },
  {
    id: 2301,
    name: "Sree Rengaraj Ispat Industries Private Limited HT 0556",
  },
  {
    id: 2302,
    name: "O2 RENEWABLE ENERGY V PRIVATE LIMITED MP-1",
  },
  {
    id: 2303,
    name: "M.S.E.W.(A DIVISION OF SAMVARDHANA MOTHERSON INT. LTD.)",
  },
  {
    id: 2304,
    name: "C V SPINNERS PRIVATE LIMITED HTSC 0179",
  },
  {
    id: 2305,
    name: "C V SPINNERS PRIVATE LIMITED HTSC 0458",
  },
  {
    id: 2306,
    name: "A A Energy Private Limited",
  },
  {
    id: 2307,
    name: "Adani Cement Industries Limited Cons.No.50360",
  },
  {
    id: 2308,
    name: "JSW STEEL LIMITED",
  },
  {
    id: 2309,
    name: "Eicher Motors Limited 1048",
  },
  {
    id: 2310,
    name: "TAGOOR LABORATORIES PRIVATE LIMITED",
  },
  {
    id: 2311,
    name: "SUNRISE CONCAST LIMITED",
  },
  {
    id: 2312,
    name: "NU VISTA LIMITED RISDA",
  },
  {
    id: 2313,
    name: "Brindavan Bottlers Pvt.Ltd. Barabanki Unit",
  },
  {
    id: 2314,
    name: "Greensignal Bio Pharma Private Limited HTSC 1828",
  },
  {
    id: 2315,
    name: "Greenergy Wind Corporation Private Limited",
  },
  {
    id: 2316,
    name: "HINDUSTAN PETROLEUM CORPORATION LIMITED (1.3 MW SPP)",
  },
  {
    id: 2317,
    name: "K M POWER PVT LTD UNIT 3",
  },
  {
    id: 2318,
    name: "VINDHYA SPINNING MILLS PRIVATE LIMITED",
  },
  {
    id: 2319,
    name: "NAVA BHARAT VENTURES LIMITED",
  },
  {
    id: 2320,
    name: "ITC Limited ITD Ranjangaon",
  },
  {
    id: 2321,
    name: "O2 RENEWABLE ENERGY V PRIVATE LIMITED MP-3",
  },
  {
    id: 2322,
    name: "ADANICONNEX PRIVATE LIMITED HTSC 1134",
  },
  {
    id: 2323,
    name: "PALANI VIJAY COTTSPIN PRIVATE LIMITED",
  },
  {
    id: 2324,
    name: "Y.S.R. SPINNING & WEAVING MILLS (P) LTD",
  },
  {
    id: 2325,
    name: "CRESCENT POWER LIMITED",
  },
  {
    id: 2326,
    name: "BR STEEL & POWER PRIVATE LIMITED",
  },
  {
    id: 2327,
    name: "ITC LIMITED-MNK03",
  },
  {
    id: 2328,
    name: "ITC LIMITED-MNK04",
  },
  {
    id: 2329,
    name: "ESCIENTIA ADVANCED SCIENCES PRIVATE LIMITED",
  },
  {
    id: 2330,
    name: "Capgemini Technology Services India Limited",
  },
  {
    id: 2331,
    name: "SLV Stone Crusher",
  },
  {
    id: 2332,
    name: "SUBABHALAJI SPINNING MILLS INDIA PRIVATE LIMITED-153",
  },
  {
    id: 2333,
    name: "Ankur Udhyog Limited - Steel Division",
  },
  {
    id: 2334,
    name: "DHARIWAL STU MH",
  },
  {
    id: 2335,
    name: "Renew Green (KAK-TWO) Private Limited- Wind",
  },
  {
    id: 2336,
    name: "V R Foundries HTSC-682",
  },
  {
    id: 2337,
    name: "Vayunandana Power Limited",
  },
  {
    id: 2338,
    name: "HERMES DISTILLERY PRIVATE LIMITED",
  },
  {
    id: 2339,
    name: "Jawaharlal Nehru Port Trust",
  },
  {
    id: 2340,
    name: "KARNATAKA RENEWABLE ENERGY DEVELOPMENT LIMITED PAVAGADA",
  },
  {
    id: 2341,
    name: "Vidya Polymer Private Limited unit: J-26",
  },
  {
    id: 2342,
    name: "Murugan Textiles (HT Sc - 255)",
  },
  {
    id: 2343,
    name: "Sunstar Precision Forge Limited",
  },
  {
    id: 2344,
    name: "Sigma Metal And Power Private Limited",
  },
  {
    id: 2345,
    name: "Reliance Industries Limited  Nagothane",
  },
  {
    id: 2346,
    name: "CROSSLAY REMEDIES LIMITED",
  },
  {
    id: 2347,
    name: "Berry Alloys Limited",
  },
  {
    id: 2348,
    name: "NSL RENEWABLE POWER PRIVATE LIMITED",
  },
  {
    id: 2349,
    name: "MURUGAN WEAVING MILLS HTSC 742",
  },
  {
    id: 2350,
    name: "FPEL UJWAL PRIVATE LIMITED",
  },
  {
    id: 2351,
    name: "ITC LIMITED HOSKOTE",
  },
  {
    id: 2352,
    name: "L K Power Corporation Limited",
  },
  {
    id: 2353,
    name: "KUNDAN HYDRO (GANGTOK) PRIVATE LIMITED,Rabom Chu HEP",
  },
  {
    id: 2354,
    name: "ANJANI PORTLAND CEMENT LIMITED",
  },
  {
    id: 2355,
    name: "KRUSHNA HESSIANS, A UNIT OF ELURU JUTE MILLS PRIVATE LIMITED",
  },
  {
    id: 2356,
    name: "ATUL SHARMA",
  },
  {
    id: 2357,
    name: "NTPC Faridabad GPS RLNG",
  },
  {
    id: 2358,
    name: "VED INDUSTRIES",
  },
  {
    id: 2359,
    name: "JINDAL POWER LIMITED",
  },
  {
    id: 2360,
    name: "RAJAMANE INDUSTRIES PRIVATE LIMITED",
  },
  {
    id: 2361,
    name: "Gomuki Spinning Mills Private Limited HTSC 0043",
  },
  {
    id: 2362,
    name: "Lucky Weavess India Private Limited",
  },
  {
    id: 2363,
    name: "SML RENEWABLE",
  },
  {
    id: 2364,
    name: "3F INDUSTRIES LIMITED",
  },
  {
    id: 2365,
    name: "RAJINIKANTH FOUNDATION",
  },
  {
    id: 2366,
    name: "GREEN INFRA SOLAR POWER PROJECTS LIMITED",
  },
  {
    id: 2367,
    name: "SJLT SPINNING MILLS PRIVATE LIMITED HTSC 0249",
  },
  {
    id: 2368,
    name: "SJLT TEXTILES PRIVATE LIMITED HTSC 241",
  },
  {
    id: 2369,
    name: "RENEW WIND ENERGY AP PRIVATE LIMITED",
  },
  {
    id: 2370,
    name: "RENEW WIND ENERGY AP PRIVATE LIMITED -8 MW",
  },
  {
    id: 2371,
    name: "Vidya Polymer Private Limited Unit-J-24",
  },
  {
    id: 2372,
    name: "Sainj HEP",
  },
  {
    id: 2373,
    name: "SSF Plastics India Private Limited HT SC 0220",
  },
  {
    id: 2374,
    name: "AKCT CIDAMBARAM COTTON MILL PRIVATE LTD",
  },
  {
    id: 2375,
    name: "TVS MOTOR COMPANY LIMITED",
  },
  {
    id: 2376,
    name: "ANDHRA ORGANICS LIMITED SKL247",
  },
  {
    id: 2377,
    name: "FERRO ALLOYS CORPORATION LTD(POWER PLANT)",
  },
  {
    id: 2378,
    name: "NIKITA PAPERS LIMITED",
  },
  {
    id: 2379,
    name: "VXL SYSTEMS (EMDK3-9)",
  },
  {
    id: 2380,
    name: "RSM AUTOKAST PRIVATE LIMITED",
  },
  {
    id: 2381,
    name: "Adyah Solar Energy Private Limited",
  },
  {
    id: 2382,
    name: "TORRENT SAURYA URJA 3 PVT LIMITED",
  },
  {
    id: 2383,
    name: "Saint-Gobain India Private Limited HTSC 499",
  },
  {
    id: 2384,
    name: "ALOK INDUSTRIES LIMITED SAYLI",
  },
  {
    id: 2385,
    name: "ADANI HAZIRA PORT LTD",
  },
  {
    id: 2386,
    name: "SIPANI FIBRES LIMITED",
  },
  {
    id: 2387,
    name: "LR Energy (Unit of Roop Ram Industries Pvt Ltd)",
  },
  {
    id: 2388,
    name: "Tamilnadu Coke & Power Pvt Ltd",
  },
  {
    id: 2389,
    name: "NOVAAIR TECHNOLOGIES PRIVATE LIMITED TPT2758TPT2758",
  },
  {
    id: 2390,
    name: "KALPANA SHARMA",
  },
  {
    id: 2391,
    name: "KAIRALI STEELS & ALLOYS PRIVATE LIMITED",
  },
  {
    id: 2392,
    name: "PALLAVA TEXTILES PRIVATE LIMITED(HT.SC.NO.407)",
  },
  {
    id: 2393,
    name: "Clean Max Arnav Pvt Ltd 2.7 MW WPP",
  },
  {
    id: 2394,
    name: "CHENNAI METRO RAIL LIMITED 0965",
  },
  {
    id: 2395,
    name: "Vodafone Idea Limited (Varuna Vihar Varanasi)",
  },
  {
    id: 2396,
    name: "O2 RENEWABLE ENERGY VIII PRIVATE LIMITED",
  },
  {
    id: 2397,
    name: "Lakshita Engineering Services/ Hadwant Singh",
  },
  {
    id: 2398,
    name: "DAUJI ISPAT PRIVATE LIMITED",
  },
  {
    id: 2399,
    name: "ENERSHELL ALLOYS AND STEEL PRIVATE LIMITED UNIT-II",
  },
  {
    id: 2400,
    name: "THREADS (INDIA) PRIVATE LIMITED",
  },
  {
    id: 2401,
    name: "NTPC SOLAPUR SOLAR PV Station",
  },
  {
    id: 2402,
    name: "VEDHA SPINNING MILLS PRIVATE LIMITED, HT SC : 0032",
  },
  {
    id: 2403,
    name: "VEDHA SPINNING MILLS PRIVATE LIMITED, HT SC 0495",
  },
  {
    id: 2404,
    name: "VXL SYSTEMS (EMDK3-8)",
  },
  {
    id: 2405,
    name: "Clean Max Balam Private Limited 3 3 MW",
  },
  {
    id: 2406,
    name: "SANTHOSH ENTERPRISES",
  },
  {
    id: 2407,
    name: "INDUSTRIAL AND BUILDING GLASS INDUSTRIES",
  },
  {
    id: 2408,
    name: "SJLT TEXTILES PRIVATE LIMITED HTSC 0474",
  },
  {
    id: 2409,
    name: "NTPC Farakka stage I",
  },
  {
    id: 2410,
    name: "Administrator PCMC",
  },
  {
    id: 2411,
    name: "Ultra Mega Power Private Limited.",
  },
  {
    id: 2412,
    name: "Adept Renewable Technologies Private Limited",
  },
  {
    id: 2413,
    name: "Clean Max Vega Power LLP 6 6 MW",
  },
  {
    id: 2414,
    name: "SFC SOLUTIONS INDIA (SEALING) PRIVATE LIMITED",
  },
  {
    id: 2415,
    name: "Winsome Textile Industries Ltd Unit-1",
  },
  {
    id: 2416,
    name: "Kawatra papers Private Limited",
  },
  {
    id: 2417,
    name: "MONDELEZ INDIA FOODS PRIVATE LIMITED",
  },
  {
    id: 2418,
    name: "MYTRAH VAYU (SOM) PRIVATE LIMITED",
  },
  {
    id: 2419,
    name: "NTPC Farakka stage III",
  },
  {
    id: 2420,
    name: "Transition Green Energy Private Limited",
  },
  {
    id: 2421,
    name: "NTPC Korba Stage I &II",
  },
  {
    id: 2422,
    name: "NTPC khargone",
  },
  {
    id: 2423,
    name: "SHRI SITA RAM GLASS WORKS",
  },
  {
    id: 2424,
    name: "GREENNSURE ENERGY PRIVATE LIMITED",
  },
  {
    id: 2425,
    name: "TORRENT SAURYA URJA 3 PRIVATE LIMITED",
  },
  {
    id: 2426,
    name: "Adhavan Steels Private Limited HT SC 0433",
  },
  {
    id: 2427,
    name: "SREE SIDDAGANGA MATH",
  },
  {
    id: 2428,
    name: "Greenko Sumez Hydro Energies Private Limited",
  },
  {
    id: 2429,
    name: "NTPC Vindhyachal Stage II",
  },
  {
    id: 2430,
    name: "RENEW GREEN KAK THREE PRIVATE LIMITED",
  },
  {
    id: 2431,
    name: "SURESH PRODUCTIONS PVT LTD",
  },
  {
    id: 2432,
    name: "VEDANTA LTD",
  },
  {
    id: 2433,
    name: "Wellknown Polyesters Ltd",
  },
  {
    id: 2434,
    name: "Nani Virani Wind Energy Private Limited",
  },
  {
    id: 2435,
    name: "KERALA STATE ELECTRICITY BOARD  LIMITED",
  },
  {
    id: 2436,
    name: "BIG CASTINGS PRIVATE LIMITED",
  },
  {
    id: 2437,
    name: "ITC Limited 6.3 MW SPP",
  },
  {
    id: 2438,
    name: "GEETA GLASS WORKS",
  },
  {
    id: 2439,
    name: "MEENAKSHI ENERGY LIMITED",
  },
  {
    id: 2440,
    name: "ENERGY DEVELOPMENT COMPANY LIMITED",
  },
  {
    id: 2441,
    name: "NTPC Gadarwara",
  },
  {
    id: 2442,
    name: "NTPC Solapur",
  },
  {
    id: 2443,
    name: "NTPC Mouda Stage I",
  },
  {
    id: 2444,
    name: "NTPC Mouda Stage II",
  },
  {
    id: 2445,
    name: "Sundram Fasteners Limited HTSC 82",
  },
  {
    id: 2446,
    name: "HATSUN AGRO PRODUCT LIMITED 0152",
  },
  {
    id: 2447,
    name: "MKAS TEXTILES PRIVATE LIMITED HTSC 0571",
  },
  {
    id: 2448,
    name: "MSPL LIMITED-3.80",
  },
  {
    id: 2449,
    name: "HEMAVATHY POWER & LIGHT PRIVATE LIMITED",
  },
  {
    id: 2450,
    name: "JAYAVARMA TEXTILES PRIVATE LIMITED HTSC 80",
  },
  {
    id: 2451,
    name: "WEST BENGAL STATE ELECTRICITY DISTRIBUTION COMPANY LIMITED",
  },
  {
    id: 2452,
    name: "AMPLUS SOLAR SHAKTI PRIVATE LIMITED",
  },
  {
    id: 2453,
    name: "PRANAV SHARMA, POLAYKALAN",
  },
  {
    id: 2454,
    name: "ADANI SOLAR ENERGY RJ TWO PRIVATE LIMITED(Phalodi)",
  },
  {
    id: 2455,
    name: "RENEW SURYA PRATAP PRIVATE LIMITED_Infirm",
  },
  {
    id: 2456,
    name: "NTPC Singrauli",
  },
  {
    id: 2457,
    name: "NEA Nepal Upper Balephi A Hydropower Project1",
  },
  {
    id: 2458,
    name: "THE CANARA LAND INVESTMENTS LIMITED",
  },
  {
    id: 2459,
    name: "MOHITE INDUSTRIES LIMITED",
  },
  {
    id: 2460,
    name: "FIROZABAD CERAMICS (P) LTD",
  },
  {
    id: 2461,
    name: "MITTAL CERAMICS",
  },
  {
    id: 2462,
    name: "ADANI RENEWABLE ENERGY FIFTY FIVE LIMITED_Infirm",
  },
  {
    id: 2463,
    name: "HATSUN AGRO PRODUCT LIMITED 0374",
  },
  {
    id: 2464,
    name: "VAIBHAV MERCANTILE LIMITED",
  },
  {
    id: 2465,
    name: "VENKATALAKSHMI PAPER AND BOARDS PRIVATE LIMITED HTSC 0184",
  },
  {
    id: 2466,
    name: "Noida Power Company limited",
  },
  {
    id: 2467,
    name: "PCBL (TN) Limited Unit 2 (Generator Unit)",
  },
  {
    id: 2468,
    name: "VIKI INDUSTRIES PRIVATE LIMITED",
  },
  {
    id: 2469,
    name: "SRI BASAVESHWARA RICE MILL 1",
  },
  {
    id: 2470,
    name: "SEIL Energy India Limited Project II",
  },
  {
    id: 2471,
    name: "BALDOTA STEEL AND POWER LIMITED 4.2MW WPP",
  },
  {
    id: 2472,
    name: "BEEMPOW ENERGY PRIVATE LIMITED_INFIRM",
  },
  {
    id: 2473,
    name: "SANGHI INDUSTRIES LIMITED",
  },
  {
    id: 2474,
    name: "ADANI WIND ENERGY KUTCHH FOUR Ltd. Nakhatrana",
  },
  {
    id: 2475,
    name: "ADANI WIND ENERGY KUTCHH FOUR Ltd. Nakhatrana (infirm)",
  },
  {
    id: 2476,
    name: "SIVASUBRAMANIA TEXTILES HTSC 0184",
  },
  {
    id: 2477,
    name: "Dhariwal ISTS",
  },
  {
    id: 2478,
    name: "ACC LIMITED-KAR",
  },
  {
    id: 2479,
    name: "O2Z TRADING & INDUSTRIES Private Limited",
  },
  {
    id: 2480,
    name: "RAAJCO SPINNERS PRIVATE LIMITED",
  },
  {
    id: 2481,
    name: "25 MW Solar Project Sakri",
  },
  {
    id: 2482,
    name: "GRAPHITE INDIA LIMITED",
  },
  {
    id: 2483,
    name: "DEVI SEA FOODS LIMITED UNIT II",
  },
  {
    id: 2484,
    name: "Rajshree Sugars & Chemicals Ltd, Unit-2, Mundiyampakkam",
  },
  {
    id: 2485,
    name: "GUJARAT STATE ENERGY GENERATION LIMITED",
  },
  {
    id: 2486,
    name: "UltraTech Cement Limited; Unit: Roorkee Cement Works",
  },
  {
    id: 2487,
    name: "NTPC Sipat Stage II",
  },
  {
    id: 2488,
    name: "AVAADA SUNSHINE ENERGY PRIVATE LIMITED_Infirm",
  },
  {
    id: 2489,
    name: "NTPC Simhadri Stage II",
  },
  {
    id: 2490,
    name: "TULSYAN NEC LIMITED HTSC 1823",
  },
  {
    id: 2491,
    name: "Nanal Hydropower Consultancy Pvt ltd",
  },
  {
    id: 2492,
    name: "Ambuja Cements Ltd, Marwar Mundwa (Nagaur)",
  },
  {
    id: 2493,
    name: "Ambuja Cements Limited, Ropar",
  },
  {
    id: 2494,
    name: "NEA - Bihar STU",
  },
  {
    id: 2495,
    name: "JSW RENEW ENERGY LIMITED INFIRM",
  },
  {
    id: 2496,
    name: "BRINDAVAN BEVERAGES PRIVATE LIMITED",
  },
  {
    id: 2497,
    name: "NTPC Vindhyachal Stage IV",
  },
  {
    id: 2498,
    name: "NTPC AURAIYA GPS",
  },
  {
    id: 2499,
    name: "NTPC ANTA GPS",
  },
  {
    id: 2500,
    name: "Gas Turbine Power Station Uran",
  },
  {
    id: 2501,
    name: "NABINAGAR POWER GENERATING COMPANY LIMITED",
  },
  {
    id: 2502,
    name: "JSW RENEW ENERGY LIMITED",
  },
  {
    id: 2503,
    name: "ESKO CASTING AND ELECTRONICS PRIVATE LIMITED",
  },
  {
    id: 2504,
    name: "VEEBEE YARNNTEX PRIVATE LIMITED HTSC 192",
  },
  {
    id: 2505,
    name: "Tata Power Renewable Energy Limited - Pavagada",
  },
  {
    id: 2506,
    name: "ASIAN FINE CEMENTS PRIVATE LIMITED",
  },
  {
    id: 2507,
    name: "AMBUJA CEMENTS LIMITED, BHATINDA",
  },
  {
    id: 2508,
    name: "JSW RENEW ENERGY TWO LIMITED INFIRM (KARUR)",
  },
  {
    id: 2509,
    name: "ULTRATECH CEMENT LIMITED (UNIT WEST BENGAL CEMENT WORKS)",
  },
  {
    id: 2510,
    name: "OKAY GLASS INDUSTRIES",
  },
  {
    id: 2511,
    name: "GSECL DGBPS 1",
  },
  {
    id: 2512,
    name: "GHCL TEXTILES LIMITED HTSC 248",
  },
  {
    id: 2513,
    name: "DB RENEWS PRIVATE LIMITED",
  },
  {
    id: 2514,
    name: "POPURI STEELS LIMITED",
  },
  {
    id: 2515,
    name: "GSECL DGBPS 2",
  },
  {
    id: 2516,
    name: "MANTORA SOLWENT DIVISION",
  },
  {
    id: 2517,
    name: "MANCHESTER TEXTILE PRIVATE LIMITED HTSC 375",
  },
  {
    id: 2518,
    name: "NAGAMMAL MILLS PRIVATE LIMITED HTSC 0002",
  },
  {
    id: 2519,
    name: "Clean Max Vega Power LLP",
  },
  {
    id: 2520,
    name: "SERUM INSTITUTE OF INDIA PRIVATE LIMITED",
  },
  {
    id: 2521,
    name: "NTPC Anta Solar",
  },
  {
    id: 2522,
    name: "SHRI SANGAM SAHAKARI SAKKARE KARKHANE NIYAMIT",
  },
  {
    id: 2523,
    name: "Siddhasiri Souharda Sahakari  Niyamit",
  },
  {
    id: 2524,
    name: "Ayana Renewable Power Six Private Limited",
  },
  {
    id: 2525,
    name: "LOREAL INDIA PRIVATE LIMITED,BADDI",
  },
  {
    id: 2526,
    name: "ESSAR POWER GUJARAT LIMITED",
  },
  {
    id: 2527,
    name: "SARDA ENERGY & MINERALS LIMITED",
  },
  {
    id: 2528,
    name: "NTPC Unchahar Stage II",
  },
  {
    id: 2529,
    name: "ALTILIUM VENTI PRIVATE LIMITED",
  },
  {
    id: 2530,
    name: "Gangdari Hydro Power Private Limited",
  },
  {
    id: 2531,
    name: "JAYAVARMA TEXTILES PRIVATE LIMITED HTSC 264",
  },
  {
    id: 2532,
    name: "GMR KAMALANGA ENERGY LTD-CTU",
  },
  {
    id: 2533,
    name: "ASIAAN METALS & ALUMINIUM CASTING PRIVATE LIMITED",
  },
  {
    id: 2534,
    name: "BDH INDUSTRIES LIMITED",
  },
  {
    id: 2535,
    name: "FARUKHI GLASS INDUSTRIES",
  },
  {
    id: 2536,
    name: "ANIRUDH FOODS LIMITED",
  },
  {
    id: 2537,
    name: "BHARATH WIND FARM LIMITED PHASE-1",
  },
  {
    id: 2538,
    name: "MASS NERGY PVT LTD",
  },
  {
    id: 2539,
    name: "SHREE SAKTHI VINAYAGAR WEAVES PRIVATE LIMITED HTSC 0535",
  },
  {
    id: 2540,
    name: "SUNSURE SOLARPARK FIVE PRIVATE LIMITED",
  },
  {
    id: 2541,
    name: "NLC INDIA LIMITED THERMAL POWER STATION II STAGE II",
  },
  {
    id: 2542,
    name: "Greenko Tejassarnika Hydro Energies Private Limited",
  },
  {
    id: 2543,
    name: "KAP CONES PRIVATE LIMITED",
  },
  {
    id: 2544,
    name: "C L GUPTA EXPORTS LIMITED",
  },
  {
    id: 2545,
    name: "TPCL_U7 RLNG",
  },
  {
    id: 2546,
    name: "RENEW SURYA OJAS PRIVATE LIMITED_INFIRM",
  },
  {
    id: 2547,
    name: "JEPPIAAR FURNACE AND STEELS PRIVATE LIMITED",
  },
  {
    id: 2548,
    name: "SREEDHARA TEXTILES PRIVATE  LIMITED HT SC 0500",
  },
  {
    id: 2549,
    name: "JSW STEEL LIMITED Cons.No.31505",
  },
  {
    id: 2550,
    name: "AD HYDRO POWER LIMITED",
  },
  {
    id: 2551,
    name: "KARTYA TEXTILES PRIVATE LIMITED HTSC 0495",
  },
  {
    id: 2552,
    name: "Clean Max Mirage Pvt Ltd 9 9 MW",
  },
  {
    id: 2553,
    name: "NTPC North Karanpura  STPS",
  },
  {
    id: 2554,
    name: "NTPC Darlipali",
  },
  {
    id: 2555,
    name: "SANVIRA INDUSTRIES LIMITED",
  },
  {
    id: 2556,
    name: "DGEN MEGA POWER PROJECT",
  },
  {
    id: 2557,
    name: "N K STONE CRUSHER",
  },
  {
    id: 2558,
    name: "Green Infra Wind Power Generation Limited",
  },
  {
    id: 2559,
    name: "MSPL LIMITED-1.90 MW",
  },
  {
    id: 2560,
    name: "SRI RATNALAKSHMI SPINNING MILLS PRIVATE LIMITED HTSC 0103",
  },
  {
    id: 2561,
    name: "AVAADA INDSOLAR PRIVATE LIMITED",
  },
  {
    id: 2562,
    name: "IBEX ENGINEERING PRIVATE LIMITED",
  },
  {
    id: 2563,
    name: "SJLT SPINNING MILLS PRIVATE LIMITED HTSC 0475",
  },
  {
    id: 2564,
    name: "NLC INDIA LIMITED THERMAL POWER STATION II EXPANSION",
  },
  {
    id: 2565,
    name: "ITC LIMITED-GARDENIA",
  },
  {
    id: 2566,
    name: "O2 Renewable Energy IV Private Limited 3 125 MW SPP",
  },
  {
    id: 2567,
    name: "KRSKA SOLAR PRIVATE LIMITED",
  },
  {
    id: 2568,
    name: "SIMCON SOLAR, SIRONJ 3.0 MW",
  },
  {
    id: 2569,
    name: "ASSAM GAS BASED POWER STATION",
  },
  {
    id: 2570,
    name: "EASTMAN INTERNATIONAL, IMLANI 5MW",
  },
  {
    id: 2571,
    name: "ACC- Madukkarai Cement Works",
  },
  {
    id: 2572,
    name: "ULTRATECH CEMENT LIMITED- ARAKKONAM CEMENT WORKS",
  },
  {
    id: 2573,
    name: "Northern Railway-Punjab",
  },
  {
    id: 2574,
    name: "NTPC Unchahar Stage I",
  },
  {
    id: 2575,
    name: "NTPC Unchahar Stage III",
  },
  {
    id: 2576,
    name: "NTPC DADRI GPS Spot RF",
  },
  {
    id: 2577,
    name: "NTPC AURAIYA  GPS RLNG",
  },
  {
    id: 2578,
    name: "NTPC DADRI GPS RLNG",
  },
  {
    id: 2579,
    name: "NTPC DADRI GAS POWER STATION",
  },
  {
    id: 2580,
    name: "Reliance Industries Ltd",
  },
  {
    id: 2581,
    name: "RISINGSUN POWER PRIVATE LIMITED",
  },
  {
    id: 2582,
    name: "A.R.S AGRO BUSINESS PVT LTD",
  },
  {
    id: 2583,
    name: "UTRAN GAS BASED POWER STATION",
  },
  {
    id: 2584,
    name: "GODAVARI GAS POWER PLANT",
  },
  {
    id: 2585,
    name: "NTPC BARH Stage II",
  },
  {
    id: 2586,
    name: "NTPC BARH Stage I",
  },
  {
    id: 2587,
    name: "KUSUMSHIVA ENERGY PROJECTS PRIVATE LIMITED",
  },
  {
    id: 2588,
    name: "VISHNU CHEMICALS LIMITED",
  },
  {
    id: 2589,
    name: "DHANALAKSHMI SYNTHETICS PRIVATE LIMITED",
  },
  {
    id: 2590,
    name: "RENEW SURYA ROSHNI PRIVATE LIMITED-Fatehgarh-III PS_Infirm",
  },
  {
    id: 2591,
    name: "IGSTPS JHAJJAR",
  },
  {
    id: 2592,
    name: "NTPC Dadri Stage II",
  },
  {
    id: 2593,
    name: "Ahuja And Anand Buildwell Private Limited",
  },
  {
    id: 2594,
    name: "KANTI BIJLEE UTPADAN NIGAM LIMITED",
  },
  {
    id: 2595,
    name: "BANSAL WIRE INDUSTRIES LIMITED B-35",
  },
  {
    id: 2596,
    name: "I T C  LIMITED SHERATON",
  },
  {
    id: 2597,
    name: "HPCL BIOFUELS LIMITED LAURIYA",
  },
  {
    id: 2598,
    name: "HPCL BIOFUELS  LIMITED SUGAULI",
  },
  {
    id: 2599,
    name: "NTPC Korba Stage III",
  },
  {
    id: 2600,
    name: "AGRAWAL SOLAR POWER VENTURES(RAJASTHAN) PRIVATE LIMITED-RRECL REGISTRATION NO. S/0158/2019",
  },
  {
    id: 2601,
    name: "Transition Energy Services Private Limited",
  },
  {
    id: 2602,
    name: "NTPC Kahalgaon stage I",
  },
  {
    id: 2603,
    name: "NIDP DEVELOPERS PRIVATE LIMITED",
  },
  {
    id: 2604,
    name: "KAYESS FLOUR MILLS PVT LTD",
  },
  {
    id: 2605,
    name: "Sorang HEP (Himachal Sorang Power Pvt. Ltd.))",
  },
  {
    id: 2606,
    name: "TULSYAN NEC LIMITED HTSC 1771",
  },
  {
    id: 2607,
    name: "SMT. ASHA PRABHAKAR KORE",
  },
  {
    id: 2608,
    name: "KARCHAM WANGTOO HYDRO ELECTRIC PLANT.",
  },
  {
    id: 2609,
    name: "NEELACHAL ISPAT NIGAM LIMITED",
  },
  {
    id: 2610,
    name: "MSPL LIMITED-2.85 MW",
  },
  {
    id: 2611,
    name: "Clean Max Balam Private Limited",
  },
  {
    id: 2612,
    name: "Ultra Tech Cement Ltd, Magdalla",
  },
  {
    id: 2613,
    name: "DRREDYSLABORATORIES LIMITED(FTO-11)",
  },
  {
    id: 2614,
    name: "NTPC Ramagundam Stage III",
  },
  {
    id: 2615,
    name: "NTPC Simhadri Stage I",
  },
  {
    id: 2616,
    name: "NTPC Ramagundam Stage I &II",
  },
  {
    id: 2617,
    name: "ADANI SOLAR ENERGY RJ TWO PRIVATE LIMITED (infirm)",
  },
  {
    id: 2618,
    name: "NTPC AURAIYA GPS Spot RF",
  },
  {
    id: 2619,
    name: "NTPC ANTA GPS  RLNG",
  },
  {
    id: 2620,
    name: "ACC LIMITED Kudithini",
  },
  {
    id: 2621,
    name: "NTPC Talcher Super Thermal Power Station Stage II",
  },
  {
    id: 2622,
    name: "Arthanari Loom Centre Textile Private Limited HTSC 0416",
  },
  {
    id: 2623,
    name: "GRINDWELL NORTON LTD TPT051",
  },
  {
    id: 2624,
    name: "Toray Industries(India) Private Limited",
  },
  {
    id: 2625,
    name: "Adani Green Energy Twenty Five A Limited_Infirm",
  },
  {
    id: 2626,
    name: "NEA Nepal Upper Kalangagad Hydropower Project",
  },
  {
    id: 2627,
    name: "RNS POWER LIMITED",
  },
  {
    id: 2628,
    name: "M/s Torrent Power 382.5 MW UNOSUGEN, Kamrej",
  },
  {
    id: 2629,
    name: "M/s Torrent Power 1147.5 Mw Sugen Ccpp, Kamrej",
  },
  {
    id: 2630,
    name: "MALABAR CEMENTS LIMITED(Cement Grinding Unit)",
  },
  {
    id: 2631,
    name: "INDIAN CANE POWER LIMITED UNIT ALGAWADI BIRESHWARA SUGARS",
  },
  {
    id: 2632,
    name: "VIVIN TEX  TEXTILE PROCESSING UNIT",
  },
  {
    id: 2633,
    name: "The Gowthami Solvent Oils Limited",
  },
  {
    id: 2634,
    name: "Paras Glass Ware Private Limited",
  },
  {
    id: 2635,
    name: "GOKUL METATECH PRIVATE LIMITED",
  },
  {
    id: 2636,
    name: "Transition Sustainable Energy Services Private Limited",
  },
  {
    id: 2637,
    name: "O2 Renewable Energy XVI Private Limited 18  MW SPP",
  },
  {
    id: 2638,
    name: "JINDAL POWER LIMITED SIMHAPURI",
  },
  {
    id: 2639,
    name: "SIDDHESH SURESH SHARMA,POLAYKALAN",
  },
  {
    id: 2640,
    name: "NTPC Lara Stage I",
  },
  {
    id: 2641,
    name: "Palmar Mills Private Limited",
  },
  {
    id: 2642,
    name: "Winsome Textile Industries Limited (Manuni 3.5 MW)",
  },
  {
    id: 2643,
    name: "JSW RENEW ENERGY TWO LIMITED",
  },
  {
    id: 2644,
    name: "RELIANCE INDUSTRIES LIMITED HOSHIARPUR",
  },
  {
    id: 2645,
    name: "ADANI RENEWABLE ENERGY HOLDING FOUR LIMITED",
  },
  {
    id: 2646,
    name: "Lanco Kondapalli Power Limited STG2",
  },
  {
    id: 2647,
    name: "NTECL VALLUR",
  },
  {
    id: 2648,
    name: "INDUS TMT INDUSTRIES LIMITED",
  },
  {
    id: 2649,
    name: "ARAMCO PAPERS PVT LTD",
  },
  {
    id: 2650,
    name: "JSW Steel Limited GOAR",
  },
  {
    id: 2651,
    name: "Ultratech Cement Ltd(UnitWanakbori Cement Works)",
  },
  {
    id: 2652,
    name: "Bagmane Clean Energy Private Limited",
  },
  {
    id: 2653,
    name: "NTPC Sipat Stage I",
  },
  {
    id: 2654,
    name: "Lloyds Metals And Energy Limited_Konsari",
  },
  {
    id: 2655,
    name: "M/s Air Liquide India Holding (P) Ltd Jhagadia",
  },
  {
    id: 2656,
    name: "AGARTALA GAS BASED POWER STATION",
  },
  {
    id: 2657,
    name: "Sundram Fasteners Limited HTSC 36",
  },
  {
    id: 2658,
    name: "MRF LIMITED (HTSC 1199)",
  },
  {
    id: 2659,
    name: "NTPC Telangana",
  },
  {
    id: 2660,
    name: "Amp Energy Green Six Private Limited",
  },
  {
    id: 2661,
    name: "RENEW SURYA ROSHNI PRIVATE LIMITED Koppal PS_Infirm",
  },
  {
    id: 2662,
    name: "RENEW SURYA ROSHNI PRIVATE LIMITED Koppal PS",
  },
  {
    id: 2663,
    name: "RPA FERRO INDUSTRIES PVT LTD",
  },
  {
    id: 2664,
    name: "BHARATH WIND FARM LIMITED PHASE-2",
  },
  {
    id: 2665,
    name: "ANS PAPER MILLS PRIVATE LIMITED 3MW Solar",
  },
  {
    id: 2666,
    name: "ULTRATECH CEMENT LIMITED- AP CEMENT WORKS",
  },
  {
    id: 2667,
    name: "NTPC Unchahar Stage IV",
  },
  {
    id: 2668,
    name: "RENEW SURYA OJAS PRIVATE LIMITED-Wind",
  },
  {
    id: 2669,
    name: "ITC LIMITED KAPURTHALA",
  },
  {
    id: 2670,
    name: "India Glycols Ltd (Kashipur)",
  },
  {
    id: 2671,
    name: "DAIMLER INDIA COMMERCIAL VEHICLES PRIVATE LIMITED HTSC 0866",
  },
  {
    id: 2672,
    name: "JSW Energy Limited-MH-Unit1",
  },
  {
    id: 2673,
    name: "Continuum MP Windfarm Development Private Limited",
  },
  {
    id: 2674,
    name: "Adani Green Energy Twenty Six B Limited_infirm",
  },
  {
    id: 2675,
    name: "NTPC Rihand stage II",
  },
  {
    id: 2676,
    name: "NTPC Rihand stage III",
  },
  {
    id: 2677,
    name: "Shree Sidhbali Steels Private Limited Unit II",
  },
  {
    id: 2678,
    name: "AMBUJA CEMENTS LIMITED - Roorkee",
  },
  {
    id: 2679,
    name: "Trombay Unit-8",
  },
  {
    id: 2680,
    name: "Clean Max Celeste Private Limited 4 95 MW",
  },
  {
    id: 2681,
    name: "ACC Limited, Tikaria Cement Works",
  },
  {
    id: 2682,
    name: "THENPANDIAN SPINNING MILLS INDIA PRIVATE LIMITED HTSC NO-422",
  },
  {
    id: 2683,
    name: "UTTAR PRADESH METRO RAIL CORPORATION LIMITED-KANPUR (CSA RSS)",
  },
  {
    id: 2684,
    name: "Malana II (Everest Power Private Limited)",
  },
  {
    id: 2685,
    name: "MINERA STEEL & POWER PRIVATE LIMITED",
  },
  {
    id: 2686,
    name: "VISWAS TEXTILES PROCESSORS",
  },
  {
    id: 2687,
    name: "YENKAYS ENGINEERING PRIVATE LIMITED",
  },
  {
    id: 2688,
    name: "NARUNRAKSHITH PRIVATE LIMITED",
  },
  {
    id: 2689,
    name: "Adani Green Energy Twenty Five B Limited_infirm",
  },
  {
    id: 2690,
    name: "MB POWER (MADHYA PRADESH) LIMITED",
  },
  {
    id: 2691,
    name: "TPSL Banderwala SECI 100_INF",
  },
  {
    id: 2692,
    name: "Trombay Unit-5",
  },
  {
    id: 2693,
    name: "PRAGATI CCPP",
  },
  {
    id: 2694,
    name: "SRAVANTHI ENERGY PRIVATE LIMITED",
  },
  {
    id: 2695,
    name: "MAHENDRA SPONGE AND POWER LIMITED (UNIT-II)",
  },
  {
    id: 2696,
    name: "GAS TURBINE POWER STATION (IPGCL) NEW DELHI",
  },
  {
    id: 2697,
    name: "GIRDHARI LAL MANOHAR LAL GLASS WORKS NO 2",
  },
  {
    id: 2698,
    name: "BPCL-KOCHI REFINERY",
  },
  {
    id: 2699,
    name: "SHV ENERGY PRIVATE LIMITED",
  },
  {
    id: 2700,
    name: "MAITHON POWER LIMITED",
  },
  {
    id: 2701,
    name: "GSPC Pipavav Power Company Limited",
  },
  {
    id: 2702,
    name: "SIKKA THERMAL POWER STATION",
  },
  {
    id: 2703,
    name: "Perstorp Industries India private limited Cons.No.12489",
  },
  {
    id: 2704,
    name: "NTPC ANTA  GPS Spot RF",
  },
  {
    id: 2705,
    name: "Shri Bajrang Chemical Distillery LLP",
  },
  {
    id: 2706,
    name: "Badami Sugars Limited.",
  },
  {
    id: 2707,
    name: "SREE RAYALASEEMA ALKALIES AND ALLIED CHEMICALS LIMITED",
  },
  {
    id: 2708,
    name: "SREE KAILAII SPINNERS PRIVATE LIMITED HTSC 0308",
  },
  {
    id: 2709,
    name: "NANDA CHEMICALS PRIVATE LIMITED NLR2048",
  },
  {
    id: 2710,
    name: "KUBAIR STEEL AND POWER LLP",
  },
  {
    id: 2711,
    name: "GOMATHI SPINNING MILLS INDIA PRIVATE LIMITED HTSC 210",
  },
  {
    id: 2712,
    name: "K G DENIM LIMITED",
  },
  {
    id: 2713,
    name: "SHRIE HARIVALLABI SPINNERS PRIVATE LIMITED HTSC 0515",
  },
  {
    id: 2714,
    name: "NTPC Kahalgaon stage II",
  },
  {
    id: 2715,
    name: "Rimjhim Ispat Limited (Erstwhile-BRG Iron & Steel Co (P) Ltd)",
  },
  {
    id: 2716,
    name: "SUDHESH INDUSTRIES PVT LTD UNIT III",
  },
  {
    id: 2717,
    name: "NLC INDIA LIMITED NEYVELI NEW THERMAL POWER STATION",
  },
  {
    id: 2718,
    name: "APOLLO TYRES LTD",
  },
  {
    id: 2719,
    name: "NTPC Vindhyachal Stage III",
  },
  {
    id: 2720,
    name: "GSECL DGBPS 3",
  },
  {
    id: 2721,
    name: "PRAGATI CCGT -III",
  },
  {
    id: 2722,
    name: "Budhil HEP (Greenko Budhil Hydro Power Pvt. Ltd.)",
  },
  {
    id: 2723,
    name: "MSPL LIMITED-5.30 MW",
  },
  {
    id: 2724,
    name: "AMP ENERGY C&I SIX PRIVATE LIMITED",
  },
  {
    id: 2725,
    name: "NLC INDIA LIMITED THERMAL POWER STATION I EXPANSION",
  },
  {
    id: 2726,
    name: "NTPC TANDA stg 1",
  },
  {
    id: 2727,
    name: "SUDHESH INDUSTRIES PVT LTD UNIT II",
  },
  {
    id: 2728,
    name: "MSPL LIMITED-3.75 MW",
  },
  {
    id: 2729,
    name: "MRF LIMITED (HTSC 81)",
  },
  {
    id: 2730,
    name: "AVON ENERGIES AND INVESTMENTS PRIVATE LIMITED, SIRONJ 10 MW",
  },
  {
    id: 2731,
    name: "NTPP BRBCL",
  },
  {
    id: 2732,
    name: "NTPC Rihand stage I",
  },
  {
    id: 2733,
    name: "NTPC Tanda Stage II",
  },
  {
    id: 2734,
    name: "JAANVI SPINNERS (P) LTD",
  },
  {
    id: 2735,
    name: "ACC Limited_Ametha",
  },
  {
    id: 2736,
    name: "BIRLA CARBON INDIA PRIVATE LIMITED-MH",
  },
  {
    id: 2737,
    name: "ADANI SOLAR ENERGY RJ TWO PRIVATE LIMITED",
  },
  {
    id: 2738,
    name: "TPSL 200MW TPTCL Banderwala",
  },
  {
    id: 2739,
    name: "AMP Energy Green Five Private Limited",
  },
  {
    id: 2740,
    name: "ATUL SHARMA (PHASE-II)",
  },
  {
    id: 2741,
    name: "Bihar State Power (Holding) Company Limited",
  },
  {
    id: 2742,
    name: "NTPC Vindhyachal Stage V",
  },
  {
    id: 2743,
    name: "NTPC BARAUNI stg2",
  },
  {
    id: 2744,
    name: "AMARA RAJA ENERGY & MOBILITY LIMITED (UNIT-01)",
  },
  {
    id: 2745,
    name: "Ramgad Minerals and Mining Limited-0.75 MW",
  },
  {
    id: 2746,
    name: "RENEW SURYA ROSHNI PRIVATE LIMITED-Fatehgarh-III PS",
  },
  {
    id: 2747,
    name: "manthri homes",
  },
  {
    id: 2748,
    name: "KESARI ROLLER FLOUR MILLS PRIVATE LIMITED 0.8 MW 1",
  },
  {
    id: 2749,
    name: "Ambuja Cements Ltd Cons.No.10215",
  },
  {
    id: 2750,
    name: "Mangal Industries Limited",
  },
  {
    id: 2751,
    name: "ITC Limited ITC Grand Bharat",
  },
  {
    id: 2752,
    name: "JSW ENERGY LIMITED-MH",
  },
  {
    id: 2753,
    name: "MAAMAHAMAYA ISPAT AND ALLOY PVT LTD (Chunar Unit)",
  },
  {
    id: 2754,
    name: "Green Infra Clean Wind Power Limited",
  },
  {
    id: 2755,
    name: "AMBA SHAKTI STEELS LIMITED",
  },
  {
    id: 2756,
    name: "GHCL TEXTILES LIMITED HTSC 194",
  },
  {
    id: 2757,
    name: "MEERA GLASS INDUSTRIES",
  },
  {
    id: 2758,
    name: "ULTRATECH CEMENT LIMITED (BAGA CEMENT WORKS)",
  },
  {
    id: 2759,
    name: "Ayana Renewable Power Three Private Limited",
  },
  {
    id: 2760,
    name: "PVSR STEEL AND POWER PRIVATE LIMITED",
  },
  {
    id: 2761,
    name: "Indan Energy Private Limited",
  },
  {
    id: 2762,
    name: "Sri Kumaraswamy Mineral Export Private Limited",
  },
  {
    id: 2763,
    name: "NTPC Talcher Stage I",
  },
  {
    id: 2764,
    name: "Serentica Renewables India 4 Private Limited",
  },
  {
    id: 2765,
    name: "MAXWELL AUTO COMPONENTS PRIVATE LIMITED HTSC 0669",
  },
  {
    id: 2766,
    name: "SUNSURE SOLARPARK TEN PRIVATE LIMITED",
  },
  {
    id: 2767,
    name: "MAAMAHAMAYA ISPAT & ALLOYS PRIVATE LIMITED(DHAUHA UNIT)",
  },
  {
    id: 2768,
    name: "ALTRA XERGI POWER PRIVATE LIMITED",
  },
  {
    id: 2769,
    name: "RENEW SURYA PRATAP PRIVATE LIMITED",
  },
  {
    id: 2770,
    name: "S K Steel Tech Private Limited",
  },
  {
    id: 2771,
    name: "SRI VELA SMELTERS PRIVATE LIMITED HTSC 0231",
  },
  {
    id: 2772,
    name: "KESARI ROLLER FLOUR MILLS PRIVATE LIMITED",
  },
  {
    id: 2773,
    name: "KAYNES TECHNOLOGY INDIA LIMITED",
  },
  {
    id: 2774,
    name: "Amplus Ages Private Limited",
  },
  {
    id: 2775,
    name: "IND BARATH ENERGY UTKAL LIMITED",
  },
  {
    id: 2776,
    name: "SEIL Energy India Limited - Project 2 (Unit-2 STU)",
  },
  {
    id: 2777,
    name: "IH CASTINGS PRIVATE LIMITED",
  },
  {
    id: 2778,
    name: "NTPC KUDGI",
  },
  {
    id: 2779,
    name: "VENKATALAKSHMI PAPER AND BOARDS PRIVATE LIMITED HTSC 0053",
  },
  {
    id: 2781,
    name: "NEA - UP STU",
  },
  {
    id: 2782,
    name: "ACC LIMITED WADI",
  },
  {
    id: 2783,
    name: "AMARA RAJA ENERGY & MOBILITY LIMITED (UNIT-02)",
  },
  {
    id: 2784,
    name: "SAGAR GRANDHI EXPORTS PRIVATE LIMITED",
  },
  {
    id: 2785,
    name: "MALANA POWER COMPANY LIMITED",
  },
  {
    id: 2786,
    name: "MSPL LIMITED-6.25 MW",
  },
  {
    id: 2787,
    name: "NLC INDIA LIMITED THERMAL POWER STATION II STAGE I",
  },
  {
    id: 2788,
    name: "Madura Industrial Textiles Ltd",
  },
  {
    id: 2789,
    name: "Agrocel Industries Pvt Ltd Cons.No.31607",
  },
  {
    id: 2790,
    name: "ADANI GREEN ENERGY TWENTY SIX A LIMITED_infirm",
  },
  {
    id: 2791,
    name: "Matrix Sunpower Private Limited",
  },
  {
    id: 2792,
    name: "GOMUKI SPINNING MILLS PRIVATE LIMITED HTSC 0553",
  },
  {
    id: 2793,
    name: "Clean Max Uranus Pvt Ltd 9 9 MW",
  },
  {
    id: 2794,
    name: "JAI HIND ROLLING MILLS INDIA PRIVATE LIMITED",
  },
  {
    id: 2795,
    name: "RENEW SURYA AAYAN PRIVATE LIMITED",
  },
  {
    id: 2796,
    name: "RENEW SURYA VIHAAN PRIVATE LIMITED",
  },
  {
    id: 2797,
    name: "ULTRATECH CEMENT LIMITED- ULTSLDCD47",
  },
  {
    id: 2798,
    name: "Grian Energy Private Limited",
  },
  {
    id: 2799,
    name: "Onevolt Energy Private Limited",
  },
  {
    id: 3012,
    name: "APTRANSCO",
  },
  {
    id: 3013,
    name: "Assam Ben",
  },
  {
    id: 3014,
    name: "BSPHCL",
  },
  {
    id: 3015,
    name: "CSEB Beneficiary",
  },
  {
    id: 3016,
    name: "DELHI",
  },
  {
    id: 3017,
    name: "DNHDDPDCL",
  },
  {
    id: 3018,
    name: "DVC",
  },
  {
    id: 3019,
    name: "GEB Beneficiary",
  },
  {
    id: 3020,
    name: "GOA Beneficiary",
  },
  {
    id: 3021,
    name: "GOA SR",
  },
  {
    id: 3022,
    name: "HARYANA",
  },
  {
    id: 3023,
    name: "HP",
  },
  {
    id: 3024,
    name: "JHARKHAND",
  },
  {
    id: 3025,
    name: "JK&LADAKH",
  },
  {
    id: 3026,
    name: "KPTCL",
  },
  {
    id: 3027,
    name: "KSEB",
  },
  {
    id: 3028,
    name: "MPSEB Beneficiary",
  },
  {
    id: 3029,
    name: "MSEB Beneficiary",
  },
  {
    id: 3030,
    name: "Meghalaya Ben",
  },
  {
    id: 3031,
    name: "Nagaland Ben",
  },
  {
    id: 3032,
    name: "ODISHA",
  },
  {
    id: 3033,
    name: "PUNJAB",
  },
  {
    id: 3034,
    name: "RAJASTHAN",
  },
  {
    id: 3035,
    name: "SIKKIM",
  },
  {
    id: 3036,
    name: "TNEB",
  },
  {
    id: 3037,
    name: "TSTRANSCO",
  },
  {
    id: 3038,
    name: "Tripura Ben",
  },
  {
    id: 3039,
    name: "UPPCL",
  },
  {
    id: 3040,
    name: "UTTARAKHAND",
  },
  {
    id: 3041,
    name: "WBSETCL",
  },
  {
    id: 3042,
    name: "Arunachal Ben",
  },
  {
    id: 3043,
    name: "Manipur Ben",
  },
  {
    id: 3044,
    name: "PONDY",
  },
  {
    id: 3045,
    name: "CHANDIGARH",
  },
  {
    id: 3046,
    name: "DD Beneficiary",
  },
  {
    id: 3047,
    name: "DNH Beneficiary",
  },
  {
    id: 3048,
    name: "Mizoram Ben",
  },
  {
    id: 3049,
    name: "ASEJOPL W FTG2",
  },
  {
    id: 3050,
    name: "ASEJOPL S FTG2",
  },
  {
    id: 3051,
    name: "ESSARMPL",
  },
  {
    id: 3052,
    name: "RGPPL MSEB",
  },
  {
    id: 3053,
    name: "RSEJ3PL FTG2",
  },
  {
    id: 3054,
    name: "RSUPL FTG2",
  },
  {
    id: 3055,
    name: "APL Stage 3",
  },
  {
    id: 3056,
    name: "AHEJ2L SOLAR",
  },
  {
    id: 3057,
    name: "AHEJ3L SOLAR",
  },
  {
    id: 3058,
    name: "AHEJOL SOLAR",
  },
  {
    id: 3059,
    name: "AHEJ4L SOLAR",
  },
  {
    id: 3060,
    name: "AP41PL BHDL",
  },
  {
    id: 3061,
    name: "RGPPL OTHERS",
  },
  {
    id: 3062,
    name: "BARHinfirm",
  },
  {
    id: 3063,
    name: "RGPPL IR",
  },
  {
    id: 3064,
    name: "KAPS Unit 4",
  },
  {
    id: 3066,
    name: "ARP1PL BKN",
  },
  {
    id: 3067,
    name: "AP43PL BKN",
  },
];
